import * as types from '../constants/activityConstants';
import config from './../config.js';
import appConstants from '../appConstants';
import moment from 'moment';
import numeral from 'numeral';
import ArrayStore from "devextreme/data/array_store";

let workingOrders = []

const initialState = {
  activityLog: [],
  ordcnfrmsg: {},
  dealcnfrmsg: {},
  bmOrdcnfrmsg: {},
  tradeBook: {
    tradeBookArray: [],
    randomNo: 0,
  },
  swapBook: { swapBookArray: [], randomNo: 0 },
  allspotTrades: [],
  allSwapTrades: [],
  cancelledBm: [],
  filledBm: [],
  cancelledLm: [],
  filledLm: [],
  benmFillObj: [],
  lmtFillModExpObj: [],
  benchMrkBook: {
    outStanBencMrkOrd: { outStanBencMrkArray: [], randomNo: 0 },
    benchMrkMap: null,
    bmCancelledOrdersRows: { bmCancelledOrdArray: [], randomNo: 0 },
    bmFillOrdersRows: { bmFillOrderArray: [], randomNo: 0 },
    bmOrderRows: [],
    randomNo: 0,
    outstandingBm: []
  },
  limitOrdBook: {
    outstandingLm: { outstandingLmArr: [], randomNo: 0 },
    limitOrdMap: null,
    lmCancellOrd: { lmCancellOrdArr: [], randomNo: 0 },
    lmFillOrd: { lmFillOrdArr: [], randomNo: 0 },
    lmExpOrd: { lmExpOrdArr: [], randomNo: 0 },
    suspendedOrders: { suspendedOrdArr: [], randomNo: 0 },
    lmtOrdersRows: [],
    randomNo: 0,
    randomNopro: 0
  },
  requestRejectModal: {
    mdflag: false,
    title: "",
    msg: "",
    CTID: ""
  },
  randomNoDB: 0,
  LoadFlag: true,
  ordersCTID: [],
  trdCTID: null,
  dealFlag: false,
  invalidBmFlag: false,
  clearNotifyFlag: false,
  notificationCount: 0,
  payReqRejectModal: {
    mdflag: false,
    title: "",
    msg: "",
    docNo: ""
  },
  limitOrdFlag: false,
  bmkOrdFlag: false,
  stopOrdFlag: false,
  avgBMKData: [],
  isavgBMKDataUpdated: false,
  avgBMKDrilldownData: [],
  selectedAllOrders: [],
  selectedWorkingOrders: [],
  selectedFilledOrders: [],
  selectedExpiredOrders: [],
  selectedCancelledOrders: [],
  noSelectedOrders: false,
  avgBMKDrilldownData: [],
  randomNoVD:0,
  subscribedObj: null,

};
const getOutstandingorderBM = (orderBm, benchMrkBook) => {
  try {
      var outstandingBMArray = [];
      var tempBMOrderArr = [];
      var temMap = new Map();
      orderBm.map((order) => {
    //  const user = JSON.parse(localStorage.getItem('user'));
      var item = Object.assign([], JSON.parse(localStorage.getItem(order.IID)));
      var SPR = (order.isSPRSelected ? order.SPR : parseFloat(order.SPR) * (-1));
      SPR = (" $ " + (Number(parseFloat(SPR)).toLocaleString('en', { minimumFractionDigits: item.pMinDec, maximumFractionDigits: item.pDec })));
      var SPRPER = ''
      if (order.SPRPER && (parseFloat(order.SPRPER) !== 0)) {
        SPRPER = (Number(parseFloat(order.SPRPER)).toLocaleString('en', { minimumFractionDigits: config.roundOff, maximumFractionDigits: config.roundOff })) + " % | "
      }
      let spreadVal = ''
      if (order.SCT === 'PHY') {
        spreadVal = getSpreadValueForPCS(order.PRMTYPE, order.PRMRATE)
      } else {
        spreadVal = SPRPER + '' + SPR
      }
     // const TID = user.name;
      var obj = {
        'id': order.id ? order.id : order.CLID,
        'eventTime': moment.utc(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
        'benchmark': order.BMD,
        'time': order.BEMT,
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'cmdtyPair': order.SD,
        'quantity':  (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0"),
        'orderNo': order.DN,
        'traderCode': order.LM,//TID,
        'accDescription': order.AD,
        'accCode': order.AC,
        'comments': order.RMK,
        'selected': false,
        'cmdtyId': order.IID,
        'FD': moment(order.FD).format('YYYY-MM-DD'),
        'TD': moment(order.TD).format('YYYY-MM-DD'),
        'REPEAT': order.ISSETREP ? order.ISSETREP : false,
        'fixingDate': moment(order.DD).format(appConstants.rptDateFormat),
        'valDate': handleONBValueDate(order),//item.VD === moment(order.VD).format(appConstants.paymentDateFormat)? "Spot" : moment(order.VD).format(appConstants.shortDateFormat),
        'spreadVal':spreadVal,
        'forwardVal': parseFloat(order.FWD).toFixed(config.roundOff),
        'SPR': (order.isSPRSelected ? parseFloat(order.SPR) : parseFloat(order.SPR) * (-1)),
        'SPRPER': parseFloat(order.SPRPER),
        'isSPRSelected': order.isSPRSelected,
        'orderType': order.D,
        'SCT': order.SCT,
        'stockCode': order.OSC,
        'eqOz': parseFloat(order.GQ).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff,maximumFractionDigits: config.QuantityRoundOff }),//parseFloat((order.GQ).toFixed(config.QuantityRoundOff))
        'fwdVD' : moment(order.VD).format(appConstants.rptDateFormat),
        'tenor' : order.TENOR,
        'fwdPerc' : order.FWDPER,
        'isSNEXrmk': order.isSNEXrmk,
        'isVDSelected' : order.isVDSelected ? order.isVDSelected : false
      };
      var obj1 = {
        'id': order.id ? order.id : order.CLID,
        'eventTime': moment.utc(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
        'benchmark': order.BMD,
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'cmdtyPair': order.SD,
        'quantity': (order.PQ ? convertToFloat(order.PQ) : "0"),
        'orderNo': order.DN,
        'traderCode': order.LM,
        'accCode': order.AC,
        'accDescription': order.AD,
        'comments': order.RMK,
        'DRMK': order.DRMK,
        'OR': order.P,
        'OSC': order.OSC,
        'OMC': parseInt(order.OMC) + 1,
        'CTID': '',
        'cmdtyId': order.IID,
        'FD': moment(order.FD).format('YYYY-MM-DD'),
        'TD': moment(order.TD).format('YYYY-MM-DD'),
        'REPEAT': order.ISSETREP ? order.ISSETREP : false,
        'DD': moment(order.DD).format('YYYY-MM-DD'),
        'orderType': order.D,
        'SCT': order.SCT,
        'stockCode': order.OSC,
        'eqOz': parseFloat((order.GQ).toFixed(config.QuantityRoundOff)),
        'fwdVD' : moment(order.VD).format(appConstants.rptDateFormat),
        'tenor' : order.TENOR,
        'fwdPerc' : order.FWDPER,
        'isSNEXrmk': order.isSNEXrmk,
        'isVDSelected' : order.isVDSelected ? order.isVDSelected : false
        // 'valDate': moment(order.VD).format(appConstants.shortDateFormat),
      };
      var obj2 = {
        'id': order.id ? order.id : order.CLID,
        'eventTime': moment.utc(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
        'status': 'Working',
        'benchmark': order.BMD,
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'pair': order.SD,
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0"),
        'orderNo': order.DN,
        'docNo': '',
        'rate': '',
        'accDescription': order.AD,
        'comments': order.RMK,
        'selected': false,
        'cmdtyId': order.IID,
        'FD': moment(order.FD).format('YYYY-MM-DD'),
        'TD': moment(order.TD).format('YYYY-MM-DD'),
        'REPEAT': order.ISSETREP ? order.ISSETREP : false,
        'orderType': order.D,
        'SCT': order.SCT,
        'stockCode': order.OSC,
        'eqOz':  parseFloat(order.GQ).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff,maximumFractionDigits:config.QuantityRoundOff }),
        // 'valDate': moment(order.VD).format(appConstants.shortDateFormat)
        'fwdVD' : moment(order.VD).format(appConstants.rptDateFormat),
        'tenor' : order.TENOR,
        'fwdPerc' : order.FWDPER,
        'isSNEXrmk': order.isSNEXrmk
           };
      tempBMOrderArr.push(obj2);
      outstandingBMArray.push(obj);
      temMap.set(order.DN, obj1);
    });
    benchMrkBook.outStanBencMrkOrd.outStanBencMrkArray = outstandingBMArray;
    benchMrkBook.outStanBencMrkOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    benchMrkBook.benchMrkMap = temMap;
    benchMrkBook.bmOrderRows = tempBMOrderArr;
    return outstandingBMArray;
  } catch (e) {
    console.log(" exception " + e);
  }
}

const getProximity=(order,cmdtyDet)=>{
  let proximity = 0;
  switch (parseFloat(order.OT)) {
    case appConstants.LMT_ORD_TYPE: 
      if (order.DT) {
        proximity = (parseFloat(order.P) - parseFloat(cmdtyDet.ask)) / (parseFloat(cmdtyDet.ask)) * 100 * -1;
      } else {
        proximity = (parseFloat(order.P) - parseFloat(cmdtyDet.bid)) / (parseFloat(cmdtyDet.bid)) * 100;
      }
      return proximity;

    case appConstants.STOP_ORD_TYPE:
      if (order.DT) {
        proximity = (parseFloat(order.P) - parseFloat(cmdtyDet.bid)) / (parseFloat(cmdtyDet.bid)) * 100;
      } else {
        proximity = (parseFloat(order.P) - parseFloat(cmdtyDet.ask)) / (parseFloat(cmdtyDet.ask)) * 100 * -1;
      }
      return proximity;
    case (appConstants.OCO_ORD_TYPE || appConstants.OTO_ORD_TYPE):
      if (parseFloat(order.DOT) === appConstants.STOP_ORD_TYPE) {
        if (order.DT) {
          proximity = (parseFloat(order.P) - parseFloat(cmdtyDet.bid)) / (parseFloat(cmdtyDet.bid)) * 100;
        } else {
          proximity = (parseFloat(order.P) - parseFloat(cmdtyDet.ask)) / (parseFloat(cmdtyDet.ask)) * 100 * -1;
        }
      } else {
        if (order.DT) {
          proximity = (parseFloat(order.P) - parseFloat(cmdtyDet.ask)) / (parseFloat(cmdtyDet.ask)) * 100 * -1;
        } else {
          proximity = (parseFloat(order.P) - parseFloat(cmdtyDet.bid)) / (parseFloat(cmdtyDet.bid)) * 100;
        }
      }
      return proximity;  
}
}

const handleValueDate = (order) => {
  let valueDate = 'Spot';
  if (order.isVDSelected) {
    valueDate = moment(order.VD).format(appConstants.shortDateFormat);
    const tradingDate = moment(new Date()).format(appConstants.shortDateFormat);
    if (moment(valueDate).isBefore(tradingDate)) {
      valueDate = 'Spot';
    }
  } else {
    valueDate = 'Spot';
  }
  return valueDate;
}
//handle value date for BMK
const handleONBValueDate = (order) => {
  let valueDate = 'Spot';
  if (order.isVDSelected) {
    valueDate = moment(order.VD).format(appConstants.shortDateFormat);
    const fixingDate = moment(order.FD).format(appConstants.shortDateFormat);
    if (moment(valueDate).isBefore(fixingDate)) {
      valueDate = 'Spot';
    }
  } else {
    valueDate = 'Spot';
  }
  return valueDate;
}

const convertToFloat = (value, roundOff = config.QuantityRoundOff) => 
    parseFloat(parseFloat(value).toFixed(roundOff))

const getOutstandingorderLMT = (orderLmt, limitOrdBook) => {
  try {
    var outstandinLMTArray = [];
    var lmtOrdArr = [];
    var temMap = new Map();
    orderLmt.map((order) => {
      const user = JSON.parse(localStorage.getItem('user'));
      var dec = getDecimal(order.IID);
      var minDec=getMinDecimal(order.IID)
      var item1 = Object.assign([], JSON.parse(localStorage.getItem(order.IID)));
      let proximity = 0;
      let dealType = `${order.ISOTO ? 'OTO ' : ''}Limit`;
    // to handle (L) for only working orders
      let LoopDealType = `${order.ISOTO ? 'OTO ' : ''}Limit`;
      let ordProximity=getProximity(order,item1);
      switch (parseFloat(order.OT)) {
        case appConstants.LMT_ORD_TYPE: 
          dealType = `${order.ISOTO ? 'OTO ' : ''}Limit`;
          LoopDealType = `${order.ISOTO ? 'OTO ' : ''}Limit${order.isLoopOTO ? ' (L)' : ''}`;
          if (order.DT) {
            proximity = (parseFloat(order.P) - parseFloat(item1.ask)) / (parseFloat(item1.ask)) * 100 * -1;
          } else {
            proximity = (parseFloat(order.P) - parseFloat(item1.bid)) / (parseFloat(item1.bid)) * 100;
          }
          break;
        case appConstants.STOP_ORD_TYPE:
          dealType = `${order.ISOTO ? 'OTO ' : ''}Stop`;
          LoopDealType = `${order.ISOTO ? 'OTO ' : ''}Stop${order.isLoopOTO ? ' (L)' : ''}`;
          if (order.DT) {
            proximity = (parseFloat(order.P) - parseFloat(item1.bid)) / (parseFloat(item1.bid)) * 100;
          } else {
            proximity = (parseFloat(order.P) - parseFloat(item1.ask)) / (parseFloat(item1.ask)) * 100 * -1;
          }
          break;
        case appConstants.OCO_ORD_TYPE:
          if (parseFloat(order.DOT) === appConstants.STOP_ORD_TYPE) {
            dealType = `${order.ISOTO ? 'OTO ' : ''}OCO Stop`;
            if (order.DT) {
              proximity = (parseFloat(order.P) - parseFloat(item1.bid)) / (parseFloat(item1.bid)) * 100;
            } else {
              proximity = (parseFloat(order.P) - parseFloat(item1.ask)) / (parseFloat(item1.ask)) * 100 * -1;
            }
          } else {
            dealType = `${order.ISOTO ? 'OTO ' : ''}OCO Limit`;
            if (order.DT) {
              proximity = (parseFloat(order.P) - parseFloat(item1.ask)) / (parseFloat(item1.ask)) * 100 * -1;
            } else {
              proximity = (parseFloat(order.P) - parseFloat(item1.bid)) / (parseFloat(item1.bid)) * 100;
            }
          }
          break;
          case appConstants.OTO_ORD_TYPE:
            if (parseFloat(order.DOT) === appConstants.STOP_ORD_TYPE) {
              dealType = `OTO ${order.isOCO ? 'OCO' : ''} Stop`;
              if (order.DT) {
                proximity = (parseFloat(order.P) - parseFloat(item1.bid)) / (parseFloat(item1.bid)) * 100;
              } else {
                proximity = (parseFloat(order.P) - parseFloat(item1.ask)) / (parseFloat(item1.ask)) * 100 * -1;
              }
            } else {
              dealType = `OTO ${order.isOCO ? 'OCO' : ''} Limit`;
              if (order.DT) {
                proximity = (parseFloat(order.P) - parseFloat(item1.ask)) / (parseFloat(item1.ask)) * 100 * -1;
              } else {
                proximity = (parseFloat(order.P) - parseFloat(item1.bid)) / (parseFloat(item1.bid)) * 100;
              }
            }
            break;
      }
      // working orders
      if(proximity && Number.isFinite(proximity)) {
        proximity = parseFloat(proximity).toFixed(2);
      }else{
        proximity=null
      }
      var obj = {
        id: order.CLID,
        'eventTime': moment(order.ET).format(appConstants.actTimeDateTimeFormatter),
        'orderNo': (order.DN
          ? order.DN
          : ""),
        'proximity': proximity,
        'cmdtyPair': order.SD,
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0.000"),
        'working': (order.PDQ ? (Number(parseFloat(order.PDQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0.000"),
        'filled': (order.PQ ? (Number(parseFloat(order.PQ)-parseFloat(order.PDQ)-parseFloat(order.COTCQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0.000"),
        'cancelQty': (order.COTCQ ? (Number(parseFloat(order.COTCQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0.000"),
        'price': (order.P ? (Number(parseFloat(order.P)).toLocaleString('en', { minimumFractionDigits: dec,maximumFractionDigits:minDec })) : "0"),
        'accDescription': order.AD,
        'accCode': order.CC,
        'validity': (parseInt(order.VC) === appConstants.GTD ? "GTD: " + moment(parseFloat(order.TIME)).format(appConstants.validityDateFormat) : (parseInt(order.VC) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
        'comments': order.RMK,
        'cmdtyId': order.IID,
        'selected': false,
        'dealType': order?.isLoopOTO ? LoopDealType : dealType,
        'valDate': handleValueDate(order),
        'forwardVal': order.FWD ? parseFloat(order.FWD).toFixed(config.roundOff) : "0.00",
        //'markup': SPRPER,
        'OT': parseFloat(order.OT),//OT=2 limit ,OT=3 ,Stop OT=6 OCO
        'DOT': parseFloat(order.DOT),//DOT=2 limit DOT=3 stop,
        'DT': (order.DT) === true ? 1 : 0,//BUY or sell
        'isMRKSelected': order.isMRKSelected,
        'ISOTO': order?.ISOTO ?? false,
        'ISOCO': order?.isOCO ?? false,
        'ISACTIVE': order?.isActive ?? true,
        'INLOOP': order?.isLoopOTO ?? false,
        'linkclid': !!order?.oto_link_cl_ord_id ? order?.oto_link_cl_ord_id : order.CLID,
        'isSNEXrmk': order.isSNEXrmk
      };
      // working orders map
      var obj1 = {
        'id': order.CLID,
        'eventTime': moment(order.ET).format(appConstants.actTimeDateTimeFormatter),
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'cmdtyPair': order.SD,
        'quantity':  (order.PQ ? convertToFloat(order.PQ) : "0"),
        'WKQ': parseFloat((order.PDQ).toFixed(config.QuantityRoundOff)),
        'TFQ': parseFloat(((order.PQ)-(order.PDQ)-(order.COTCQ)).toFixed(config.QuantityRoundOff)),
        'orderNo': (order.DN
          ? order.DN
          : ""),
        'accCode': order.CC,
        'accDescription': order.AD,
        'comments': order.RMK,
        'DRMK': order.DRMK,
        'OR': (order.P).toFixed(dec),
        'OSC': order.OSC,
        'OMC': parseInt(order.OMC) + 1,
        'VT': order.VC,
        'OVT': order.VC,
        'TIME': order.TIME,
        'OTIME': order.TIME,
        'BID': order.BID,
        'VD': moment(order.VD).format('YYYY/MM/DD'),
        'CTID': order.CLID,
        'cmdtyId': order.IID,
        'OT': parseFloat(order.OT),//OT=2 limit ,OT=3 ,Stop OT=6 OCO
        'DOT': parseFloat(order.DOT),//DOT=2 limit DOT=3 stop,
        'DT': (order.DT) === true ? 1 : 0,//BUY or sell
        'isVDSelected': order.isVDSelected,
        'isOCO': order.isOCO,
        'ISOTO': order?.ISOTO ?? false,
        'ISOCO': order?.isOCO ?? false,
        'ISACTIVE': order?.isActive ?? true,
        'INLOOP': order?.isLoopOTO ?? false,
        'linkclid': !!order?.oto_link_cl_ord_id ? order?.oto_link_cl_ord_id : order.CLID,
        'isSNEXrmk': order.isSNEXrmk ? order.isSNEXrmk : false
      };
      // all orders
      var obj2 = {
        id: order.CLID,
        'eventTime': moment(order.ET).format(appConstants.actTimeDateTimeFormatter),
        'status': 'Working',
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'pair': order.SD,
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0.000"),
        'rate': Number((order.P)).toLocaleString('en', { minimumFractionDigits: dec, maximumFractionDigits: minDec }),
        'validity': (parseInt(order.VC) === appConstants.GTD ? "GTD: " + moment(parseFloat(order.TIME)).format(appConstants.validityDateFormat) : (parseInt(order.VC) === appConstants.DAY ? "DAY 1700 NYC" : "GTC")),
        'orderNo': (order.DN
          ? order.DN
          : ""),
        'docNo': '',
        'accDescription': order.AD,
        'comments': order.RMK,
        'cmdtyId': order.IID,
        'selected': false,
        'dealType':  order?.isLoopOTO ? LoopDealType : dealType,
        'OT': parseFloat(order.OT),
        'DOT': parseFloat(order.DOT),//DOT=2 limit DOT=3 stop
        'DT': (order.DT) === true ? 1 : 0,
        'ISOTO': order?.ISOTO ?? false,
        'ISOCO': order?.isOCO ?? false,
        'ISACTIVE': order?.isActive ?? true,
        'isLoopOTO': order.isLoopOTO,
        'INLOOP': order?.isLoopOTO ?? false,
        'linkclid': !!order?.oto_link_cl_ord_id ? order?.oto_link_cl_ord_id : order.CLID,
        'isSNEXrmk': order.isSNEXrmk ? order.isSNEXrmk : false
      };
      if (order.hasOwnProperty("ISOTO") && order.ISOTO) {
        // OTO order
        if (order.hasOwnProperty("isActive")) {
          if (order.isActive) {
            outstandinLMTArray.push(obj);      
            lmtOrdArr.push(obj2);
          }
        }
      } else {
        // non-OTO order
        outstandinLMTArray.push(obj);      
        lmtOrdArr.push(obj2);
      }
      
      temMap.set(order.DN, obj1);
    });
    limitOrdBook.outstandingLm.outstandingLmArr = outstandinLMTArray;
    limitOrdBook.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    limitOrdBook.limitOrdMap = temMap;
    limitOrdBook.lmtOrdersRows = lmtOrdArr;
    localStorage.setItem('outstandingLm', JSON.stringify(limitOrdBook.outstandingLm));
    workingOrders.length = 0
    workingOrders.push(...outstandinLMTArray)
    ordersStore.push({
        key: 'orderNo',
        type: 'update',
        data: workingOrders
    })
    return outstandinLMTArray;
  } catch (e) {
    /* 
        Note: changes.filter is not a function
        this error can be ignored as this
        happens when data is null/undefined 
        which it is at the start
    */
    console.log(" e " + e);
  } finally {

  }
}

const getSuspendedOrders = (orderLmt, limitOrdBook) => {
  try {
    var tempArray = [];
    orderLmt.map((order) => {
      var dec = getDecimal(order.IID);
      var item1 = Object.assign([], JSON.parse(localStorage.getItem(order.IID)));
      let proximity = 0;
      let dealType = 'Limit';
      switch (parseFloat(order.OT)) {
        case appConstants.LMT_ORD_TYPE:
          dealType = 'Limit';
          if (order.DT) {
            proximity = (parseFloat(order.P) - parseFloat(item1.ask)) / (parseFloat(item1.ask)) * 100 * -1;
          } else {
            proximity = (parseFloat(order.P) - parseFloat(item1.bid)) / (parseFloat(item1.bid)) * 100;
          }
          break;
        case appConstants.STOP_ORD_TYPE:
          dealType = 'Stop';
          if (order.DT) {
            proximity = (parseFloat(order.P) - parseFloat(item1.bid)) / (parseFloat(item1.bid)) * 100;
          } else {
            proximity = (parseFloat(order.P) - parseFloat(item1.ask)) / (parseFloat(item1.ask)) * 100 * -1;
          }
          break;
        case appConstants.OCO_ORD_TYPE:
          if (parseFloat(order.DOT) === appConstants.STOP_ORD_TYPE) {
            dealType = 'OCO Stop';
            if (order.DT) {
              proximity = (parseFloat(order.P) - parseFloat(item1.bid)) / (parseFloat(item1.bid)) * 100;
            } else {
              proximity = (parseFloat(order.P) - parseFloat(item1.ask)) / (parseFloat(item1.ask)) * 100 * -1;
            }
          } else {
            dealType = 'OCO Limit';
            if (order.DT) {
              proximity = (parseFloat(order.P) - parseFloat(item1.ask)) / (parseFloat(item1.ask)) * 100 * -1;
            } else {
              proximity = (parseFloat(order.P) - parseFloat(item1.bid)) / (parseFloat(item1.bid)) * 100;
            }
          }
          break;
        case appConstants.OTO_ORD_TYPE:
          if (parseFloat(order.DOT) === appConstants.STOP_ORD_TYPE) {
            dealType = `OTO ${order.isOCO ? 'OCO' : ''} Stop`;
            if (order.DT) {
              proximity = (parseFloat(order.P) - parseFloat(item1.bid)) / (parseFloat(item1.bid)) * 100;
            } else {
              proximity = (parseFloat(order.P) - parseFloat(item1.ask)) / (parseFloat(item1.ask)) * 100 * -1;
            }
          } else {
            dealType = `OTO ${order.isOCO ? 'OCO' : ''} Limit`;
            if (order.DT) {
              proximity = (parseFloat(order.P) - parseFloat(item1.ask)) / (parseFloat(item1.ask)) * 100 * -1;
            } else {
              proximity = (parseFloat(order.P) - parseFloat(item1.bid)) / (parseFloat(item1.bid)) * 100;
            }
          }
          break;
      }
      let fillQty=parseFloat((parseFloat(order.PQ)-parseFloat(order.PDQ)-parseFloat(order.COTCQ)).toFixed(config.QuantityRoundOff));
      if (parseFloat(order.OT) === appConstants.OTO_ORD_TYPE) {
        if (order.hasOwnProperty("isActive") && !order?.isActive) {
          const obj = {
            id: order.CLID,
            'eventTime': moment(order.ET).format(appConstants.actTimeDateTimeFormatter),
            'orderNo': (order.DN
              ? order.DN
              : ""),
            'proximity': parseFloat(proximity).toFixed(2),
            'cmdtyPair': order.SD,
            'deal': (order.DT) === true
              ? "BUY"
              : "SELL",
            'quantity': parseFloat((order.PQ).toFixed(config.QuantityRoundOff)),
            'working': parseFloat((order.PDQ).toFixed(config.QuantityRoundOff)),
            'filled':fillQty,//Number(parseFloat(((order.PQ)-(order.PDQ)-(order.COTCQ)).toFixed(config.QuantityRoundOff))),
            'cancelQty': (order.COTCQ ? parseFloat(order.COTCQ.toFixed(config.QuantityRoundOff)) : '0.000'),
            'price': (order.P ? (Number(parseFloat(order.P)).toLocaleString('en', { minimumFractionDigits: dec })) : "0"),
            'accDescription': order.AD,
            'accCode': order.CC,
            'validity': (parseInt(order.VC) === appConstants.GTD ? "GTD: " + moment(parseFloat(order.TIME)).format(appConstants.validityDateFormat) : (parseInt(order.VC) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
            'comments': order.RMK,
            'cmdtyId': order.IID,
            'selected': false,
            'dealType': dealType,
            'valDate': order.isVDSelected ? moment(order.VD).format(appConstants.shortDateFormat) : 'Spot',
            'forwardVal': order.FWD ? parseFloat(order.FWD).toFixed(config.roundOff) : "0.00",
            //'markup': SPRPER,
            'OT': parseFloat(order.OT),//OT=2 limit ,OT=3 ,Stop OT=6 OCO
            'DOT': parseFloat(order.DOT),//DOT=2 limit DOT=3 stop,
            'DT': (order.DT) === true ? 1 : 0,//BUY or sell
            'isMRKSelected': order.isMRKSelected,
            'isActive': order?.isActive,
            'isSNEXrmk': order.isSNEXrmk ? order.isSNEXrmk : false
          };
          tempArray.push(obj);
        }
      }
    });

    limitOrdBook.suspendedOrders = {
      suspendedOrdArr: tempArray,
      randomNo: Math.floor((Math.random() * 1000000) + 1)
    }
    localStorage.setItem('suspendedOrd', JSON.stringify(limitOrdBook.suspendedOrders));
    return tempArray;
  } catch (e) {
    console.log(" e " + e);
  }
}

const getallspot = (orderspot, tradeBook) => {
  try {
    var tradeBookArr = [];
    orderspot.map((order) => {  
      var cmdtyDet = Object.assign([], JSON.parse(localStorage.getItem(order.IID)));
      let maxDec = 0;
      var minDec = 0

      if ((cmdtyDet.TF).toString().split(".")[1]) {
        maxDec = (cmdtyDet.TF).toString().split(".")[1].length
        for (let i = 0; i < maxDec; i++) {
          if ((cmdtyDet.TF).toString().split(".")[1][i] === '0') { minDec += 1; }
        }
      }
      var obj = {
        'id': '',
        'eventTime': moment(order.ET).local().format(appConstants.actTimeDateTimeFormatter),
        'deal': (order.DT) === 1
          ? "BUY"
          : "SELL",
        'cmdtyPair': order.SD,
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0"),
        'qtyType': order.OSC,
        'rate': Number(parseFloat(order.P)).toLocaleString('en', { maximumFractionDigits: maxDec, minimumFractionDigits: minDec }),
        'docNo': order.DN,
        'valDate': moment(order.VD).format('YYYY/MM/DD') !== cmdtyDet.VD  ? moment(order.VD).format(appConstants.shortDateFormat) : 'Spot', // order.isVDSelected ? moment(order.VD).format(appConstants.shortDateFormat) : 'Spot',
        'VD': moment(order.VD).format('YYYY/MM/DD'),
        'trader': order.TC,
        'accDescription': order.AD,
        'comments': order.RMK,
        'cmdtyId': order.IID
      };
      tradeBookArr.push(obj);
    });
    tradeBook.tradeBookArray = tradeBookArr;
    tradeBook.randomNo = Math.floor((Math.random() * 10) + 1);
    //localStorage.setItem('tradeBook', JSON.stringify(tradeBook));
    return tradeBook;
  } catch (e) {
    console.log("exception " + e);
  }
}

const getallSwap = (orderspot, swapBook) => {
  try {
    var swapBookArr = [];
    orderspot.map((order) => {  
      var cmdtyDet = Object.assign([], JSON.parse(localStorage.getItem(order.inst_id)));
      let maxDec = 0;
      var minDec = 0

      if ((cmdtyDet.TF).toString().split(".")[1]) {
        maxDec = (cmdtyDet.TF).toString().split(".")[1].length
        for (let i = 0; i < maxDec; i++) {
          if ((cmdtyDet.TF).toString().split(".")[1][i] === '0') { minDec += 1; }
        }
      }
      const leg1DealType = order.leg1_deal_type === 1 ? "BOUGHT" : "SOLD";
      const leg2DealType = order.leg2_deal_type === 1 ? "BOUGHT" : "SOLD";
 
      let legComments =`${leg1DealType}, ${order.leg1_remarks}` +` | ${leg2DealType}, ${order.leg2_remarks}`;
 
      if (order.rmk && order.rmk.trim() !== "") {
          legComments += ` | ${order.rmk}`;
      }
      let obj = {
        'id': '',
        'eventTime': moment(order.event_time).local().format(appConstants.actTimeDateTimeFormatter),
        'deal': (order.leg1_deal_type) === 1
          ? "Borrow"
          : "Lend",
        'cmdtyPair': cmdtyDet.ID,
        'quantity': (order.leg1_pcs_qty ? (Number(parseFloat(order.leg1_pcs_qty)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0"),
        'qtyType': order.leg1_stk_code,
        'nearLegRate': Number(parseFloat(order.leg1_rate)).toLocaleString('en', { maximumFractionDigits: maxDec, minimumFractionDigits: minDec }),
        'farLegRate': Number(parseFloat(order.leg2_rate)).toLocaleString('en', { maximumFractionDigits: maxDec, minimumFractionDigits: minDec }),
        'docNo': order.docno,
        'nearLegDate': moment(order.leg1_valdate).format('YYYY/MM/DD') !== cmdtyDet.VD  ? moment(order.leg1_valdate).format(appConstants.shortDateFormat) : 'Spot', // order.isVDSelected ? moment(order.VD).format(appConstants.shortDateFormat) : 'Spot',
        'farLegDate': moment(order.leg2_valdate).format('YYYY/MM/DD') !== cmdtyDet.VD  ? moment(order.leg2_valdate).format(appConstants.shortDateFormat) : 'Spot', // order.isVDSelected ? moment(order.VD).format(appConstants.shortDateFormat) : 'Spot',
        'trader': order.user_code,
        'accDescription': order.acc_description,
        'comments': legComments,
      };
      swapBookArr.push(obj);
    });
    swapBook.swapBookArray = swapBookArr;
    swapBook.randomNo = Math.floor((Math.random() * 10) + 1);
    //localStorage.setItem('tradeBook', JSON.stringify(tradeBook));
    return swapBook;
  } catch (e) {
    console.log("exception swapbook" + e);
  }
}

const getFilledBM = (filledBm, benchMrkBook) => {
  try {
    var filledBMArray = [];
    var filledtempBMArr = benchMrkBook.bmOrderRows;
    filledBm.map((order,index) => {
      var dec = getBMKDecimal(order.IID);
      var minDec=getMinBMKDecimal(order.IID);
      const user = JSON.parse(localStorage.getItem('user'));
      var obj = {
        'id': index,
        'eventTime': moment(order.ET).format(appConstants.actTimeDateTimeFormatter),
        'benchmark': order.BMD,
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'cmdtyPair': order.SD,
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff})) : "0"),
        'rate': parseFloat(order.P).toLocaleString('en', { minimumFractionDigits: minDec,maximumFractionDigits:dec }),
        'docNo': order.NFD,
        'orderNo': order.DN,
        'valDate': moment(order.VD).format(appConstants.shortDateFormat),
        'comments': order.RMK,
        'accDescription': order.AD,
        'cmdtyId': order.IID,
        'stockCode': order.OSC,
        'eqOz':  parseFloat(order.GQ).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff,maximumFractionDigits:config.QuantityRoundOff }),
        'fwdVD' : moment(order.VD).format(appConstants.rptDateFormat),
        'tenor' : order.TENOR,
        'fwdPerc' : order.FWDPER
      };
      var obj2 = {
        'id': index,
        'eventTime': moment(order.ET).format(appConstants.actTimeDateTimeFormatter),
        'status': 'Filled',
        'benchmark': order.BMD,
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'pair': order.SD,
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0"),
        'orderNo': order.DN,
        'valDate': moment(order.VD).format(appConstants.shortDateFormat),
        'docNo': order.NFD,
        'rate': parseFloat(order.P).toLocaleString('en', { minimumFractionDigits: minDec,maximumFractionDigits:dec }),
        'accDescription': order.AD,
        'comments': order.RMK,
        'cmdtyId': order.IID,
        'stockCode': order.OSC,
        'eqOz':  parseFloat(order.GQ).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff,maximumFractionDigits:config.QuantityRoundOff }),
        'fwdVD' : moment(order.VD).format(appConstants.rptDateFormat),
        'tenor' : order.TENOR,
        'fwdPerc' : order.FWDPER
      };
      filledtempBMArr.push(obj2);
      filledBMArray.push(obj);
    });
    benchMrkBook.bmFillOrdersRows.bmFillOrderArray = filledBMArray;
    benchMrkBook.bmOrderRows = filledtempBMArr;
    benchMrkBook.bmFillOrdersRows.randomNo = Math.floor((Math.random() * 1000000) + 1);
    //localStorage.setItem('benchMrkBook', JSON.stringify(benchMrkBook));
    return filledBMArray;
  } catch (e) {
    console.log(" exception " + e);
  }
}
const getCancelledBM = (cancelledBmk, benchMrkBook) => {
  try {
    var cancelledBMArray = [];
    var cancelledtempBMArr = benchMrkBook.bmOrderRows;
    cancelledBmk.map((order,index) => {
      var obj = {
        'id': index,
        'eventTime': moment(order.ET).format(appConstants.actTimeDateTimeFormatter),
        'benchmark': order.BMD,
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'cmdtyPair': order.SD,
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0"),
        'orderNo': order.DN,
        'cmdtyId': order.IID,
        'stockCode': order.OSC,
        'eqOz':  parseFloat(order.GQ).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff,maximumFractionDigits:config.QuantityRoundOff })
        // 'valDate': moment(order.VD).format(appConstants.shortDateFormat),
      }

      var obj2 = {
        'id': index,
        'eventTime': moment(order.ET).format(appConstants.actTimeDateTimeFormatter),
        'status': 'Cancelled',
        'benchmark': order.BMD,
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'pair': order.SD,
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0"),
        'orderNo': order.DN,
        'docNo': '',
        'rate': '',
        'accDescription': order.AD,
        'comments': order.RMK,
        'cmdtyId': order.IID,
        'stockCode': order.OSC,
        'eqOz':  parseFloat(order.GQ).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff,maximumFractionDigits:config.QuantityRoundOff })
        // 'valDate': moment(order.VD).format(appConstants.shortDateFormat)
      };

      cancelledtempBMArr.push(obj2);
      cancelledBMArray.push(obj);
    });
    benchMrkBook.bmOrderRows = cancelledtempBMArr;
    benchMrkBook.bmCancelledOrdersRows.bmCancelledOrdArray = cancelledBMArray;
    benchMrkBook.bmCancelledOrdersRows.randomNo = Math.floor((Math.random() * 1000000) + 1);
    //localStorage.setItem('benchMrkBook', JSON.stringify(benchMrkBook));
    return cancelledBMArray;
  } catch (e) {
    console.log(" exception " + e);
  }
}
const getCancelledLMT = (cancelledLMT, limitOrdBook) => {
  try {
    const AD = JSON.parse(localStorage.getItem('DefaultAC')).AD
    var cancelledLMTArray = [];
    var lmtOrdArr = limitOrdBook.lmtOrdersRows;
    cancelledLMT.map((order, index) => {
      let dealType = `${order.ISOTO ? 'OTO ' : ''}Limit`;
      let cancelDealType = `${order.ISOTO ? 'OTO ' : ''}Limit ${order.isLoopOTO ? '(L)' : ''}`;
      if (parseFloat(order.OT) === appConstants.STOP_ORD_TYPE) {
        dealType = `${order.ISOTO ? 'OTO ' : ''}Stop`;
        cancelDealType = `${order.ISOTO ? 'OTO ' : ''}Stop ${order.isLoopOTO ? '(L)' : ''}`;
      } else if (parseFloat(order.OT) === appConstants.OCO_ORD_TYPE) {
        if (parseFloat(order.DOT) === appConstants.STOP_ORD_TYPE) {
          dealType = `${order.ISOTO ? 'OTO ' : ''}OCO Stop`
        } else {
          dealType = `${order.ISOTO ? 'OTO ' : ''}OCO Limit`
        }
      }
      // cancelled orders tab
      var obj = {
        id: index,
        'eventTime': moment(order.FT).local().format(appConstants.actTimeDateTimeFormatter),
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'cmdtyPair': order.ST,
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0"),
        'rate': (order.P ? (Number(parseFloat(order.P)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0.000"),
        'validity': (order.VC) === '6' ? "GTD: " + moment(parseFloat(order.VD)).format(appConstants.validityDateFormat) : (order.VC) === '0' ? "DAY: 1700 NYC" : "GTC",
        'orderNo': order.DN,
        'cmdtyId': order.I,
        'dealType': order?.isLoopOTO ? cancelDealType : dealType,
      }
      // All orders tab
      var obj2 = {
        id: index,
        'eventTime': moment(order.FT).local().format(appConstants.actTimeDateTimeFormatter),
        'status': 'Cancelled',
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'pair': order.ST,
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0"),
        'rate': (order.P ? (Number(parseFloat(order.P)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0.000"),
        'validity': (order.VC) === '6' ? "GTD: " + moment(parseFloat(order.VD)).format(appConstants.validityDateFormat) : (order.VC) === '0' ? "DAY: 1700 NYC" : "GTC",
        'orderNo': order.DN,
        'docNo': '',
        'accDescription': (order.AD ? order.AD : AD),
        'comments': order.R,
        'cmdtyId': order.I,
        'dealType': order?.isLoopOTO ? cancelDealType : dealType,

      };
      //Bug#37000 changes
      lmtOrdArr.push(obj2);
      cancelledLMTArray.push(obj);
    });
    limitOrdBook.lmCancellOrd.lmCancellOrdArr = cancelledLMTArray;
    limitOrdBook.lmtOrdersRows = lmtOrdArr;
    //localStorage.setItem('limitOrdBook', JSON.stringify(limitOrdBook));
    return cancelledLMTArray;
  } catch (e) {
    console.log(" exception " + e);
  }
}
const getFilledLMT = (filledLm, limitOrdBook) => {
  try {
    const AD = JSON.parse(localStorage.getItem('DefaultAC')).AD;
    var filledLMArray = [];
    var filledLMtempArr = limitOrdBook.lmtOrdersRows;
    filledLm.map((order, index) => {
      const minDec = getMinAmntDecimal(order.I);
      const maxDec = getAmntDecimal(order.I);
      let dealType = `${order.ISOTO ? 'OTO ' : ''}Limit`;
      let filledDealType = `${order.ISOTO ? 'OTO ' : ''}Limit ${order.isLoopOTO ? '(L)' : ''}`;
      if (parseFloat(order.OT) === appConstants.STOP_ORD_TYPE) {
        dealType = `${order.ISOTO ? 'OTO ' : ''}Stop`;
        filledDealType = `${order.ISOTO ? 'OTO ' : ''}Stop ${order.isLoopOTO ? '(L)' : ''}`;
      } else if (parseFloat(order.OT) === appConstants.OCO_ORD_TYPE) {
        if (parseFloat(order.DOT) === appConstants.STOP_ORD_TYPE) {
          dealType = `${order.ISOTO ? 'OTO ' : ''}OCO Stop`
        } else {
          dealType = `${order.ISOTO ? 'OTO ' : ''}OCO Limit`
        }
      }
      var obj = {
        id: index,
        'eventTime': moment(order.FT).format(appConstants.actTimeDateTimeFormatter),
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'cmdtyPair': order.ST,
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0"),
        'rate': (Number(parseFloat(order.P)).toLocaleString('en', { minimumFractionDigits: minDec, maximumFractionDigits: maxDec })),
        'validity': (parseInt(order.VC) === appConstants.GTD ? "GTD: " + moment(parseFloat(order.TIME)).format(appConstants.validityDateFormat) : (parseInt(order.VC) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
        'docNo': order.FD,
        'orderNo': order.DN,
        'valDate': moment(order.VD).format(appConstants.shortDateFormat),
        'comments': order.R,
        'accDescription': (order.AD ? order.AD : AD),
        'cmdtyId': order.I,
        'dealType': order?.isLoopOTO? filledDealType:dealType,
        'status': order.OS === 'F'|| order.OS === 'C' || order.OS === 'E' ? 'Filled' : 'Partially Filled',
        'OT':parseFloat(order.OT)
      };

      var obj2 = {
        id: index,
        'eventTime': moment(order.FT).format(appConstants.actTimeDateTimeFormatter),
        'status': order.OS === 'F' || order.OS === 'C' || order.OS === 'E' ? 'Filled' : 'Partially Filled',
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'pair': order.ST,
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0"),
        'rate': (Number(parseFloat(order.P)).toLocaleString('en', { minimumFractionDigits: minDec, maximumFractionDigits: maxDec })),
        'validity': (parseInt(order.VC) === appConstants.GTD ? "GTD: " + moment(parseFloat(order.TIME)).format(appConstants.validityDateFormat) : (parseInt(order.VC) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")), //FD#24225
        'orderNo': order.DN,
        'docNo': order.FD,
        'accDescription': (order.AD ? order.AD : AD),
        'comments': order.R,
        'cmdtyId': order.I,
        'dealType': order?.isLoopOTO? filledDealType:dealType,
        'OT':parseFloat(order.OT)
      };

      filledLMtempArr.push(obj2);
      filledLMArray.push(obj);
    });
    limitOrdBook.lmFillOrd.lmFillOrdArr = filledLMArray;
    limitOrdBook.lmtOrdersRows = filledLMtempArr;
    //localStorage.setItem('limitOrdBook', JSON.stringify(limitOrdBook));
    return filledLMArray;
  } catch (e) {
    console.log(" exception " + e);
  }
}
const getExpiredLMT = (expiredLMT, limitOrdBook) => {
  try {
    const AD = JSON.parse(localStorage.getItem('DefaultAC')).AD;
    var expiredLMTArray = [];
    var expiredLMTtempArr = limitOrdBook.lmtOrdersRows;
    expiredLMT.map((order,index) => {
      let dealType = `${order.ISOTO ? 'OTO ' : ''}Limit`;
      let expiredDealType = `${order.ISOTO ? 'OTO ' : ''}Limit ${order.isLoopOTO ? '(L)' : ''}`;
      if (parseFloat(order.OT) === appConstants.STOP_ORD_TYPE) {
        dealType = `${order.ISOTO ? 'OTO ' : ''}Stop`;
        expiredDealType = `${order.ISOTO ? 'OTO ' : ''}Stop ${order.isLoopOTO ? '(L)' : ''}`;
      } else if (parseFloat(order.OT) === appConstants.OCO_ORD_TYPE) {
        if (parseFloat(order.DOT) === appConstants.STOP_ORD_TYPE) {
          dealType = `${order.ISOTO ? 'OTO ' : ''}OCO Stop`
        } else {
          dealType = `${order.ISOTO ? 'OTO ' : ''}OCO Limit`
        }
      }
      var dec = getDecimal(order.I);
      const user = JSON.parse(localStorage.getItem('user'));
      var obj = {
        id: index,
        'eventTime': moment(order.FT).format(appConstants.actTimeDateTimeFormatter),
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'cmdtyPair': order.ST,
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0"),
        'rate': (Number(parseFloat(order.P)).toLocaleString('en', { minimumFractionDigits: dec })),
        'validity': (parseInt(order.VC) === appConstants.GTD ? "GTD: " + moment(parseFloat(order.VD)).format(appConstants.validityDateFormat) : (parseInt(order.VC) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
        'orderNo': order.DN,
        'cmdtyId': order.I,
        'dealType': order?.isLoopOTO ? expiredDealType:dealType
      }

      var obj2 = {
        id: index,
        'eventTime': moment(order.FT).format(appConstants.actTimeDateTimeFormatter),
        'status': 'Expired',
        'deal': (order.DT) === true
          ? "BUY"
          : "SELL",
        'pair': order.ST,
        'quantity': (order.PQ ? (Number(parseFloat(order.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0"),
        'rate': order.P,
        'validity': (parseInt(order.VC) === appConstants.GTD ? "GTD: " + moment(parseFloat(order.VD)).format(appConstants.validityDateFormat) : (parseInt(order.VC) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
        'orderNo': order.DN,
        'docNo': '',
        'accDescription': (order.AD ? order.AD : AD),
        'comments': order.R,
        'cmdtyId': order.I,
        'dealType': order?.isLoopOTO ? expiredDealType:dealType
      };
      // Bug#37000
      expiredLMTtempArr.push(obj2);
      expiredLMTArray.push(obj);
    });
    limitOrdBook.lmExpOrd.lmExpOrdArr = expiredLMTArray;
    limitOrdBook.lmtOrdersRows = expiredLMTtempArr;
    //localStorage.setItem('limitOrdBook', JSON.stringify(limitOrdBook));
    return expiredLMTArray;
  } catch (e) {
    console.log(" exception " + e);
  }
}

const getDecimal = (cmdtypair) => {
  var item = JSON.parse(localStorage.getItem(cmdtypair));
  var dec = item ? item.dec :''
  return dec;
}
const getMinDecimal = (cmdtypair) => {
  var item = JSON.parse(localStorage.getItem(cmdtypair));
  var dec = item ? item.minDec :''
  return dec;
}
const getBMKDecimal = (cmdtypair) => {
  var item = JSON.parse(localStorage.getItem(cmdtypair));
  let dec = item ?  item.BMdec : ''
  return dec;
}
const getMinBMKDecimal = (cmdtypair) => {
  var item = JSON.parse(localStorage.getItem(cmdtypair));
  let dec = item ? item.BMminDec : ''
  return dec;
}
const getAmntDecimal = (cmdtypair) => {
  var item = JSON.parse(localStorage.getItem(cmdtypair));
  var dec = item ? item.amntDec : ''
  return dec;
}
const getMinAmntDecimal = (cmdtypair) => {
  var item = JSON.parse(localStorage.getItem(cmdtypair));
  var dec = item ? item.amntMinDec : ''
  return dec;
} 
const getAvgBMKData = (avgBMK) => {
  try {
      var avgBMKDetails = [];
      avgBMK.map((msg, index) => {
          var item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
          let SPR = msg.SPR ? msg.SPR : 0;
          SPR = (msg.isSPRSelected ? msg.SPR : parseFloat(msg.SPR) * (-1));
          SPR = (" $ " + (Number(parseFloat(SPR)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff }))); //fd25883
          var SPRPER = ''
          if (msg.SPRPER && (parseFloat(msg.SPRPER) !== 0)) {
              SPRPER = (Number(parseFloat(msg.SPRPER)).toLocaleString('en', { minimumFractionDigits: config.roundOff, maximumFractionDigits: config.roundOff })) + " % | "
          }
          const status = msg.OS === 'O' ? 'Working' : msg.OS === 'C' ? 'Cancelled' : msg.OS === 'CL' ? 'Closed' : '';
          var obj = {
              //'Doc': msg.NDO,
              'Cmdty Pair': msg.SD,
              'Deal': msg.DT ? 'BUY' : 'SELL',
              'Total Qty': (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff })),
              'Benchmark': msg.FTY.replace('SLVFIX','Silver Fix'),//msg.FTY === 'SLVFIX' ? 'Silver Fix' : msg.FTY,
              'Start Date': moment(msg.FD).format(appConstants.shortDateFormat),
              'End Date': moment(msg.TD).format(appConstants.shortDateFormat),
              'Value Date': msg.isVDSelected ? moment(msg.VD).format(appConstants.shortDateFormat) : 'Spot',
              'Qty/Fix': (Number(parseFloat(msg.QPF)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff })),
              'Quantity Booked': `${(Number(parseFloat(msg.QOFB ? msg.QOFB : 0)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff }))} / ${(Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff }))}`,
              'Fixes Booked': `${msg.NOFB ? msg.NOFB : 0}  / ${msg.NOF ? msg.NOF : 0}`,
              'Avg Price': (Number(parseFloat(msg.AVR)).toLocaleString('en', { minimumFractionDigits: item.BMminDec, maximumFractionDigits: item.BMdec })),
              'Spread': `${SPRPER}${SPR}`,
              'Forward %': parseFloat(msg.FWD).toFixed(config.roundOff),
              'Comments': msg.RMK,
              'Status': status,
              'AVG': msg.NDO,
              'Account': msg.AD,
              'Location': msg.dept_desc,//Location code=msg.LOC,
              'DB_ID': msg.CLD,
              'SPR': (msg.isSPRSelected ? parseFloat(msg.SPR) : parseFloat(msg.SPR) * (-1)),
              'SPRPER': parseFloat(msg.SPRPER),
              'isSPRSelected': msg.isSPRSelected,
              'cmdtyId': msg.IID,
              'eventTime': new Date(moment(msg.ET).format('DD-MMM-YYYY')).getTime(),
              'reverse': msg.RVD ? msg.RVD : '',
              'rebook': msg.RBD ? msg.RBD : '',
              'NOF':(msg.NOF? msg.NOF : 0),
              'accCode': msg.AC,
              'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false
          };
          avgBMKDetails.push(obj);
      });
      return avgBMKDetails;
  } catch (e) {
    console.log(" exception " + e);
  }
}

const updateAvgBMKData = (msg, avgBMKData) => {
  try {
    if (msg.BCM === appConstants.AVGBMK_ORDER_PLACED) {
    var avgBMKDetails = []; 
    var dec = getDecimal(msg.IID);
    var item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
    var SPR = msg.SPR ? msg.SPR : 0;
    SPR = msg.isSPRSelected ? SPR : SPR * (-1);
    SPR = (" $ " + (Number(parseFloat(SPR)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff })));
    var SPRPER = (msg.SPRPER ? msg.SPRPER : '')
    if (msg.SPRPER && (parseFloat(msg.SPRPER) !== 0)) {
      SPRPER = (Number(parseFloat(msg.SPRPER)).toLocaleString('en', { minimumFractionDigits: config.roundOff, maximumFractionDigits: config.roundOff })) + " % | "
    }
    msg.BMKTYPE = msg.BMKTYPE.map(key => (key === 'SLVFIX') ? key='Silver Fix' : key)
    var obj = {
      //'Doc': msg.AVG,
      'Cmdty Pair': item.ID,
      'Deal': parseFloat(msg.DT) === 1 ? 'BUY' : 'SELL',
      'Total Qty': (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff })),
      'Benchmark': msg.BMKTYPE.join('\t|\t'),
      'Start Date': moment(msg.FD).format(appConstants.shortDateFormat),
      'End Date': moment(msg.TD).format(appConstants.shortDateFormat),
      'Value Date': msg.isVDSelected ? moment(msg.VD).format(appConstants.shortDateFormat) : 'Spot',
      'Qty/Fix': (Number(parseFloat(msg.QPF)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff })),
      'Quantity Booked': `${(Number(parseFloat(msg.TFQ ? msg.TFQ : 0)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff }))} / ${(Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff }))}`,
      'Fixes Booked': `${msg.NOFB ? msg.NOFB : 0} / ${msg.NOF ? msg.NOF : 0}`,
      'Avg Price': (Number(parseFloat(msg.AVR ? msg.AVR : 0)).toLocaleString('en', { minimumFractionDigits: item.BMminDec, maximumFractionDigits: item.BMdec })),
      'Spread': `${SPRPER}${SPR}`,
      'Forward %': parseFloat(msg.FWDPER ? msg.FWDPER : 0).toFixed(config.roundOff),
      'Comments': msg.RMK,
      'Status': "Working",
      'AVG': msg.AVG,
      'Account': msg.AD,
      'Location': msg.LOCDESC,//msg.LOC,
      'DB_ID': msg.ID,
      'SPR': (msg.isSPRSelected ? parseFloat(SPR) : parseFloat(SPR) * (-1)),
      'SPRPER': parseFloat(msg.SPRPER ? msg.SPRPER : 0),
      'isSPRSelected': msg.isSPRSelected,
      'cmdtyId': msg.IID,
      'eventTime': msg.TS,
      'NOF': (msg.NOF ? msg.NOF : 0),
      'accCode': msg.AC,
      'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false

    };
    avgBMKDetails.push(obj);
    return [...avgBMKDetails, ...avgBMKData];

  } else if (msg.BCM === appConstants.AVGBMK_ORDER_MODIFIED) {
    var dec = getDecimal(msg.IID);
    var item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
    var SPR = msg.SPR ? msg.SPR : 0;
    SPR = msg.isSPRSelected ? SPR : parseFloat(SPR) * (-1);
    SPR = (" $ " + (Number(parseFloat(SPR)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff })));
    var SPRPER = ''
    if (msg.SPRPER && (parseFloat(msg.SPRPER) !== 0)) {
      SPRPER = (Number(parseFloat(msg.SPRPER)).toLocaleString('en', { minimumFractionDigits: config.roundOff, maximumFractionDigits: config.roundOff })) + " % | "
    }
    msg.BMKTYPE = msg.BMKTYPE.map(key => (key === 'SLVFIX') ? key='Silver Fix' : key)
    avgBMKData && avgBMKData.forEach((data, index) => {
      if (data.AVG === msg.AVG) {
        //data['Doc'] = msg.AVG
        data['Cmdty Pair'] = item.ID
        data['Deal'] = parseFloat(msg.DT) === 1 ? 'BUY' : 'SELL'
        data['Total Qty'] = (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff })),
          data['Benchmark'] = msg.BMKTYPE.join('\t|\t')
        data['Start Date'] = moment(msg.FD).format(appConstants.shortDateFormat)
        data['End Date'] = moment(msg.TD).format(appConstants.shortDateFormat)
        data['Value Date'] = msg.isVDSelected ? moment(msg.VD).format(appConstants.shortDateFormat) : 'Spot'
        data['Qty/Fix'] = parseFloat(msg.QPF).toFixed(config.QuantityRoundOff)
        data['Quantity Booked'] = `${(Number(parseFloat(msg.TFQ ? msg.TFQ : 0)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff }))} / ${(Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff }))}`
        data['Fixes Booked'] = `${msg.NOFB ? msg.NOFB : 0} / ${msg.NOF ? msg.NOF : 0}`
        data['Avg Price'] = (Number(parseFloat(msg.AVR ? msg.AVR : 0)).toLocaleString('en', { minimumFractionDigits: item.BMminDec, maximumFractionDigits: item.BMdec }))
        data['Spread'] = `${SPRPER}${SPR}`
        data['Forward %'] = parseFloat(msg.FWDPER ? msg.FWDPER : 0).toFixed(config.roundOff)
        data['Comments'] = msg.RMK
        data['Status'] = "Working"
        data['AVG'] = msg.AVG
        data['Account'] = msg.AD
        data['Location'] = msg.LOCDESC,//msg.LOC
        data['DB_ID'] = msg.ID
        data['SPR'] = (msg.isSPRSelected ? parseFloat(SPR) : parseFloat(SPR) * (-1))
        data['SPRPER'] = parseFloat(msg.SPRPER ? msg.SPRPER : '')
        data['isSPRSelected'] = msg.isSPRSelected
        data['cmdtyId'] = msg.IID
        data['eventTime'] = msg.TS
        data['NOF'] = (msg.NOF ? msg.NOF : 0)
        data['accCode'] = msg.AC
        data['isSNEXrmk'] = msg.isSNEXrmk ? msg.isSNEXrmk : false

        }
      })
      return avgBMKData;

  } else if (msg.BCM === appConstants.BENCHMARK_MANUAL_FILL && msg.OT === 8) {    
    // var item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
    var item = JSON.parse(localStorage.getItem(msg.IID));
   if(item){
    avgBMKData && avgBMKData.forEach((data) => {
      if (data.AVG === msg.MNOD) {
        data['Quantity Booked'] = `${(Number(parseFloat(msg.TFQ ? msg.TFQ : 0)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff }))} / ${(Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff }))}`
        data['Fixes Booked'] = `${msg.NOFB ? msg.NOFB : 0} / ${data.NOF ? data.NOF : 0}`
        data['eventTime'] = msg.TS
        data['Avg Price'] = (Number(parseFloat(msg.AVR ? msg.AVR : 0)).toLocaleString('en', { minimumFractionDigits: item.BMminDec, maximumFractionDigits: item.BMdec }))
      }
    })
  }
    return avgBMKData;
  } else if (msg.BCM === appConstants.AVGBMK_ORDER_CANCELLED) {  
    // var item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
    var item = JSON.parse(localStorage.getItem(msg.IID));
   if(item){
    avgBMKData && avgBMKData.forEach((data, index) => {
      if (data.AVG === msg.AVG) {
        data['Status'] = msg.rev_docno ? 'Closed' : 'Cancelled';
        data['Quantity Booked'] = `${(Number(parseFloat(msg.TFQ ? msg.TFQ : 0)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff }))} / ${(Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff }))}`
        data['Fixes Booked'] = `${msg.NOFB ? msg.NOFB : 0} / ${data.NOF ? data.NOF : 0}`
        data['eventTime'] = msg.TS
        data['Avg Price'] = (Number(parseFloat(msg.AVR ? msg.AVR : 0)).toLocaleString('en', { minimumFractionDigits: item.BMminDec, maximumFractionDigits: item.BMdec }))
        data['reverse'] = msg.rev_docno? msg.rev_docno : ''
        data['rebook'] = msg.reb_docno? msg.reb_docno : ''
      }
    })
  }
    return avgBMKData;
  } else if (msg.BCM === appConstants.AVGBMK_REVERSE_REBOOK) {
    avgBMKData && avgBMKData.forEach((data, index) => {
      if (data.AVG === msg.AVG) {
        let findRevIndex= msg.D.findIndex(x => (x.TYPE == 'Rev'));
        if(findRevIndex !== -1){
          data['reverse'] = msg.D[findRevIndex].DN
        }
        let findRebIndex= msg.D.findIndex(x => (x.TYPE == 'Reb'));
        if(findRebIndex !== -1){
          data['rebook'] = msg.D[findRebIndex].DN
        }
       // data['reverse'] = msg.rev_docno
        //data['rebook'] = msg.reb_docno
        data['Status'] = 'Closed'
        data['eventTime'] = msg.TS
        // data['Avg Price'] = parseFloat(msg.AVR ? msg.AVR : 0).toFixed(item.BMdec)
      }
    })
    return avgBMKData;
  }
}catch(e){
  console.log(" exception " + e);

  }
}

const getAvgBMKDrilldownData = (msg, avgBMKDrilldownData) => {
  // return [...msg, ...avgBMKDrilldownData]
  return msg
}

export function marginCheckNotification(msg, activityLog) {
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.isRejectFlag = true;
  obj.docNo = (msg.NFD
    ? msg.NFD
    : "");
  if (parseInt(msg.OT) === 2) {
    obj.docNo = (msg.NOD
      ? msg.NOD
      : "");
  } else if (parseInt(msg.OT) === 5) {
    obj.docNo = (msg.ONB
      ? msg.ONB
      : "");
  }
  let remark = "";
  const type = (msg.OT
    ? msg.OT
    : "1");
  const msgType = msg.OMT;
  if (parseInt(type) === 1) {
    remark = "Trade unsuccessful. "
  } else if (parseInt(msgType) === 2) {
    remark = "Modify unsuccessful. "
  } else if (parseInt(msgType) === 6) {
    remark = "Cancel unsuccessful. "
  } else {
    remark = "Order unsuccessful. "
  }
  switch (msg.STATUS) {
    case appConstants.TRD_ROUTE_ISSUE:
      remark = remark + "There's a problem with the price feed. Please contact your StoneX Trading Desk.";
      break;
    case appConstants.SESSION_EXP:
      remark = remark + "Your session has expired. Please login again.";
      break;
    case appConstants.REJ_ACCLOCKED:
      remark = remark + "Another trader is executing in this account.";
      break;
    case appConstants.MRG_FAILED:
      remark = remark + "Insufficient margins.";
      break;
    case appConstants.NOP_BREACH:
      remark = remark + "This trade would breach your position limit. Please contact your StoneX Trading Desk.";
      break;
    case appConstants.WORST_NOP_BREACH:
      remark = remark + "The value of your position plus outstanding orders cannot exceed your NOP limit.";
      break;
    case appConstants.INVALID_DATE:
      remark = remark + "The expiry time you entered falls on a non-business day.";
      break;
    case appConstants.ORD_FILLED:
      remark = remark + "This order has already been filled and cannot be modified.";
      break;
    case appConstants.EXCEEDS_TRDLIMIT:
      remark = remark + "The size exceeds your per deal limit.";
      break;
    case appConstants.EXCEEDS_EXPOSURE:
      remark = remark + "The value exceeds your overall exposure limit.";
      break;
    case appConstants.INSUFFICIENT_MRG:
      remark = remark + "Your margin levels are insufficient.";
      break;
    case appConstants.EXCEEDS_ORDLIMIT:
      remark = remark + "The value exceeds your per deal limit.";
      break;
    case appConstants.EXCEEDS_MIN_QTYLIMIT:
      remark = remark + "Quantity Exceeds Max Hedge Quantity.";
      break;
    case appConstants.TRD_PROCESS_ISSUE:
      remark = remark + "Deal request could not be processed. Please try after some time alert.";
      break;
    case appConstants.NO_DEALER:
      remark = remark + "There's no StoneX dealer available. Please contact your StoneX Trading Desk.";
      break;
    case appConstants.TRD_DISABLED:
      remark = remark + "This commodity is unavailable to you. Please contact your StoneX Trading Desk.";
      break;
    // case appConstants.TRD_ROUTE_ISSUE:
    //   remark=remark+ "There's a problem with the price feed. Please contact your StoneX Trading Desk.";
    //   break;
    // case appConstants.SESSION_EXP:
    //   remark=remark+ "Your session has expired. Please login again.";
    //   break;
    case appConstants.TRD_PLACE_FAIL:
      remark = remark + "Please try again.";
      break;
    // case appConstants.INVALID_DATE:
    //   remark=remark+ "The expiry time you entered falls on a non-business day.";
    //   break;
    // case appConstants.REJ_ACCLOCKED:
    //   remark=remark+ "Another trader is executing in this account.";
    //   break;
    case appConstants.NOP_BREACH:
      remark = remark + "This trade would breach your position limit. Please contact your StoneX Trading Desk.";
      break;
    // case appConstants.WORST_NOP_BREACH:
    //   remark=remark+ "The value of your position plus outstanding orders cannot exceed your NOP limit.";
    //   break;
    case appConstants.BM_NOT_VALID:
      remark = remark + "This benchmark is no longer available for new orders or modifications. Please contact your StoneX Dealing Desk.";
      break;
    case appConstants.MRK_ORD_CACNEL:
      remark = remark + "Trader cannot modify/cancel marked orders";
      break;
    case appConstants.NO_PRICE:
      remark = remark + "No price for this Commodity";
      break;
    case appConstants.BM_HOLIDAY:
      remark = remark + msg.MSG;//"The date entered falls on a holiday.";
      break;
    case appConstants.LOOP_ORDER_FAILED:
      remark = `OTO order loop failed. ${msg.MSG}`;
      break;
    case appConstants.FAILED:
      remark = remark + msg.MSG;//"The date range selected cannot be more than 3 months.";
      break;
    default:
      remark = remark + "Please try again.";
      break;
  }
  obj.remark = remark;
  activityLog.unshift(obj);
  return activityLog;
}
export function getDealRcvdLogRmk(msg, activityLog, cmdtypair) {
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NFD
    ? msg.NFD
    : "");
  var dec = getAmntDecimal(msg.IID);
  var cmdtyDet = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  let maxDec = 0;
  var minDec = 0

  if ((cmdtyDet.TF).toString().split(".")[1]) {
    maxDec = (cmdtyDet.TF).toString().split(".")[1].length
    for (let i = 0; i < maxDec; i++) {
      if ((cmdtyDet.TF).toString().split(".")[1][i] === '0') { minDec += 1; }
    }
  }

  let remark = "";
  remark = "Trade request received: ";
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL");
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })); //commBean.getSuffixFormat().format( To Ask Rekha mam
  remark = remark + " ";
  remark = remark + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
  remark = remark + " @";
  remark = remark + " ";
  remark = remark + (msg.DR
    ? (Number(parseFloat(msg.DR)).toLocaleString('en', { minimumFractionDigits: minDec, maximumFractionDigits: maxDec }))
    : "0");
  remark = remark + " ";
  remark = remark + (msg.ST !== undefined
    ? msg.ST
    : "");
  remark = remark + (msg.VD ? `(Value Date: ${moment(msg.VD).format("DD-MMM-YY")}) ` : "");  
  if (msg.AC)
    remark = remark + "for " + msg.AD;
  remark = remark + " [" + msg.UCD + "]";
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  if (msg.RMK !== "" && msg.RMK !== " ")
    remark = remark + " (Comments: " + (msg.RMK).trim() + ") ";
  obj.remark = remark + ".";
  activityLog.unshift(obj);
  return activityLog;
}

export function getFWDTradeRcvdRemark(msg, activityLog) {
  let obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = '';
  let remark = msg?.MSG;
  obj.remark = remark + ".";
  activityLog.unshift(obj);
  return activityLog;
}

export function getFWDTradeConfirmedRemark(msg, activityLog){
  let obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = msg?.NFD; 
  let remark = msg?.MSG;
  obj.remark = remark + ".";
  activityLog.unshift(obj);
  return activityLog;
}

export function getSWPTradeRcvdRemark(msg, activityLog) {
  let obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = '';
  let remark = msg?.MSG;
  obj.remark = remark + ".";
  activityLog.unshift(obj);
  return activityLog;
}

export function getSWPTradeConfirmedRemark(msg, activityLog){
  let obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = msg.SWC; 
  let remark = msg?.MSG;
  obj.remark = remark + ".";
  activityLog.unshift(obj);
  return activityLog;
}

export function getFwdNoRatesLogRemark(msg, activityLog){
  let obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = ""; 
  let remark = msg?.MSG;
  obj.remark = remark + ".";
  activityLog.unshift(obj);
  return activityLog;
}

export function getFwdOrdRejectLogRemark(msg, activityLog){
  let obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.isRejectFlag = true;
  obj.docNo = ""; 
  let remark = msg?.MSG;
  obj.remark = remark + ".";
  activityLog.unshift(obj);
  return activityLog;
}

export function getSwpOrdRejectLogRemark(msg, activityLog){
  let obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.isRejectFlag = true;
  obj.docNo = ""; 
  let remark = msg?.MSG;
  obj.remark = remark + ".";
  activityLog.unshift(obj);
  return activityLog;
}

export function getRejectedDealLogRemark(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getAmntDecimal(msg.IID);
  const cmdtyDet = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.isRejectFlag = true;
  obj.docNo = (msg.NFD
    ? msg.NFD
    : "");
  let remark = "";
  remark = remark + "Your trade request was unsuccessful: ";
  //remark=remark+(msg.T==="D"?"Dealer":msg.UCD)+" ";
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL");
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })); //commBean.getSuffixFormat().format( To Ask Rekha mam
  remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : +cmdtypair);
  remark = remark + " @" + " " + (msg.DR
    ? (Number(parseFloat(msg.DR)).toLocaleString('en', { minimumFractionDigits: cmdtyDet.amntMinDec, maximumFractionDigits: dec }))
    : "0") + " "
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  remark = remark + (msg.VD ? `(Value Date: ${moment(msg.VD).format("DD-MMM-YY")})` : "");   
  if (msg.AC)
    remark = remark + " for " + msg.AD;
  remark = remark + " [" + msg.UCD + "]";
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  if (msg.RMK !== "" && msg.RMK !== " ")
    remark = remark + " (Comments: " + (msg.RMK).trim() + ") ";
  obj.remark = remark + ".";
  item.unshift(obj);
  return item;
}
export function getConfirmedDealLogRemark(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getAmntDecimal(msg.IID);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NFD
    ? msg.NFD
    : "");
  let remark = "";

  var cmdtyDet = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  let maxDec = 0;
  var minDec = 0

  if ((cmdtyDet.TF).toString().split(".")[1]) {
    maxDec = (cmdtyDet.TF).toString().split(".")[1].length
    for (let i = 0; i < maxDec; i++) {
      if ((cmdtyDet.TF).toString().split(".")[1][i] === '0') { minDec += 1; }
    }
  }

  remark = "Trade confirmed: "
  //remark=reamark+(msg.T==="D"?"Dealer":msg.UCD)+" ";
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BOUGHT"
    : "SOLD");
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })); //commBean.getSuffixFormat().format( To Ask Rekha mam
  remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
  remark = remark + " @" + " " + (msg.DR
    ? (Number(parseFloat(msg.DR)).toLocaleString('en', { maximumFractionDigits: maxDec, minimumFractionDigits: minDec }))
    : "0") + " ";
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  remark = remark + (msg.VD ? `(Value Date: ${moment(msg.VD).format("DD-MMM-YY")}) ` : "");   
  if (msg.AC)
    remark = remark + "for " + msg.AD;
  remark = remark + " [" + msg.UCD + "]";
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  if (msg.RMK !== "" && msg.RMK !== " ")
    remark = remark + " (Comments: " + (msg.RMK).trim() + ") ";
  obj.remark = remark + ".";
  item.unshift(obj);
  return item;
}
export function getLimitOrderReqRecd(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NOD
    ? msg.NOD
    : "");
  let remark = "";
  let LoopdealType = `${msg?.INLOOP ? '(L) ' : ''}`;
  if (msg.OMT === appConstants.NEWORD) {
    remark = remark + "Order request received: ";
  } else if (msg.OMT === appConstants.MODORD) {
    remark = remark + "Modify Order request received: ";
  } else if (msg.OMT === appConstants.CANCELORD) {
    remark = remark + "Cancel Order request received: ";
  }
  if (msg.OT === appConstants.STOP_ORD_TYPE) {
    remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? `${msg.ISOTO ? 'OTO ': ''}Stop ${LoopdealType}BUY` : `${msg.ISOTO ? 'OTO ': ''}Stop ${LoopdealType}SELL`);
  } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
    let dealType = "";
    if (msg.DOT === appConstants.STOP_ORD_TYPE) {
      dealType = `${msg.ISOTO ? 'OTO ': ''}OCO Stop ` + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    } else {
      dealType = `${msg.ISOTO ? 'OTO ': ''}OCO Limit ` + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    }
    remark = remark + dealType;
  } else {
    let dealType = "";
    if (msg.DOT === appConstants.STOP_ORD_TYPE) {
      dealType = `${msg.ISOTO ? 'OTO Stop ': ''}STOP ${parseInt(msg.DT) === appConstants.TRADER_BUY ? `BUY ` : `${msg.ISOTO ? 'OTO Stop ': ''}SELL`}`;
    } else {
      dealType = parseInt(msg.DT) === appConstants.TRADER_BUY ? `${msg.ISOTO ? 'OTO Limit ': ''}${LoopdealType}BUY` : `${msg.ISOTO ? 'OTO Limit ': ''}${LoopdealType}SELL`;
    }
    remark = remark + dealType;
  }
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
  remark = remark + " @" + " " + (msg.R
    ? (Number(parseFloat(msg.R)).toLocaleString('en', { minimumFractionDigits: dec }))
    : "0") + " ";
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  remark = remark + (parseInt(msg.VT) === appConstants.GTD
    ? "GTD: " + moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat)
    : (parseInt(msg.VT) === appConstants.DAY
      ? "DAY: 1700 NYC"
      : "GTC"));

  if (msg.AC)
    remark = remark + " for " + msg.AD;
  remark = remark + " [" + msg.UCD + "]";
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  if (msg.RMK !== "" && msg.RMK !== " ")
    remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
  obj.remark = remark + ".";
  item.unshift(obj);
  return item;
}
export function getLimitOrderreject(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.isRejectFlag = true;
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NOD
    ? msg.NOD
    : "");
  let rate, validity, qty, time;
  let remark = "";
  let dealType = "";
  remark = remark + "Your Order request was unsuccessful: ";
  qty = msg.PQ;
  
  if (msg.OT === appConstants.OTO_ORD_TYPE || msg.OT === appConstants.OCO_ORD_TYPE) {
    if (msg.OrderDet) {
      let OrderDet = msg.OrderDet[0];
      dealType = getDealType(msg.OT, OrderDet.DOT, OrderDet.DT, false, msg.INLOOP, msg.ISOTO);
      rate = OrderDet.R;
      if (OrderDet.PQ) {
        qty = OrderDet.PQ
      } else {
        qty = msg.PQ
      }
      if (OrderDet.VT) {
        validity = OrderDet.VT
      } else {
        validity = msg.VT
      }
      if (OrderDet.TIME) {
        time = OrderDet.TIME
      } else {
        time = msg.TIME
      }
    } else {
      rate = msg?.R
    }
    remark += dealType;
  } else {
    if (msg.OT === appConstants.STOP_ORD_TYPE) {
      remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "Stop BUY" : "Stop SELL");
    } else {
      remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    }
    rate = msg.R;
    validity = msg.VT;
    qty = msg.PQ
    time = msg.TIME
  }
  qty = (Number(parseFloat(qty)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + qty;
  remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
  remark = remark + " @" + " " + (rate
    ? (Number(parseFloat(rate)).toLocaleString('en', { minimumFractionDigits: dec }))
    : "0") + " ";
  remark = remark + (msg.ST ? msg.ST : "");
  remark = remark + (parseInt(validity) === appConstants.GTD
    ? "GTD: " + moment(parseFloat(time)).format(appConstants.validityDateFormat)
    : (parseInt(validity) === appConstants.DAY
      ? "DAY: 1700 NYC"
      : "GTC"));

  if (msg.AC)
    remark = remark + " for " + msg.AD;
  remark = remark + " [" + msg.UCD + "]";
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  if (msg.RMK !== "" && msg.RMK !== " ")
    remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
  obj.remark = remark + ".";
  item.unshift(obj);
  return item;
}
export function getLimitOrderPlcRecd(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NOD
    ? msg.NOD
    : "");
  let remark = "";
  let isDisplay=true;
  let LoopdealType = `${msg.INLOOP ? ' (L) ' : ' '}`;
  if (msg.BCM === appConstants.ORD_PLACED && msg.OMT === appConstants.NEWORD) {
    remark = remark + "Order Placed: ";
  } else if (msg.BCM === appConstants.ORD_ACTIVATED) {
    remark = remark + "Order Activated: ";
  } else if (msg.BCM !== appConstants.ORD_ACTIVATED && msg.OMT === appConstants.MODORD) {
    remark = remark + "Order Modified: ";
  } else if (msg.OMT === appConstants.CANCELORD) {
    remark = remark + "Order Cancelled: ";
  }
  if (msg.OT === appConstants.STOP_ORD_TYPE) {
    remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? `${msg.ISOTO ? 'OTO ': ''}Stop${LoopdealType}BUY` : `${msg.ISOTO ? 'OTO ': ''}Stop${LoopdealType}SELL`);
    isDisplay=true;
  } else if (msg.OT === appConstants.LMT_ORD_TYPE){
    remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? `${msg.ISOTO ? 'OTO ': ''}Limit${LoopdealType}BUY` : `${msg.ISOTO ? 'OTO ': ''}Limit${LoopdealType}SELL`);
    isDisplay=true;
  } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
    let dealType = "";
    if (msg.DOT === appConstants.STOP_ORD_TYPE) {
      dealType = `${msg.ISOTO ? 'OTO ': ''}OCO Stop ` + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    } else {
      dealType = `${msg.ISOTO ? 'OTO ': ''}OCO Limit ` + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    }
    remark = remark + dealType;
    isDisplay=false;
    if(msg.OT === appConstants.OCO_ORD_TYPE && !msg.isUserCancel && !msg.NFD && msg.OMT === appConstants.CANCELORD){
      isDisplay=true;
    }
    if(msg.OT === appConstants.OCO_ORD_TYPE && msg.isUserCancel){
      isDisplay=true;
    }
    if (msg.OMT === appConstants.MODORD || msg.OMT === appConstants.NEWORD) {
      isDisplay=true;
    }
  } else {
    let dealType = "";
    if (msg.DOT === appConstants.STOP_ORD_TYPE) {
      dealType = `${msg.ISOTO ? 'OTO Stop ': ''}STOP ${parseInt(msg.DT) === appConstants.TRADER_BUY ? `BUY${LoopdealType}` : `${msg.ISOTO ? 'OTO Stop ': ''}SELL${LoopdealType}`}`;
    } else {
      dealType = parseInt(msg.DT) === appConstants.TRADER_BUY ? `${msg.ISOTO ? 'OTO Limit ': ''}BUY${LoopdealType}` : `${msg.ISOTO ? 'OTO Limit ': ''}SELL${LoopdealType}`;
    }
    remark = remark + dealType;
    isDisplay=true;
  }
  if (msg.OMT === appConstants.CANCELORD) {
    let TFQ = (msg.TFQ !== undefined ? msg.TFQ : 0);
    let GQ = (msg.GQ !== undefined ? msg.GQ : msg.PQ);
    remark = remark + " " + (Number(parseFloat(GQ) - parseFloat(TFQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
  }
  else {
    remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
  }
  remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
  remark = remark + " @" + " " + (msg.R
    ? (Number(parseFloat(msg.R)).toLocaleString('en', { minimumFractionDigits: dec, maximumFractionDigits: dec }))
    : "0") + " ";
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  remark = remark + (parseInt(msg.VT) === appConstants.GTD
    ? "GTD: " + moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat)
    : (parseInt(msg.VT) === appConstants.DAY
      ? "DAY: 1700 NYC"
      : "GTC"));

  if (msg.AC)
    remark = remark + " for " + msg.AD;
  remark = remark + " [" + msg.UCD + "]";
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  if (msg.RMK !== "" && msg.RMK !== " ")
    remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
  obj.remark = remark + ".";
  if(isDisplay){
    item.unshift(obj);
  }  return item;
}
export function getBmkOrderReqRecd(msg, activityLog, cmdtypair, benchmark) {
  const item = Object.assign([], activityLog);
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.ONB
    ? msg.ONB
    : "");
  let remark = "";
  if (msg.OMT === appConstants.NEWORD) {
    remark = remark + "Benchmark Order request received " + (msg.ISAPPLY ? "[" + moment(msg.FD).format(appConstants.shortDateFormat) + " to " + moment(msg.TD).format(appConstants.shortDateFormat) + "]: "
      : "[" + moment(msg.FD).format(appConstants.shortDateFormat) + "]: ");
    remark = remark + "(" + (msg.BMN ? msg.BMN : "") + ") ";
  } else if (msg.OMT === appConstants.MODORD) {
    let bmData = benchmark.benchMrkMap.get(msg.ONB);
    remark = "Modify Benchmark Order request received " + (msg.ISAPPLY ? "[" + moment(msg.FD).format(appConstants.shortDateFormat) + " to " + moment(msg.TD).format(appConstants.shortDateFormat) + "]: "
      : "[" + moment(bmData.DD).format(appConstants.shortDateFormat) + "]: ");
    remark = remark + "(" + (msg.BMN ? msg.BMN : "") + ") ";
  } else if (msg.OMT === appConstants.CANCELORD) {
    remark = remark + `Cancel Benchmark Order request received [${moment(msg.DD).format(appConstants.shortDateFormat)}]: `;
    remark = remark + "(" + (msg.BMN ? msg.BMN : "") + ") ";
  }
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL");
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : "");
  remark = remark + (msg.ST ? msg.ST : "");
  const isFwdEnableForBMK = localStorage.getItem('isFwdEnableForBMK');
  if(isFwdEnableForBMK === true) {
  let forwardPerc = msg.FWDPER !== undefined ? ` Fwd: ${msg.FWDPER === 0 ? '0.00' : msg.FWDPER}%` : '';
  remark = remark + ` (Value Date: ${moment(msg.VD).format(appConstants.shortDateFormat)}${forwardPerc})`;
  }
  if (msg.AC)
    remark = remark + " for " + msg.AD;
  remark = remark + " [" + msg.UCD + "]";
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  if (msg.RMK !== "" && msg.RMK !== " ")
    remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
  obj.remark = remark + ".";
  item.unshift(obj);
  return item;
}
export function getBmkOrderPlcRecd(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.ONB ? msg.ONB : msg.ONB);
  let remark = "";
  remark = remark +  "Benchmark Order Placed " + (msg.REPEAT ? "[" + moment(msg.FD).format(appConstants.shortDateFormat) + " to " + moment(msg.TD).format(appConstants.shortDateFormat) + "]: "
  : "[" + moment(msg.DD).format(appConstants.shortDateFormat) + "]: ");
  remark = remark + "(" + (msg.BMN ? msg.BMN : "") + ") "
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY" :
    "SELL");
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
  remark = remark + (msg.ST ? msg.ST : "");
  const isFwdEnableForBMK = localStorage.getItem('isFwdEnableForBMK');
  if(isFwdEnableForBMK === true) {
  let forwardPerc = msg.FWDPER !== undefined ? ` Fwd: ${msg.FWDPER === 0 ? '0.00' : msg.FWDPER}%` : '';
  remark = remark + ` (Value Date: ${moment(msg.VD).format(appConstants.shortDateFormat)}${forwardPerc})`;
  }
  if (msg.AC)
    remark = remark + " for " + msg.AD;
  remark = remark + " [" + msg.UCD + "]";
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  if (msg.RMK !== "" && msg.RMK !== " ")
    remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
  obj.remark = remark + '.';
  item.unshift(obj);
  // });
  return item;
}

export function getBmkOrderFailed(msg, activityLog) {
  var obj = {};
  var details = JSON.parse(msg.Details);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (details.ONB
    ? details.ONB
    : "");
  let remark = '';
  if (details.OMT === 1) {
    remark = 'Benchmark request failed. ';
  } else if (details.OMT === 2) {
    remark = 'Modify Benchmark request Failed. ';
  } else if (details.OMT === 6) {
    remark = 'Cancel Benchmark request failed. ';
  } else {
    remark = remark;
  }
  remark = remark + (details.desc ? details.desc : "");
  obj.remark = remark;
  activityLog.unshift(obj);
  localStorage.setItem('activityLog', JSON.stringify(activityLog));
  return activityLog;
}

export function getInvalidBmkOrder(msg, activityLog, invalidBmFlag) {
  var obj = {};
  //var details = JSON.parse(msg.Details);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.isRejectFlag = true;
  obj.docNo = (msg.ONB ? msg.ONB : "");
  let remark = '';
  remark = remark + (msg.MSG ? msg.MSG : "");
  obj.remark = remark;
  activityLog.unshift(obj);
  localStorage.setItem('activityLog', JSON.stringify(activityLog));
  return activityLog;
}

export function getDefAccChngRemark(msg, activityLog){
  let obj = {};
  obj.det = moment().format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = ""; 
  let remark = msg?.MSG;
  obj.remark = remark + ".";
  activityLog.unshift(obj);
  return activityLog;
}

export function getBmkOrderModify(msg, activityLog, cmdtypair, benchmark) {
  const item = Object.assign([], activityLog);
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = msg.ISAPPLY ? msg.ONB : msg.BMSET[0].DN;
  let remark = "";
  let bmData = benchmark.benchMrkMap.get(obj.docNo);
  remark = "Benchmark Order Modified " + (msg.ISAPPLY ? "[" + moment(msg.FD).format(appConstants.shortDateFormat) + " to " + moment(msg.TD).format(appConstants.shortDateFormat) + "]: "
    : "[" + moment(bmData.DD).format(appConstants.shortDateFormat) + "]: ");
  remark = remark + "(" + (msg.BMN ? msg.BMN : "") + ") "
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL");
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair);
  remark = remark + (msg.ST ? msg.ST : "");
  const isFwdEnableForBMK = localStorage.getItem('isFwdEnableForBMK');
  if(isFwdEnableForBMK === true) {
  let forwardPerc = msg.FWDPER !== undefined ? ` Fwd: ${msg.FWDPER === 0 ? '0.00' : msg.FWDPER}%` : '';
  remark = remark + ` (Value Date: ${moment(msg.VD).format(appConstants.shortDateFormat)}${forwardPerc})`;
  }
  if (msg.AC)
    remark = remark + " for " + msg.AD;
  remark = remark + " [" + msg.UCD + "]";
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  if (msg.RMK !== "" && msg.RMK !== " ")
    remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
  obj.remark = remark + ".";
  item.unshift(obj);
  // });
  return item;
}
export function getBenchMarkOrderreject(msg, activityLog, cmdtyPair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.isRejectFlag = true;
  obj.docNo = (msg.ONB ? msg.ONB : "");
  let remark = "";
  remark = remark + `Your Benchmark Order request was unsuccessful [${moment(msg.FD).format(appConstants.shortDateFormat)}]: `;
  remark = remark + "(" + (msg.BMN
    ? msg.BMN
    : "") + ") "
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL");
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC !== undefined
    ? msg.SC + " " + cmdtyPair : "");
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  const isFwdEnableForBMK = localStorage.getItem('isFwdEnableForBMK');
  if(isFwdEnableForBMK === true) {  
  let forwardPerc = msg.FWDPER !== undefined ? ` Fwd: ${msg.FWDPER === 0 ? '0.00' : msg.FWDPER}%` : '';
  remark = remark + ` (Value Date: ${moment(msg.VD).format(appConstants.shortDateFormat)}${forwardPerc})`; 
  } 
  if (msg.AC)
    remark = remark + " for " + msg.AD;
  remark = remark + " [" + msg.UCD + "]";
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  if (msg.RMK !== "" && msg.RMK !== " ")
    remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
  obj.remark = remark + ".";
  item.unshift(obj);
  return item;
}
export function getBmkOrderCancelModify(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.ONB
    ? msg.ONB
    : "");
  let remark = "";
  if (msg.OMT === appConstants.CANCELORD) {
    remark = remark + `Benchmark Order Cancelled [${moment(msg.DD).format(appConstants.shortDateFormat)}]: `;
  }
  remark = remark + "(" + (msg.BMN
    ? msg.BMN
    : "") + ") "
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL");
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC !== undefined ? msg.SC + " " + cmdtypair : cmdtypair)
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  const isFwdEnableForBMK = localStorage.getItem('isFwdEnableForBMK');
  if(isFwdEnableForBMK === true) {
  let forwardPerc = msg.FWDPER !== undefined ? ` Fwd: ${msg.FWDPER === 0 ? '0.00' : msg.FWDPER}%` : '';
  remark = remark + ` (Value Date: ${moment(msg.VD).format(appConstants.shortDateFormat)}${forwardPerc})`;
  }
  if (msg.AC)
    remark = remark + " for " + msg.AD;
  remark = remark + " [" + msg.UCD + "]";
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  if (msg.RMK !== "" && msg.RMK !== " ")
    remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
  obj.remark = remark + ".";
  item.unshift(obj);
  return item;
}
export function getBmkOrderFillRecd(msg, activityLog, cmdtypair) {
  try {
    const item = Object.assign([], activityLog);
    var dec = getBMKDecimal(msg.IID);
    var mindec = getMinBMKDecimal(msg.IID);
    let qty = (msg.OT === 5 ? msg.PQ : msg.QPF);
    let orderNo = (msg.OT === 5 ? msg.ONB : msg.AVG);
    var obj = {};
    obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
    obj.docNo = (msg.FNC
      ? msg.FNC
      : "");
    let remark = "";
    remark = remark + (msg.OT !== 5 ? 'Avg ' : '') + `Benchmark Order Filled [${moment(msg.DD).format(appConstants.shortDateFormat)}]: `;
    remark = remark + "(" + (msg.BMN
      ? msg.BMN
      : "") + ") "
    remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
      ? "BOUGHT"
      : "SOLD");
    remark = remark + " " + (Number(parseFloat(qty)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
    remark = remark + " " + (msg.SC
      ? msg.SC
      : "");
    remark = remark + " " + cmdtypair;
    remark = remark + " @";
    remark = remark + " ";
    remark = remark + (msg.FP
      ? (parseFloat(msg.FP).toLocaleString('en', { minimumFractionDigits: mindec, maximumFractionDigits: dec }))
      : 0) + " ";

    const isFwdEnableForBMK = localStorage.getItem('isFwdEnableForBMK');
    if(isFwdEnableForBMK === true) {  
    let forwardPerc = msg.FWDPER !== undefined ? ` Fwd: ${msg.FWDPER === 0 ? '0.00' : msg.FWDPER}%` : '';
    remark = remark + ` (Value Date: ${moment(msg.VD).format(appConstants.shortDateFormat)}${forwardPerc})`;  
    }
    if (msg.AC)
      remark = remark + " for " + msg.AD;
    remark = remark + "(" + orderNo + ")";
    // remark = remark +" ["+ msg.UCD + "] ";
    if (msg.RMK === undefined) {
      msg.RMK = "";
    }
    if (msg.RMK !== "" && msg.RMK !== " ")
      remark = remark + "(Comments: " + (msg.RMK).trim() + ")";
    obj.remark = remark + ".";
    item.unshift(obj);
    return item;

  } catch (e) {
    console.log('e ', e)
  }
}
export function getLmtExpLog(msg, activityLog, cmdtypair) {
  const item = Object.assign([], activityLog);
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NOD
    ? msg.NOD
    : "");
  let remark = "";
  remark = remark + "Order Expired: ";
  let LoopdealType = `${msg.INLOOP ? ' (L) ' : ' '}`;
  if (msg.OT === appConstants.STOP_ORD_TYPE) {
    remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? `${msg.ISOTO ? 'OTO ': ''}Stop${LoopdealType}BUY` : `${msg.ISOTO ? 'OTO ': ''}Stop${LoopdealType}SELL`);
  } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
    let dealType = "";
    if (msg.DOT === appConstants.STOP_ORD_TYPE) {
      dealType = `${msg.ISOTO ? 'OTO ': ''}OCO Stop ` + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    } else {
      dealType = `${msg.ISOTO ? 'OTO ': ''}OCO Limit ` + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    }
    remark = remark + dealType;
  } else {
    remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? `${msg.ISOTO ? 'OTO ': ''}Limit${LoopdealType}BUY` : `${msg.ISOTO ? 'OTO ': ''}Limit${LoopdealType}SELL`);
  }

  remark = remark + " " + (Number(parseFloat(msg.GQ) - parseFloat((msg.TFQ !== undefined ? parseFloat(msg.TFQ) : 0))).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC !== undefined
    ? msg.SC + " " + cmdtypair
    : cmdtypair);
  remark = remark + " @" + " " + (msg.R
    ? (Number(parseFloat(msg.R)).toLocaleString('en', { minimumFractionDigits: dec }))
    : "0") + " ";
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  remark = remark + (parseInt(msg.VT) === appConstants.GTD
    ? "GTD: " + moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat)
    : (parseInt(msg.VT) === appConstants.DAY
      ? "DAY: 1700 NYC"
      : "GTC"));

  if (msg.AC)
    remark = remark + " for " + msg.AD;
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  if (msg.RMK !== "" && msg.RMK !== " ")
    remark = remark + " (Comments: " + (msg.RMK).trim() + ")";
  obj.remark = remark + ".";
  item.unshift(obj);
  return item;
}
export function getLmtOrderFillRecd(msg, activityLog, cmdtypair) {
  try {
    const item = Object.assign([], activityLog);
    var obj = {};
    var status = (msg.OMT === 10 || msg.OMT === 5 ? "Order Filled" : "Order Partially Filled");
    let qty = (msg.OMT === 4 ? msg.FQ : msg.TFQ);
   // var dec = getDecimal(msg.IID);
    var amntDec = getAmntDecimal(msg.IID);
    var minDec = getMinAmntDecimal(msg.IID);

    obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
    obj.docNo = (msg.NFD
      ? msg.NFD
      : "");
    let remark = "";
    remark = remark + status + ": ";  // + msg.UCD + " ";
    remark = remark +(parseInt(msg.DT) === appConstants.TRADER_BUY ? "BOUGHT" : "SOLD");
    remark = remark + " " + (Number(parseFloat(qty)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits: config.QuantityRoundOff }));
    remark = remark + " " + (msg.SC !== undefined
      ? msg.SC + " " + cmdtypair
      : cmdtypair);
    remark = remark + " @" + " " + (msg.DR
      ? (Number(parseFloat(msg.DR)).toLocaleString('en', { minimumFractionDigits: minDec, maximumFractionDigits: amntDec }))
      : "0") + " ";
    remark = remark + (msg.ST
      ? msg.ST
      : "");
    remark = remark + (parseInt(msg.VT) === appConstants.GTD
      ? "GTD: " + moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat)
      : (parseInt(msg.VT) === appConstants.DAY
        ? "DAY: 1700 NYC"
        : "GTC"));

    if (msg.AC)
      remark = remark + " for " + msg.AD;
    remark = remark + " ( " + msg.NOD + " )";
    // remark = remark +" ["+ msg.UCD + "] ";
    if (msg.RMK === undefined) {
      msg.RMK = "";
    }
    if (msg.RMK !== "" && msg.RMK !== " ")
      remark = remark + "(Comments: " + (msg.RMK).trim() + ")";
    obj.remark = remark + ".";
    item.unshift(obj);
    return item;
  } catch (e) { console.log(e) }
}
export function activityuserLoggedIn(msg, activityLog) {
  if (msg.BCM === appConstants.TRD_LOGIN) {
    var obj = {};
    obj.det = moment().format(appConstants.actTimeDateTimeFormatter);
    obj.docNo = "";
    let remark = msg.MSG;
    obj.remark = remark;
    activityLog.unshift(obj);
    localStorage.setItem('activityLog', JSON.stringify(activityLog));
    return activityLog;
  }
}
const getPayDecimal = (CCYG) => {
  let qtyDec;
  if (CCYG === 'M') {
    qtyDec = 3;
  } else {
    qtyDec = 2;
  }
  return qtyDec;
}
export function getPayReqLog(msg, activityLog) {
  let defaultAC = JSON.parse(localStorage.getItem('DefaultAC'));
  if (msg.AC === defaultAC.AC) {
    let accDes = msg.AD;
    if (msg.AD === undefined) {
      if (defaultAC.AC === msg.AC) {
        accDes = defaultAC.AD;
      }
    }

    let qtyDec = getPayDecimal(msg.CCYG);
    if (msg.BCM === appConstants.PAYMENT_REQUEST_PLACED) {

      var obj = {};
      obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
      obj.docNo = (msg.DN
        ? msg.DN
        : "");
      let remark = '';
      if (msg.OMT === 1) {
        remark = 'Place Payment Request: ';
      } else if (msg.OMT === 2) {
        remark = 'Modify Payment Request: ';
      } else if (msg.OMT === 6) {
        remark = 'Cancel Payment Request: ';
      } else {
        remark = remark;
      }
      remark = remark + " For " + accDes + ", " + msg.CCYN + " " + parseFloat(msg.PQ).toLocaleString('en', { minimumFractionDigits: qtyDec });
      remark = remark + " [" + msg.UCD + "] ";

      obj.remark = remark;
      activityLog.unshift(obj);
      localStorage.setItem('activityLog', JSON.stringify(activityLog));
      return activityLog;
    } else if (msg.BCM === appConstants.PAYMENT_REQ_UPDATE) {
      var obj = {};
      obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
      obj.docNo = (msg.DN
        ? msg.DN
        : "");
      let remark = '';
      if (msg.OMT === 1) {
        remark = 'Payment Request Placed: ';
      } else if (msg.OMT === 2) {
        remark = 'Payment Request Modified: ';
      } else if (msg.OMT === 6) {
        remark = 'Payment Request Cancelled: ';
      } else {
        remark = remark;
      }
      remark = remark + " For " + accDes + ", " + msg.CCYN + " " + parseFloat(msg.PQ).toLocaleString('en', { minimumFractionDigits: qtyDec, maximumFractionDigits: qtyDec });
      remark = remark + " [" + msg.PRUSER + "].";
      obj.remark = remark;
      activityLog.unshift(obj);
      localStorage.setItem('activityLog', JSON.stringify(activityLog));
      return activityLog;
    } else if (msg.BCM === appConstants.PAYMENT_REQUEST_FAIL) {
      var obj = {};
      obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
      obj.docNo = (msg.DN
        ? msg.DN
        : "");
      let remark = '';
      if (msg.OMT === 1) {
        remark = 'Payment request failed. ';
      } else if (msg.OMT === 2) {
        remark = 'Modify payment request Failed. ';
      } else if (msg.OMT === 6) {
        remark = 'Cancel Payment request failed. ';
      } else {
        remark = remark;
      }
      remark = remark + (msg.MSG ? msg.MSG : "");
      //remark = remark + " For " + accDes ; //+", "+msg.CCYN +" "+(parseFloat(msg.PQ).toFixed(config.QuantityRoundOff));
      //remark = remark +" ["+ msg.UCD + "] ";
      obj.remark = remark;
      activityLog.unshift(obj);
      localStorage.setItem('activityLog', JSON.stringify(activityLog));
      return activityLog;
    } else if (msg.BCM === appConstants.PAYMENT_REQUEST_APRVREJ) {
      var obj = {};
      obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
      obj.docNo = (msg.DN
        ? msg.DN
        : "");
      let RSC = '';
      if (msg.RSC === 'APR') {
        RSC = 'Approved';
      } else if (msg.RSC === 'CMPLT') {
        RSC = 'Completed';
      } else {
        RSC = 'Rejected';
      }
      let remark = 'Your Payment Request ' + RSC + ".";
      remark = remark + (msg.MSG ? msg.MSG : "");
      remark = remark + " for " + accDes + ", " + msg.CCYN + " " + (parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: qtyDec, maximumFractionDigits: qtyDec });
      remark = remark + " [" + msg.PRUSER + "].";
      obj.remark = remark;
      activityLog.unshift(obj);
      localStorage.setItem('activityLog', JSON.stringify(activityLog));
      return activityLog;
    } else {
      localStorage.setItem('activityLog', JSON.stringify(activityLog));
      return activityLog;
    }
  } else {
    localStorage.setItem('activityLog', JSON.stringify(activityLog));
    return activityLog;
  }
}
export function actLogGenerator(msg, activityLog, benchmark, invalidBmFlag, isFwdFlag = false) {
  let cmdtypair;
  const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  cmdtypair = item.ID
  switch (msg.BCM) {
    case appConstants.INITIAL_CHECKS_FAILED:
    case appConstants.MARGIN_CHECKS_FAILED:
      var obj = marginCheckNotification(msg, activityLog);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj); //dispatch(break;
    case appConstants.TRADE_REQUEST_RECEIVED:
      let reqRecivedObj;
      if (isFwdFlag) {
        reqRecivedObj = getFWDTradeRcvdRemark(msg, activityLog);
      } else {
        reqRecivedObj = getDealRcvdLogRmk(msg, activityLog, cmdtypair);
      }
      localStorage.setItem('activityLog', JSON.stringify(reqRecivedObj));
      return reqRecivedObj;      
    case appConstants.TRADE_REQUEST_REJCTED:
      var obj = getRejectedDealLogRemark(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.TRADE_REQUEST_CONFIRMED:
      let reqConfirmedObj;
      if (isFwdFlag) {
        reqConfirmedObj = getFWDTradeConfirmedRemark(msg, activityLog);
      } else {
        reqConfirmedObj = getConfirmedDealLogRemark(msg, activityLog, cmdtypair);
      }
      localStorage.setItem('activityLog', JSON.stringify(reqConfirmedObj));
      return reqConfirmedObj;
    case appConstants.FWD_NORATES_STREAM:
      let noRatesObj;
      noRatesObj = getFwdNoRatesLogRemark(msg, activityLog); 
      localStorage.setItem('activityLog', JSON.stringify(noRatesObj));
      return noRatesObj; 
    case appConstants.FWD_ORD_REJECT:
      let ordRejectObj;
      ordRejectObj = getFwdOrdRejectLogRemark(msg, activityLog); 
      localStorage.setItem('activityLog', JSON.stringify(ordRejectObj));
      return ordRejectObj;     
    case appConstants.SWP_ORD_REJECT:
      let swpRejectObj;
      swpRejectObj = getSwpOrdRejectLogRemark(msg, activityLog); 
      localStorage.setItem('activityLog', JSON.stringify(swpRejectObj));
      return swpRejectObj;      
    case appConstants.ORD_REQ_RECD:
      var obj = getLimitOrderReqRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.ORDER_REQUEST_REJECT:
      var obj = getLimitOrderreject(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.REQUEST_REJECT:
      var obj = getLimitOrderreject(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.ORD_PLACED:
    case appConstants.ORD_ACTIVATED:
      var obj = getLimitOrderPlcRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
    case appConstants.BENCHMARK_REQ_RECD:
      var obj = getBmkOrderReqRecd(msg, activityLog, cmdtypair, benchmark);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.BM_PLACED:
      var obj = getBmkOrderPlcRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.MODIFY_REQ_RECD:
      var obj = getLimitOrderReqRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.ORD_CANCEL_REQUEST:
      var obj = getLimitOrderReqRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.ORD_CANCEL:
      var obj = getLimitOrderPlcRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.ORD_MODIFIED:
      var obj = getLimitOrderPlcRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.BENCHMARK_MOD_REQ_RECD:
      var obj = getBmkOrderReqRecd(msg, activityLog, cmdtypair, benchmark);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.BM_MODIFIED:
      var obj = getBmkOrderModify(msg, activityLog, cmdtypair, benchmark);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.BENCHMARK_CANC_REQ_RECD:
      var obj = getBmkOrderReqRecd(msg, activityLog, cmdtypair, benchmark);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.BM_CANCELLED:
      var obj = getBmkOrderCancelModify(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.BENCHMARK_MANUAL_FILL:
      var obj = getBmkOrderFillRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    // case appConstants.BENCHMARK_MANUAL_FILL:
    // var obj=getBmkOrderFillRecd(msg,activityLog,cmdtypair);
    // localStorage.setItem('activityLog',JSON.stringify(obj));
    // return(obj);
    // break;
    case appConstants.BM_REJECTED:
      var obj = getBenchMarkOrderreject(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.ORDER_UNHEDGE_EXPIRED:
      var obj = getLmtExpLog(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.ORDER_EXPIRED:
      var obj = getLmtExpLog(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.ORD_HEDGE_FILL:
      var obj = getLmtOrderFillRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.ORD_UNHEDGE_FILL:
      var obj = getLmtOrderFillRecd(msg, activityLog, cmdtypair);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.PAYMENT_REQUEST_PLACED:
      var obj = getPayReqLog(msg, activityLog);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.PAYMENT_REQ_UPDATE:
      var obj = getPayReqLog(msg, activityLog);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.PAYMENT_REQUEST_APRVREJ:
      var obj = getPayReqLog(msg, activityLog);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.PAYMENT_REQUEST_FAIL:
      var obj = getPayReqLog(msg, activityLog);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    // case appConstants.BENCHMARK_REQ_FAILED:
    //   var obj=getBmkOrderFailed(msg,activityLog);
    //   localStorage.setItem('activityLog',JSON.stringify(obj));
    //   return(obj);
    // break;
    case appConstants.INVALID_BENCHMARK_REQUEST:
      var obj = getInvalidBmkOrder(msg, activityLog, invalidBmFlag);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;
    case appConstants.DEFAULT_ACC_CHANGE:
      var obj = getDefAccChngRemark(msg, activityLog);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);
      break;  
    case appConstants.SWP_REQUEST_RECIEVED:
      var obj= getSWPTradeRcvdRemark(msg, activityLog);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);  
    case appConstants.SWAP_PLACED:
      var obj= getSWPTradeConfirmedRemark(msg, activityLog);
      localStorage.setItem('activityLog', JSON.stringify(obj));
      return (obj);  
    default:
      localStorage.setItem('activityLog', JSON.stringify(activityLog));
      return (activityLog);
  }
}
export function ordcnfrmsgGenerator(msg, ordcnfrmsg) {
  try {
    if (msg.OT === appConstants.LMT_ORD_TYPE || msg.OT === appConstants.STOP_ORD_TYPE || msg.OT === appConstants.OCO_ORD_TYPE || msg.OT === appConstants.OTO_ORD_TYPE) {
      const orderType = getOrderType(msg.OT);
      if (msg.UID !== JSON.parse(localStorage.getItem('user')).id) {
        localStorage.setItem('ordcnfrmsg', JSON.stringify(ordcnfrmsg));
        return ordcnfrmsg;
      } else {
        if (msg.BCM === appConstants.MARGIN_CHECKS_FAILED || msg.BCM === appConstants.INITIAL_CHECKS_FAILED) {
          var obj = {};
          obj.CTID = (msg.OT === appConstants.OCO_ORD_TYPE ? " " : msg.CTID);
          obj.remark1 = `${orderType} Order Placed`;
          obj.remark2 = "Your trade request was unsuccessful. Please see the Activity Log for details.";
          obj.IID = msg.IID;
          obj.orderType = msg.OT;
          obj.BCM = msg.BCM;
          if (msg.OT === appConstants.OCO_ORD_TYPE && localStorage.getItem('ocoOrderPopout')) {
            localStorage.setItem('ocoOrdMsg', JSON.stringify(obj));
          } else {
            localStorage.setItem('ordcnfrmsg', JSON.stringify(obj));
          }
          return obj;
        } else if (appConstants.ORD_PLACED === msg.BCM) {
          try {
            var obj = {};
            if ((msg.OT !== appConstants.OCO_ORD_TYPE && msg.modifyLinkOrd !== true) && (!msg.ISOTO)) {
              let dealType = (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
              var dec = getDecimal(msg.IID);
              const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
              let metal = item.D1;
              let curr = item.D2;
              let remark2 = "";
              remark2 = dealType + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
                ? msg.SC : "") + " " + metal + "/" + curr + " @" + " " + (msg.R ? (Number(parseFloat(msg.R)).toLocaleString('en', { minimumFractionDigits: dec })) : "0") + " ";

              remark2 = remark2 + (parseInt(msg.VT) === appConstants.GTD ? "GTD: " + moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat)
                : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
              obj.remark1 = `${orderType} Order Placed`;
              obj.remark2 = remark2;
              obj.IID = msg.IID;
              obj.CTID = msg.CTID;
              obj.orderType = msg.OT;
              obj.docNo = msg.NOD;
              localStorage.setItem('ordcnfrmsg', JSON.stringify(obj));
              return obj;
            }
          } catch (e) {
            console.log(" e" + e);
          }

        } else if (!msg?.ISOTO && appConstants.OCO_ORD_BCM === msg.BCM && appConstants.NEWORD === msg.OMT) {
          try {
            let order1DT = getDealType(msg.OT, msg.DOT, msg.DT)
            let order2DT = getDealType(msg.OT, msg.LINKORD_DOT, msg.LINKORD_DT);
            var obj = {};
            var dec = getDecimal(msg.IID);
            const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
            let metal = item.D1;
            let curr = item.D2;
            let ocoOrd1Rmk = `Order 1: ${order1DT}` + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
              ? msg.SC : "") + " " + metal + "/" + curr + " @" + " " + (msg.R ? (Number(parseFloat(msg.R)).toLocaleString('en', { minimumFractionDigits: dec })) : "0") + " ";
            ocoOrd1Rmk = ocoOrd1Rmk + (parseInt(msg.VT) === appConstants.GTD ? "GTD: " + moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat)
              : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));

            let ocoOrd2Rmk = `Order 2: ${order2DT}` + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
              ? msg.SC : "") + " " + metal + "/" + curr + " @" + " " + (msg.LINKORD_R ? (Number(parseFloat(msg.LINKORD_R)).toLocaleString('en', { minimumFractionDigits: dec })) : "0") + " ";
            ocoOrd2Rmk = ocoOrd2Rmk + (parseInt(msg.VT) === appConstants.GTD ? "GTD: " + moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat)
              : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));

            obj.remark1 = `${orderType} Order Placed`;
            obj.remark2 = ocoOrd1Rmk;
            obj.remark3 = ocoOrd2Rmk;
            obj.IID = msg.IID;
            obj.CTID = msg.CTID;
            obj.CTID2 = msg.LINKORD_CTID;
            obj.orderType = msg.OT;
            obj.docNo = msg.NOD;
            obj.docNo2 = msg.LINKORD_ONG;
            if (msg.OT === appConstants.OCO_ORD_TYPE && JSON.parse(localStorage.getItem('ocoOrderPopout')) === true) {
              localStorage.setItem('ocoOrdMsg', JSON.stringify(obj));
            }
            return obj;
          } catch (e) {
            console.log(" e" + e);
          }
        } else if (!!msg?.ISOTO && appConstants.OCO_ORD_BCM === msg.BCM && appConstants.NEWORD === msg.OMT) {    
          try {
            let order1DT = getDealType(msg.OT, msg.DOT, msg.DT)
            let order2DT = getDealType(msg.LINKORD_OT, msg.LINKORD_DOT, msg.LINKORD_DT, msg.ISOCO);
            let order3DT, ocoOrd3Rmk;
            
            var obj = {};
            var dec = getDecimal(msg.IID);
            const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
            let metal = item.D1;
            let curr = item.D2;
            let ocoOrd1Rmk = `Order 1: ${order1DT}` + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
              ? msg.SC : "") + " " + metal + "/" + curr + " @" + " " + (msg.R ? (Number(parseFloat(msg.R)).toLocaleString('en', { minimumFractionDigits: dec })) : "0") + " ";
            ocoOrd1Rmk = ocoOrd1Rmk + (parseInt(msg.VT) === appConstants.GTD ? "GTD: " + moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat)
              : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));

            let ocoOrd2Rmk = `Order 2: ${msg.hasOwnProperty("OCO_LINKORD_CTID") ? "(" + order2DT : order2DT}` + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
              ? msg.SC : "") + " " + metal + "/" + curr + " @" + " " + (msg.LINKORD_R ? (Number(parseFloat(msg.LINKORD_R)).toLocaleString('en', { minimumFractionDigits: dec })) : "0") + " ";
            ocoOrd2Rmk = ocoOrd2Rmk + (parseInt(msg.LINKORD_VT) === appConstants.GTD ? "GTD: " + moment(parseFloat(msg.LINKORD_TIME)).format(appConstants.validityDateFormat)
              : (parseInt(msg.LINKORD_VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));

            // OTO-OCO orders
            if (msg.hasOwnProperty("OCO_LINKORD_CTID")) {
              // get order type
              order3DT = getDealType(msg.OCO_LINKORD_OT, msg.OCO_LINKORD_DOT, msg.OCO_LINKORD_DT, true);
              
              // generate remark
              ocoOrd2Rmk += `) / (${order3DT}` + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
                ? msg.SC : "") + " " + metal + "/" + curr + " @" + " " + (msg.OCO_LINKORD_R ? (Number(parseFloat(msg.OCO_LINKORD_R)).toLocaleString('en', { minimumFractionDigits: dec })) : "0") + " ";
              ocoOrd2Rmk += (parseInt(msg.LINKORD_VT) === appConstants.GTD ? "GTD: " + moment(parseFloat(msg.LINKORD_TIME)).format(appConstants.validityDateFormat)
                : (parseInt(msg.LINKORD_VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")) + ")";

              obj.remark4 = ocoOrd3Rmk;
              obj.CTID3 = msg.OCO_LINKORD_CTID;
              obj.docNo3 = msg.OCO_LINKORD_ONG;
            }

            obj.remark1 = `${orderType} Order Placed`;
            obj.remark2 = ocoOrd1Rmk;
            obj.remark3 = ocoOrd2Rmk;
            obj.IID = msg.IID;
            obj.CTID = msg.CTID;
            obj.CTID2 = msg.LINKORD_CTID;
            obj.orderType = msg.OT;
            obj.docNo = msg.NOD;
            obj.docNo2 = msg.LINKORD_ONG;
            if (msg.OT === appConstants.OTO_ORD_TYPE && JSON.parse(localStorage.getItem('ocoOrderPopout')) === true) {
              localStorage.setItem('ocoOrdMsg', JSON.stringify(obj));
            }
            return obj;
          } catch (e) {
            console.log(" e" + e);
          }
        } else if (msg.BCM === appConstants.ORDER_REQUEST_REJECT) {
          var obj = {};
          obj.remark1 = `${orderType} Order Placed`;
          obj.remark2 = "Your trade request was unsuccessful. Please see the Activity Log for details.";
          obj.CTID = msg.CTID;
          obj.orderType = msg.OT;
          obj.docNo = msg.NOD;
          obj.BCM = msg.BCM;
          if (msg.OT === appConstants.OCO_ORD_TYPE || msg.OT === appConstants.OTO_ORD_TYPE && localStorage.getItem('ocoOrderPopout')) {
            localStorage.setItem('ocoOrdMsg', JSON.stringify(obj));
          } else {
            localStorage.setItem('ordcnfrmsg', JSON.stringify(obj));
          }
          return obj;
        } else if (msg.BCM === appConstants.ORD_REQ_RECD) {
          localStorage.setItem('ordcnfrmsg', JSON.stringify({}));
          return ordcnfrmsg;
        } else {
          localStorage.setItem('ordcnfrmsg', JSON.stringify(ordcnfrmsg));
          return ordcnfrmsg;
        }
      }
    } else {
      var ordcnfrmsg = {};
      return ordcnfrmsg;
    }
  } catch (e) {
    console.log(" e " + e);
  }
}

// get order type
const getOrderType = (OT) => {
  switch(OT) {
    case appConstants.BMK_ORD_TYPE:
      return "Benchmark"
    case appConstants.LMT_ORD_TYPE:
      return "Limit"
    case appConstants.STOP_ORD_TYPE:
      return "Stop"
    case appConstants.OCO_ORD_TYPE:
      return "OCO"
    case appConstants.OTO_ORD_TYPE:
      return "OTO"
    default:
      return "Limit"
  }
}

//get dealType
const getDealType = (orderType, dealOrderType, DT, isOTOOCO = false, INLOOP = false, ISOTO = false) => {
  let dealType = (parseInt(DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
  let LoopdealType = `${INLOOP ? ' (L) ' : ' '}`;
  if (orderType === appConstants.OCO_ORD_TYPE) {
    if (dealOrderType === appConstants.STOP_ORD_TYPE) {
      dealType = `Stop ${dealType}`;
    } else {
      dealType = `Limit ${dealType}`;
    }
  }
  if (orderType === appConstants.OTO_ORD_TYPE) {
    if (dealOrderType === appConstants.STOP_ORD_TYPE) {
      dealType = `${ISOTO ? 'OTO ': ''}${isOTOOCO ? 'OCO ' : ''}Stop${LoopdealType}${parseInt(DT) === appConstants.TRADER_BUY ? "BUY" : "SELL"}`;
    } else {
      dealType = `${ISOTO ? 'OTO ': ''}${isOTOOCO ? 'OCO ' : ''}Limit${LoopdealType}${parseInt(DT) === appConstants.TRADER_BUY ? "BUY" : "SELL"}`;
    }
  }
  if (orderType === appConstants.STOP_ORD_TYPE) {
    dealType = `Stop ${parseInt(DT) === appConstants.TRADER_BUY ? "BUY" : "SELL"}`;
  }
  return dealType;
}
//deal cnfirmation
export function dealCnfrmsgGenerator(msg, dealcnfrmsg) {
  if (msg.UID !== JSON.parse(localStorage.getItem('user')).id) {
    localStorage.setItem('dealcnfrmsg', JSON.stringify(dealcnfrmsg));
    return dealcnfrmsg;
  } else {
    if (msg.BCM === appConstants.TRADE_REQUEST_CONFIRMED) {
      var obj = {};
      var dec = getAmntDecimal(msg.IID);
      var mindec = getMinAmntDecimal(msg.IID);

      const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
      let metal = item.D1;
      let curr = item.D2;
      let remark1 = "";
      let remark2 = "";
      if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
        remark1 = "BOUGHT" +
          " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
            ? msg.SC
            : "") + " " + metal + " @" + " " + (msg.DR
              ? (Number(parseFloat(msg.DR)).toLocaleString('en', { minimumFractionDigits: mindec, maximumFractionDigits: dec }))
              : "0") + " ";
        remark2 = "SOLD" +
          " " + curr + " " + (msg.V
            ? (Number(parseFloat(msg.V)).toLocaleString('en', { minimumFractionDigits: config.AmountRoundOFF }))
            : "0");
      } else {
        remark2 = "BOUGHT" +
          " " + curr + " " + (msg.V
            ? (Number(parseFloat(msg.V)).toLocaleString('en', { minimumFractionDigits: config.AmountRoundOFF }))
            : "0");
        remark1 = "SOLD" +
          " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
            ? msg.SC
            : "") + " " + metal + " @" + " " + (msg.DR
              ? (Number(parseFloat(msg.DR)).toLocaleString('en', { minimumFractionDigits: mindec, maximumFractionDigits: dec }))
              : "0") + " ";
      }
      obj.remark1 = remark1;
      obj.remark2 = remark2;
      obj.IID = msg.IID;
      obj.CTID = msg.CTID;
      obj.BCM = msg.BCM;
      localStorage.setItem('dealcnfrmsg', JSON.stringify(obj));
      return obj;
    } else if (msg.BCM === appConstants.TRADE_REQUEST_REJCTED) {
      var obj = {};
      let remark1 = "Your trade request was unsuccessful. Please see the Activity Log for details.";
      let remark2 = "";
      obj.remark1 = remark1;
      obj.remark2 = remark2;
      obj.CTID = msg.CTID;
      obj.BCM = msg.BCM;
      localStorage.setItem('dealcnfrmsg', JSON.stringify(obj));
      return obj;
    } else if (msg.BCM === appConstants.MARGIN_CHECKS_FAILED || msg.BCM === appConstants.INITIAL_CHECKS_FAILED) {
      var obj = {};
      obj.CTID = msg.CTID;
      obj.remark1 = "Your trade request was unsuccessful. Please see the Activity Log for details.";
      obj.remark2 = "";
      obj.IID = msg.IID;
      localStorage.setItem('dealcnfrmsg', JSON.stringify(obj));
      return obj;
    } else if (appConstants.DEAL_CONFM === msg.BCM) {
      var obj = {};
      obj.remark1 = "Your trade request is in progress";
      obj.remark2 = "";
      obj.CTID = msg.CTID;
      obj.BCM = msg.BCM;
      localStorage.setItem('dealcnfrmsg', JSON.stringify(obj));
      return obj;
    } else if (msg.BCM === appConstants.FWD_ORD_REJECT) {
      var obj = {};
      obj.remark1 = "Your trade request was unsuccessful. Please see the Activity Log for details.";
      obj.remark2 = "";
      obj.CTID = msg.CTID;
      obj.BCM = msg.BCM;
      localStorage.setItem('dealcnfrmsg', JSON.stringify(obj));
      return obj;
    } else if (msg.BCM === appConstants.SWP_ORD_REJECT) {
      var obj = {};
      obj.remark1 = "Your trade request was unsuccessful. Please see the Activity Log for details.";
      obj.remark2 = "";
      obj.CTID = msg.CTID;
      obj.BCM = msg.BCM;
      localStorage.setItem('dealcnfrmsg', JSON.stringify(obj));
      return obj;
    } else if (msg.BCM === appConstants.TRADE_REQUEST_RECEIVED) {
      localStorage.setItem('dealcnfrmsg', JSON.stringify({}));
      return dealcnfrmsg;
    } else if (msg.BCM === appConstants.SWAP_PLACED) {
      var obj = {};
      var dec = getAmntDecimal(msg.IID);
      var mindec = getMinAmntDecimal(msg.IID);

      const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
      let metal = item.D1;
      let curr = item.D2;
      let remark1 = "";
      let remark2 = "";
      if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
        remark1 = "Lend" +
          " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
            ? msg.SC
            : "") + " " + metal + "/" + curr +" "+ "from" +" "+ moment(msg.NVD).format("DD-MMM-YY") + " @" + " " + (msg.NDR
              ? (Number(parseFloat(msg.NDR)).toLocaleString('en', { minimumFractionDigits: mindec, maximumFractionDigits: dec }))
              : "0") + " ";
        remark2 = "to" +" "+ moment(msg.FVD).format("DD-MMM-YY") + " @" + " " +  (msg.FDR
          ? (Number(parseFloat(msg.FDR)).toLocaleString('en', { minimumFractionDigits: mindec, maximumFractionDigits: dec }))
          : "0") + " ";
      } else {
        remark2 = "to" +" "+ moment(msg.FVD).format("DD-MMM-YY") + " @" + " " + (msg.FDR
          ? (Number(parseFloat(msg.FDR)).toLocaleString('en', { minimumFractionDigits: mindec, maximumFractionDigits: dec }))
          : "0")
        remark1 = "Borrow" +
          " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
            ? msg.SC
            : "") + " " + metal + "/" + curr +" "+ "from" +" "+ moment(msg.NVD).format("DD-MMM-YY") + " @" + " " + (msg.NDR
              ? (Number(parseFloat(msg.NDR)).toLocaleString('en', { minimumFractionDigits: mindec, maximumFractionDigits: dec }))
              : "0") + " ";
      }
      obj.remark1 = remark1;
      obj.remark2 = remark2;
      obj.IID = msg.IID;
      obj.CTID = msg.CTID;
      obj.BCM = msg.BCM;
      localStorage.setItem('dealcnfrmsg', JSON.stringify(obj));
      return obj;
    } else {
      localStorage.setItem('dealcnfrmsg', JSON.stringify(dealcnfrmsg));
      return dealcnfrmsg;
    }
  }
}

//getBenchMark
export function bmOrdcnfrmsgGenerator(msg, bmOrdcnfrmsg) {
  if (msg.OT === 5 && (parseInt(msg.OMT) === 1)) {
    if (msg.UID !== JSON.parse(localStorage.getItem('user')).id) {
      localStorage.setItem('bmOrdcnfrmsg', JSON.stringify(bmOrdcnfrmsg));
      return bmOrdcnfrmsg;
    } else {
      if (msg.BCM === appConstants.MARGIN_CHECKS_FAILED || msg.BCM === appConstants.INITIAL_CHECKS_FAILED) {
        var obj = {};
        obj.CTID = msg.CTID;
        obj.remark1 = "Benchmark Order Placed";
        obj.remark2 = "Your trade request was unsuccessful. Please see the Activity Log for details.";
        obj.IID = msg.IID;
        localStorage.setItem('bmOrdcnfrmsg', JSON.stringify(obj));
        return obj;
      } else if (msg.BCM === appConstants.BM_REJECTED) {
        var obj = {};
        obj.CTID = msg.CTID;
        obj.remark1 = "Benchmark Order Placed";
        obj.remark2 = "Your trade request was unsuccessful. Please see the Activity Log for details.";
        obj.IID = msg.IID;
        localStorage.setItem('bmOrdcnfrmsg', JSON.stringify(obj));
        return obj;
      } else if (appConstants.BM_PLACED === msg.BCM) {
        var obj = {};
        const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
        let metal = item.D1;
        let curr = item.D2;
        let remark1 = "";
        let remark2 = "";
        const isFwdEnableForBMK = localStorage.getItem('isFwdEnableForBMK');
        let forwardPercMsg = "";
        if(isFwdEnableForBMK === true) {
          forwardPercMsg = `(Value Date: ${moment(msg.VD).format(appConstants.shortDateFormat)} Fwd: ${msg.FWDPER === 0 ? '0.00' : msg.FWDPER}%)`
        }
        if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
          remark1 = "Benchmark Order Placed";
          remark2 = "Buy" +
            " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
              ? msg.SC
              : "") + " " + metal + "/" + curr + " " + " @ " + msg.BMN +` (Fixing Date: ${moment(msg.FD).format(appConstants.shortDateFormat)})`+` ${forwardPercMsg} `;
        } else {
          remark1 = "Benchmark Order Placed";
          remark2 = "Sell" +
            " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
              ? msg.SC
              : "") + " " + metal + "/" + curr + " " + " @ " + msg.BMN + ` (Fixing Date: ${moment(msg.FD).format(appConstants.shortDateFormat)})`+` ${forwardPercMsg} `;
        }
        obj.CTID = msg.CTID;
        obj.remark1 = remark1;
        obj.remark2 = remark2;
        obj.IID = msg.IID;
        localStorage.setItem('bmOrdcnfrmsg', JSON.stringify(obj));
        return obj;
      } else if (msg.BCM === appConstants.BENCHMARK_REQ_RECD) {
        localStorage.setItem('bmOrdcnfrmsg', JSON.stringify({}));
        return bmOrdcnfrmsg;
      } else {
        localStorage.setItem('bmOrdcnfrmsg', JSON.stringify(bmOrdcnfrmsg));
        return bmOrdcnfrmsg;
      }
    }
  } else {
    var bmOrdcnfrmsg = {};
    return bmOrdcnfrmsg;
  }
}

//set spot order data
export function trdeBookSet(msg, tradeBook) {
  const item1 = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  let cmdtypair = item1.ID
  var tradeBookArr = [];
  if (tradeBook) {
    if (tradeBook.tradeBookArray !== undefined) {
      if (tradeBook.tradeBookArray.length !== 0) {
        tradeBookArr = tradeBook.tradeBookArray;
      }
    }
  }
  var minDec = getMinDecimal(msg.IID)
  var amntDec = getAmntDecimal(msg.IID);

  if (msg.BCM === appConstants.TRADE_REQUEST_CONFIRMED) {
    var obj = {
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL"),
      'cmdtyPair': cmdtypair,
      'quantity': (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': (msg.SC
        ? msg.SC
        : ""),
      'rate': (msg.DR
        ? Number(parseFloat(msg.DR)).toLocaleString('en', { minimumFractionDigits: minDec, maximumFractionDigits: amntDec }) : "0"),
      'docNo': (msg.NFD
        ? msg.NFD
        : ""),
      'valDate':  moment(msg.VD).format('YYYY/MM/DD') !== item1.VD ? moment(msg.VD).format(appConstants.shortDateFormat) : 'Spot',
      'VD': moment(item1.VD).format('YYYY/MM/DD'),
      'trader': msg.UCD,
      'accDescription': msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID
    };
    tradeBookArr.unshift(obj);
    tradeBook.tradeBookArray = tradeBookArr;
    tradeBook.randomNo = Math.floor((Math.random() * 10) + 1);
    let openedWidgets = localStorage.getItem('openedWidgets');
    let flag = 0;
    if (openedWidgets) {
      JSON.parse(openedWidgets).map((widget) => {
        if (widget.substring(0, 16) === "OutstandingOrder") {
          flag = 1;
        }
      })
    }
    if (flag === 1) {
      localStorage.setItem('tradeBook', JSON.stringify(tradeBook));
    }
    return tradeBook;
  } else if (msg.BCM === appConstants.UPDATE_FNC_RMK) {//used for updating FNC comments
    if (msg.OT === 'TRADE') {
      if (tradeBookArr.findIndex(x => (x.docNo == msg.DN)) !== -1) {
        let tempIndex = tradeBookArr.findIndex(x => (x.docNo == msg.DN));
        tradeBookArr[tempIndex].comments = msg.RMK;
        tradeBookArr[tempIndex]["id"] = "";
      }
      tradeBook.tradeBookArray = tradeBookArr;
      tradeBook.randomNo = Math.floor((Math.random() * 10) + 1);
    }
    return tradeBook;
  } else {
    let openedWidgets = localStorage.getItem('openedWidgets');
    let flag = 0;
    if (openedWidgets) {
      JSON.parse(openedWidgets).map((widget) => {
        if (widget.substring(0, 16) === "OutstandingOrder") {
          flag = 1;
        }
      })
    }
    if (flag === 1) {
      localStorage.setItem('tradeBook', JSON.stringify(tradeBook));
    }
    return tradeBook;
  }
}


//set swap order data
export function swapBookSet(msg, swapBook) {
  const item1 = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  let cmdtypair = item1.ID
  var swapBookArr = [];
  if (swapBook) {
    if (swapBook.swapBookArray !== undefined) {
      if (swapBook.swapBookArray.length !== 0) {
        swapBookArr = swapBook.swapBookArray;
      }
    }
  }
  var minDec = getMinDecimal(msg.IID)
  var amntDec = getAmntDecimal(msg.IID);

  if (msg.BCM === appConstants.SWAP_PLACED) {
    const obj = {
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'deal': (parseInt(msg.NDT) === appConstants.TRADER_BUY
        ? "Borrow"
        : "Lend"),
      'cmdtyPair': cmdtypair,
      'quantity': (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })),
      'qtyType': (msg.SC
        ? msg.SC
        : ""),
      'nearLegRate': (msg.NDR
        ? Number(parseFloat(msg.NDR)).toLocaleString('en', { minimumFractionDigits: minDec, maximumFractionDigits: amntDec }) : "0"),
      'farLegRate': (msg.FDR
        ? Number(parseFloat(msg.FDR)).toLocaleString('en', { minimumFractionDigits: minDec, maximumFractionDigits: amntDec }) : "0"),
      'docNo': msg.SWC ? msg.SWC : "",
      'nearLegDate': moment(msg.NVD).format('YYYY/MM/DD') !== item1.VD ? moment(msg.NVD).format(appConstants.shortDateFormat) : 'Spot',
      'farLegDate': moment(msg.FVD).format('YYYY/MM/DD') !== item1.VD ? moment(msg.FVD).format(appConstants.shortDateFormat) : 'Spot',
      'trader': msg.UCD,
      'accDescription': msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID
    };

    swapBookArr.unshift(obj);
    swapBook.swapBookArray = swapBookArr;
    swapBook.randomNo = Math.floor((Math.random() * 10) + 1);
    let openedWidgets = localStorage.getItem('openedWidgets');
    let flag = 0;
    if (openedWidgets) {
      JSON.parse(openedWidgets).map((widget) => {
        if (widget.substring(0, 16) === "OutstandingOrder") {
          flag = 1;
        }
      })
    }
    if (flag === 1) {
      localStorage.setItem('swapBook', JSON.stringify(swapBook));
    }
    return swapBook;
  
  } else {
    let openedWidgets = localStorage.getItem('openedWidgets');
    let flag = 0;
    if (openedWidgets) {
      JSON.parse(openedWidgets).map((widget) => {
        if (widget.substring(0, 16) === "OutstandingOrder") {
          flag = 1;
        }
      })
    }
    if (flag === 1) {
      localStorage.setItem('swapBook', JSON.stringify(swapBook));
    }
    return swapBook;
  }
}

export function updateBenchmarkOrder(msg, benchMrkBook, outstandingBm) {
  let cmdtypair;
  var dec = getBMKDecimal(msg.IID);
  const item1 = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  cmdtypair = item1.ID
  var tempbenchArray = [];
  var tempBMOrderArr = [];
  if (benchMrkBook.outStanBencMrkOrd) {
    if (benchMrkBook.outStanBencMrkOrd.outStanBencMrkArray !== undefined) {
      if (benchMrkBook.outStanBencMrkOrd.outStanBencMrkArray.length !== 0) {
        tempbenchArray = benchMrkBook.outStanBencMrkOrd.outStanBencMrkArray;
      }
      if (benchMrkBook.bmOrderRows.length !== 0) {
        tempBMOrderArr = benchMrkBook.bmOrderRows;
      }
    }
  }

  if (benchMrkBook.benchMrkMap === null) {
    var temMap = new Map();
  } else {
    temMap = benchMrkBook.benchMrkMap;
  }
  if (appConstants.BM_PLACED === msg.BCM) {
    if (msg.DRMK === undefined) {
      msg.DRMK = "";
    }
    var SPRPER = ''
    if (msg.SPRPER && (parseFloat(msg.SPRPER) !== 0)) {
      SPRPER = (Number(parseFloat(msg.SPRPER)).toLocaleString('en', { minimumFractionDigits: config.roundOff, maximumFractionDigits: config.roundOff })) + " % | "
    }
    msg.ONBLIST.map((item, index) => {
      let DD = msg.DTLIST[index][item];
      var dec = getDecimal(msg.IID);
      var SPR = (msg.isSPRSelected ? msg.SPR : parseFloat(msg.SPR) * (-1));
      SPR = " $ " + (Number(parseFloat(SPR)).toLocaleString('en', { minimumFractionDigits: item1.pMinDec, maximumFractionDigits: item1.pDec }))

      let spreadVal = ''
      if (msg.SCT === 'PHY') {
        spreadVal = getSpreadValueForPCS(msg.PRMTYPE, msg.PRMRATE)
      } else {
        spreadVal = SPRPER + '' + SPR
      }
      var obj = {
        id: msg.ID,
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'benchmark': msg.BMN,
        'time': msg.BEMT,
        'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
        'cmdtyPair': cmdtypair,
        'quantity': Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }),
        'orderNo': item,
        'traderCode': msg.UCD,
        'accDescription': msg.AD,
        'accCode': msg.AC,
        'comments': msg.RMK,
        'selected': false,
        'cmdtyId': msg.IID,
        'FD': msg.FD,
        'TD': msg.TD,
        'REPEAT': msg.REPEAT ? msg.REPEAT : false,
        'fixingDate': moment(DD).format(appConstants.rptDateFormat),
        'valDate':handleONBValueDate(msg), //msg.isVDSelected ? moment(msg.VD).format(appConstants.shortDateFormat) : "Spot", //fd23969
        'spreadVal': spreadVal, //SPRPER + '' + SPR,//parseFloat(msg.SPRPER).toFixed(dec)+" % | "+SPR,
        'forwardVal': parseFloat(msg.FWDPER).toFixed(config.roundOff),
        'SPR': (msg.isSPRSelected ? parseFloat(msg.SPR) : parseFloat(msg.SPR) * (-1)),
        'SPRPER': parseFloat(msg.SPRPER),
        'isSPRSelected': msg.isSPRSelected,
        'orderType': msg.OT === 5 ? 'ONB' : 'AVG',
        'SCT': msg.SCT,
        'stockCode': msg.SC,
        'eqOz': Number(parseFloat(msg.GQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }),
        'fwdVD' : moment(msg.VD).format(appConstants.rptDateFormat),
        'tenor' : msg.TENOR,
        'fwdPerc' : msg.FWDPER,
        'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false,
        'isVDSelected' : msg.isVDSelected ? msg.isVDSelected : false
      };

      var obj1 = {
        'id': msg.ID,
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'benchmark': msg.BMN,
        'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
        'cmdtyPair': cmdtypair,
        'quantity': parseFloat(msg.PQ).toFixed(config.QuantityRoundOff),
        'orderNo': item,
        'traderCode': msg.UCD,
        'accCode': msg.AC,
        'accDescription': msg.AD,
        'comments': msg.RMK,
        'OMT': msg.OMT,
        'PCT': msg.PCT,
        'DRMK': msg.DRMK,
        'OR': parseFloat(msg.R).toFixed(dec),
        'OSC': msg.SC,
        'OMC': msg.OMC ? (parseInt(msg.OMC) + 1) : 1,
        'CTID': msg.CTID,
        'cmdtyId': msg.IID,
        'FD': msg.FD,
        'TD': msg.TD,
        'REPEAT': msg.REPEAT ? msg.REPEAT : false,
        'DD': DD,
        'orderType': msg.OT === 5 ? 'ONB' : 'AVG',
        'SCT': msg.SCT,
        'stockCode': msg.SC,
        'eqOz': parseFloat(msg.GQ).toFixed(config.QuantityRoundOff),
        'fwdVD' : moment(msg.VD).format(appConstants.rptDateFormat),
        'tenor' : msg.TENOR,
        'fwdPerc' : msg.FWDPER,
        'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false,
        'isVDSelected' : msg.isVDSelected ? msg.isVDSelected : false
      };
      var obj2 = {
        'id': msg.ID,
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'status': 'Working',
        'benchmark': msg.BMN,
        'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
        'pair': cmdtypair,
        'quantity': Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }),
        'orderNo': item,
        'docNo': '',
        'rate': '',
        'accDescription': msg.AD,
        'comments': msg.RMK,
        'selected': false,
        'cmdtyId': msg.IID,
        'FD': msg.FD,
        'TD': msg.TD,
        'REPEAT': msg.REPEAT ? msg.REPEAT : false,
        'orderType': msg.OT === 5 ? 'ONB' : 'AVG',
        'SCT': msg.SCT,
        'stockCode': msg.SC,
        'eqOz': Number(parseFloat(msg.GQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }),
        'fwdVD' : moment(msg.VD).format(appConstants.rptDateFormat),
        'tenor' : msg.TENOR,
        'fwdPerc' : msg.FWDPER,
        'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false,
        //'fixingDate':moment(DD).format('DD/MM/YYYY')
      };
      tempbenchArray.unshift(obj);// out bmk
      tempBMOrderArr.unshift(obj2);// all bmk
      temMap.set(item, obj1);// bmk map
    });
    benchMrkBook.outStanBencMrkOrd.outStanBencMrkArray = tempbenchArray;
    benchMrkBook.bmOrderRows = tempBMOrderArr;
    benchMrkBook.outStanBencMrkOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    benchMrkBook.benchMrkMap = temMap;
    benchMrkBook.randomNo = Math.floor((Math.random() * 1000000) + 1);
  } else if (appConstants.BM_MODIFIED === msg.BCM) {
    if (msg.DRMK === undefined) {
      msg.DRMK = "";
    }
    msg.BMSET.map((item) => {
      var instDet = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
      // let valueDate = moment(msg.VD).format('YYYY/MM/DD');
      // let VD = instDet.VD === msg.VD ? "Spot" : moment(msg.VD).format(appConstants.shortDateFormat);
      // if (msg.ISAPPLY) {
      //   // valueDate = moment(item.VD).format('YYYY/MM/DD');
      //   VD = instDet.VD === msg.VD ? "Spot" : moment(msg.VD).format(appConstants.shortDateFormat);
      // }
      var tempObj = temMap.get(item.DN);
      var dec = getDecimal(msg.IID);
      var SPR = (msg.isSPRSelected ? parseFloat(msg.SPR) : parseFloat(msg.SPR) * (-1));
      SPR = " $ " + SPR.toFixed(instDet.pDec);
      var SPRPER = ''
      if (msg.SPRPER && (parseFloat(msg.SPRPER) !== 0)) {
        SPRPER = (Number(parseFloat(msg.SPRPER)).toLocaleString('en', { minimumFractionDigits: config.roundOff, maximumFractionDigits: config.roundOff })) + " % | "
      }
      let spreadVal = ''
      if (msg.SCT === 'PHY') {
        spreadVal = getSpreadValueForPCS(msg.PRMTYPE, msg.PRMRATE)
      } else {
        spreadVal = SPRPER + '' + SPR
      }
      var obj = {
        id: tempObj.id,
        'eventTime': moment(item.TS).format(appConstants.actTimeDateTimeFormatter),
        'benchmark': msg.BMN,
        'time': msg.BEMT,
        'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
        'cmdtyPair': cmdtypair,
        'quantity': Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }),
        'orderNo': item.DN,
        'traderCode': msg.UCD,
        'accDescription': msg.AD,
        'accCode': msg.AC,
        'comments': msg.RMK,
        'selected': false,
        'cmdtyId': msg.IID,
        'fixingDate': moment(item.DD).format(appConstants.rptDateFormat),
        'valDate':  handleONBValueDate(msg),//msg.isVDSelected? moment(msg.VD).format(appConstants.shortDateFormat) : "Spot",
        'spreadVal': spreadVal,//SPRPER + '' + SPR,
        'forwardVal': parseFloat(msg.FWDPER).toFixed(config.roundOff),
        'SPR': (msg.isSPRSelected ? parseFloat(msg.SPR) : parseFloat(msg.SPR) * (-1)),
        'SPRPER': parseFloat(msg.SPRPER),
        'isSPRSelected': msg.isSPRSelected,
        'orderType': msg.OT === 5 ? 'ONB' : 'AVG',
        'SCT': msg.SCT,
        'stockCode': msg.SC,
        'eqOz': Number(parseFloat(msg.GQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }),
        'fwdVD' : moment(msg.VD).format(appConstants.rptDateFormat),
        'tenor' : msg.TENOR,
        'fwdPerc' : msg.FWDPER,
        'isVDSelected' : msg.isVDSelected ? msg.isVDSelected : false,
        'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false
      };
      var obj1 = {
        'id': tempObj.id,
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'benchmark': msg.BMN,
        'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
        'cmdtyPair': cmdtypair,
        'quantity': parseFloat(msg.PQ).toFixed(config.QuantityRoundOff),
        'orderNo': item.DN,
        'traderCode': msg.UCD,
        'accCode': msg.AC,
        'accDescription': msg.AD,
        'OMT': msg.OMT,
        'PCT': msg.PCT,
        'DRMK': msg.DRMK,
        'comments': msg.RMK,
        'OR': parseFloat(msg.R).toFixed(dec),
        'OSC': msg.OSC,
        'OMC': parseInt(item.OMC) + 1,
        'CTID': msg.CTID,
        'cmdtyId': msg.IID,
        'FD': msg.FD,
        'TD': msg.TD,
        'REPEAT': msg.REPEAT ? msg.REPEAT : false,
        'DD': item.DD,
        'orderType': msg.OT === 5 ? 'ONB' : 'AVG',
        'SCT': msg.SCT,
        'stockCode': msg.SC,
        'eqOz': parseFloat(msg.GQ).toFixed(config.QuantityRoundOff),
        'fwdVD' : moment(msg.VD).format(appConstants.rptDateFormat),
        'tenor' : msg.TENOR,
        'fwdPerc' : msg.FWDPER,
        'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false,
        'isVDSelected' : msg.isVDSelected ? msg.isVDSelected : false
      };
      var obj2 = {
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'status': 'Working',
        'benchmark': msg.BMN,
        'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
        'pair': cmdtypair,
        'quantity': Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }),
        'orderNo': item.DN,
        'docNo': '',
        'rate': '',
        'accDescription': msg.AD,
        'comments': msg.RMK,
        'selected': false,
        'cmdtyId': msg.IID,
        'orderType': msg.OT === 5 ? 'ONB' : 'AVG',
        'SCT': msg.SCT,
        'stockCode': msg.SC,
        'eqOz': Number(parseFloat(msg.GQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }),
        'fwdVD' : moment(msg.VD).format(appConstants.rptDateFormat),
        'tenor' : msg.TENOR,
        'fwdPerc' : msg.FWDPER,
       'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false
      };
      temMap.set(item.DN, obj1);// map
      for (let i = 0; i < tempbenchArray.length; i++) {
        if (tempbenchArray[i].orderNo === item.DN) {
          tempbenchArray[i] = obj;// out bmk
          break;
        }
      }
      for (let i = 0; i < tempBMOrderArr.length; i++) {
        if (tempBMOrderArr[i].orderNo === item.DN) {
          tempBMOrderArr[i] = obj2;// all bmk
          break;
        }
      }
    });
    benchMrkBook.outStanBencMrkOrd.outStanBencMrkArray = tempbenchArray;
    benchMrkBook.bmOrderRows = tempBMOrderArr;
    benchMrkBook.outStanBencMrkOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    benchMrkBook.benchMrkMap = temMap;
    benchMrkBook.randomNo = Math.floor((Math.random() * 1000000) + 1);
  } else if (appConstants.BM_CANCELLED === msg.BCM) {
    var tempbenchArrayCancel = [];
    if (benchMrkBook.bmCancelledOrdersRows.bmCancelledOrdArray !== undefined) {
      if (benchMrkBook.bmCancelledOrdersRows.bmCancelledOrdArray.length !== 0) {
        tempbenchArrayCancel = benchMrkBook.bmCancelledOrdersRows.bmCancelledOrdArray;
      }
    }
    for (let i = 0; i < tempbenchArray.length; i++) {
      if (tempbenchArray[i].orderNo === msg.ONB) {
        tempbenchArray.splice(i, 1);
        break;
      }
    }
    for (let i = 0; i < tempBMOrderArr.length; i++) {
      if (tempBMOrderArr[i].orderNo === msg.ONB) {
        tempBMOrderArr.splice(i, 1);
        break;
      }
    }
    let tempData = temMap.get(msg.ONB)
    temMap.delete(msg.ONB);
    var obj = {
      "id": msg.ID,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'benchmark': msg.BMN,
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL"),
      'cmdtyPair': cmdtypair,
      'quantity': Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }),
      'orderNo': msg.ONB,
      'cmdtyId': msg.IID,
      'stockCode': msg.SC,
      'eqOz': Number(parseFloat(tempData.eqOz)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })
    }
    var obj2 = {
      "id": msg.ID,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'status': 'Cancelled',
      'benchmark': msg.BMN,
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL"),
      'pair': cmdtypair,
      'quantity': Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }),
      'orderNo': (msg.ONB
        ? msg.ONB
        : ""),
      'docNo': '',
      'rate': '',
      'accDescription': msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'stockCode': msg.SC,
      'eqOz': Number(parseFloat(tempData.eqOz)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })
    };
    tempbenchArrayCancel.unshift(obj);
    tempBMOrderArr.unshift(obj2);
    benchMrkBook.outStanBencMrkOrd.outStanBencMrkArray = tempbenchArray;
    benchMrkBook.bmOrderRows = tempBMOrderArr;
    benchMrkBook.outStanBencMrkOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    benchMrkBook.benchMrkMap = temMap;
    benchMrkBook.bmCancelledOrdersRows.bmCancelledOrdArray = tempbenchArrayCancel;
    benchMrkBook.bmCancelledOrdersRows.randomNo = Math.floor((Math.random() * 1000000) + 1);
    benchMrkBook.randomNo = Math.floor((Math.random() * 1000000) + 1);

  } else if (appConstants.BENCHMARK_MANUAL_FILL === msg.BCM && msg.OT === 5) {
    var tempbenchArrayFill = []
    if (benchMrkBook.bmFillOrdersRows.bmFillOrderArray !== undefined) {
        if (benchMrkBook.bmFillOrdersRows.bmFillOrderArray.length !== 0) {
            var tempbenchArrayFill = benchMrkBook.bmFillOrdersRows.bmFillOrderArray;
        }
    }
    for (let i = 0; i < tempbenchArray.length; i++) {
        if (tempbenchArray[i].orderNo === msg.ONB) {
            tempbenchArray.splice(i, 1);
            break;
        }
    }
    for (let i = 0; i < tempBMOrderArr.length; i++) {
        if (tempBMOrderArr[i].orderNo === msg.ONB) {
            tempBMOrderArr.splice(i, 1);
            break;
        }
    }
    let tempData = temMap.get(msg.ONB)
    temMap.delete(msg.ONB);
    var obj = {
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'benchmark': msg.BMN,
        'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
            ? "BUY"
            : "SELL"),
        'cmdtyPair': cmdtypair,
        'quantity': Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }),
        'rate': parseFloat(msg.FP).toFixed(dec),
        'docNo': msg.FNC,
        'orderNo': msg.ONB,
        'valDate': moment(msg.VD).format(appConstants.shortDateFormat),
        'comments': msg.RMK,
        'accDescription': msg.AD,
        'cmdtyId': msg.IID,
        'stockCode': msg.SC,
        'eqOz': Number(parseFloat(tempData.eqOz)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })
    };
    var obj2 = {
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'status': 'Filled',
        'benchmark': msg.BMN,
        'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
            ? "BUY"
            : "SELL"),
        'pair': cmdtypair,
        'quantity': Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }),
        'orderNo': (msg.ONB
            ? msg.ONB
            : ""),
        'docNo': msg.FNC,
        'rate': parseFloat(msg.FP).toFixed(dec),
        'accDescription': msg.AD,
        'comments': msg.RMK,
        'cmdtyId': msg.IID,
        'stockCode': msg.SC,
        'eqOz': Number(parseFloat(tempData.eqOz)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })
    };
    tempbenchArrayFill.unshift(obj);
    tempBMOrderArr.unshift(obj2);
    benchMrkBook.outStanBencMrkOrd.outStanBencMrkArray = tempbenchArray;
    benchMrkBook.bmOrderRows = tempBMOrderArr;
    benchMrkBook.outStanBencMrkOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    benchMrkBook.benchMrkMap = temMap;
    benchMrkBook.bmFillOrdersRows.bmFillOrderArray = tempbenchArrayFill;
    benchMrkBook.bmFillOrdersRows.randomNo = Math.floor((Math.random() * 1000000) + 1);
    benchMrkBook.randomNo = Math.floor((Math.random() * 1000000) + 1);
  } else if (appConstants.UPDATE_FNC_RMK === msg.BCM && msg.DT === 'ONB' && msg.OT==='ORDER') {//used for updating (BMK FILLED) FNC comments
    var tempbenchArrayFill = benchMrkBook.bmFillOrdersRows.bmFillOrderArray;
    if (tempbenchArrayFill.findIndex(x => (x.orderNo == msg.DN)) !== -1) {
      let tempIndex = tempbenchArrayFill.findIndex(x => (x.orderNo == msg.DN));
      tempbenchArrayFill[tempIndex].comments = msg.RMK;
    }
    benchMrkBook.bmFillOrdersRows.bmFillOrderArray = tempbenchArrayFill;
    benchMrkBook.bmFillOrdersRows.randomNo = Math.floor((Math.random() * 1000000) + 1);

    var tempBMOrderArr = benchMrkBook.bmOrderRows;
    if (tempBMOrderArr.findIndex(x => (x.orderNo == msg.DN)) !== -1) {
      let tempIndex = tempBMOrderArr.findIndex(x => (x.orderNo == msg.DN));
      tempBMOrderArr[tempIndex].comments = msg.RMK;
    }

    benchMrkBook.bmOrderRows = tempBMOrderArr;
    benchMrkBook.randomNo = Math.floor((Math.random() * 1000000) + 1);
  } else if (appConstants.FWD_BMK_PERCENTAGE_UPDATE === msg.BCM) {
    let obj1 = temMap.get(msg.Doc_No);
    if (obj1) {
      obj1.fwdPerc = msg.FWDPER;
      temMap.set(msg.Doc_No, obj1);
    }

    for (let i = 0; i < tempbenchArray.length; i++) {
      if (tempbenchArray[i].orderNo === msg.Doc_No) {
        tempbenchArray[i].forwardVal = msg.FWDPER;
        break;
      }
    }
    for (let i = 0; i < tempBMOrderArr.length; i++) {
      if (tempBMOrderArr[i].orderNo === msg.Doc_No) {
        tempBMOrderArr[i].fwdPerc = msg.FWDPER;
        break;
      }
    }
    benchMrkBook.outStanBencMrkOrd.outStanBencMrkArray = tempbenchArray;
    benchMrkBook.bmOrderRows = tempBMOrderArr;
    benchMrkBook.outStanBencMrkOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    benchMrkBook.benchMrkMap = temMap;
    benchMrkBook.randomNo = Math.floor((Math.random() * 1000000) + 1);
  }

  let openedWidgets = localStorage.getItem('openedWidgets');
  let flag = 0;
  if (openedWidgets) {
    JSON.parse(openedWidgets).map((widget) => {
      if (widget.substring(0, 16) === "OutstandingOrder") {
        flag = 1;
      }
    })
  }
  if (flag === 1) {
    localStorage.setItem('benchMrkBook', JSON.stringify(benchMrkBook));
  }
  return benchMrkBook;
}

export function setRequestRejectModal(msg, requestRejectModal) {
  localStorage.setItem('requestRejectModal', JSON.stringify(requestRejectModal));
  var obj = {};
  if (msg.BCM === appConstants.REQUEST_REJECT || msg.BCM === appConstants.INITIAL_CHECKS_FAILED || msg.BCM === appConstants.MARGIN_CHECKS_FAILED) {
    if (parseInt(msg.OMT) === 2) {
      obj.mdflag = true;
      if (parseInt(msg.OT) === 2) {
        obj.title = "Modify Limit Order";
      } else if (parseInt(msg.OT) === 3) {
        obj.title = "Modify Stop Order";
      } else if (parseInt(msg.OT) === 6) {
        obj.title = "Modify OCO Order";
      } else if (parseInt(msg.OT) === 5) {
        obj.title = "Modify Benchmark Order";
      }
      obj.msg = "Your order request was unsuccessful. Please see the Activity Log for details.";
      obj.CTID = msg.CTID;
      requestRejectModal = obj;
      localStorage.setItem('requestRejectModal', JSON.stringify(requestRejectModal));
    }
  }
  return requestRejectModal
}

const closeReqRejectModal = (requestRejectModal) => {
  var obj1 = {
    mdflag: false,
    title: "",
    msg: "",
    CTID: ""
  };
  localStorage.setItem('requestRejectModal', JSON.stringify(obj1));
  return obj1;
}

// update orders tab on WS update
export function setLimitOrdBook(msg,lmObj){
  let proximity=0;
  var dec = getDecimal(msg.IID);
  var minDec=getMinDecimal(msg.IID)
  var amntDec = getAmntDecimal(msg.IID);
  const minAmtDec = getMinAmntDecimal(msg.IID);
  const item1 = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  let cmdtypair = item1.ID;
  var templmtArray = [];
  var lmtOrdArr = [];
  let suspendedArray = [];
  lmtOrdArr = lmObj.lmtOrdersRows;
  if (lmObj.outstandingLm){
    if (lmObj.outstandingLm.outstandingLmArr !== undefined) {
      if (lmObj.outstandingLm.outstandingLmArr.length !== 0) {
        templmtArray = lmObj.outstandingLm.outstandingLmArr;
      }
    }
  }

  // suspended orders
  if (lmObj.hasOwnProperty("suspendedOrders")) {
    if (lmObj.suspendedOrders?.suspendedOrdArr?.length !== 0) {
      suspendedArray = lmObj.suspendedOrders.suspendedOrdArr;
    }
  } 

  if (lmObj.limitOrdMap === null) {
    var temMap = new Map();
  } else {
    temMap = lmObj.limitOrdMap;
  }
  let dealType="Limit"
  // to handle (L) for only all orders
  let LoopDealType = `${msg.ISOTO ? 'OTO ' : ''}Limit${msg.INLOOP ? ' (L)' : ''}`;
  switch (msg.OT) {
    case appConstants.LMT_ORD_TYPE:  
      dealType=`${msg.ISOTO ? 'OTO ' : ''}Limit`;
      LoopDealType=`${msg.ISOTO ? 'OTO ' : ''}Limit${msg.INLOOP ? ' (L)' : ''}`;
      if(parseInt(msg.DT)=== appConstants.TRADER_BUY){
        proximity=(parseFloat(msg.R)-parseFloat(item1.ask))/(parseFloat(item1.ask))*100* -1;
      }else {
        proximity=(parseFloat(msg.R)-parseFloat(item1.bid))/(parseFloat(item1.bid))*100;
      }
      break;
    case appConstants.STOP_ORD_TYPE:
        dealType=`${msg.ISOTO ? 'OTO ' : ''}Stop`;
        LoopDealType=`${msg.ISOTO ? 'OTO ' : ''}Stop${msg.INLOOP ? ' (L)' : ''}`;
        if(parseInt(msg.DT)===appConstants.TRADER_BUY){
        proximity=(parseFloat(msg.R)-parseFloat(item1.bid))/(parseFloat(item1.bid))*100;
      }else {
        proximity=(parseFloat(msg.R)-parseFloat(item1.ask))/(parseFloat(item1.ask))*100* -1;
      }
      break;
    case appConstants.OCO_ORD_TYPE:
      if (parseFloat(msg.DOT) === appConstants.STOP_ORD_TYPE){
        dealType=`${msg.ISOTO ? 'OTO ' : ''}OCO Stop`;
        if(parseInt(msg.DT)===appConstants.TRADER_BUY){
          proximity=(parseFloat(msg.R)-parseFloat(item1.bid))/(parseFloat(item1.bid))*100;
        }else {
          proximity=(parseFloat(msg.R)-parseFloat(item1.ask))/(parseFloat(item1.ask))*100* -1;
        }
      }else {
        dealType=`${msg.ISOTO ? 'OTO ' : ''}OCO Limit`;
        if(parseInt(msg.DT)=== appConstants.TRADER_BUY){
          proximity=(parseFloat(msg.R)-parseFloat(item1.ask))/(parseFloat(item1.ask))*100* -1;
        }else {
          proximity=(parseFloat(msg.R)-parseFloat(item1.bid))/(parseFloat(item1.bid))*100;
        }
      }
      break;
    case appConstants.OTO_ORD_TYPE:
      // if (parseFloat(msg.DOT) === appConstants.STOP_ORD_TYPE){
      //   dealType='OTO Stop';
      //   if(parseInt(msg.DT)===appConstants.TRADER_BUY){
      //     proximity=(parseFloat(msg.R)-parseFloat(item1.bid))/(parseFloat(item1.bid))*100;
      //   }else {
      //     proximity=(parseFloat(msg.R)-parseFloat(item1.ask))/(parseFloat(item1.ask))*100* -1;
      //   }
      // } else {
      //   try {
      //     dealType='OTO Limit';
      //     if(parseInt(msg.DT)=== appConstants.TRADER_BUY){
      //       proximity=(parseFloat(msg.R)-parseFloat(item1.ask))/(parseFloat(item1.ask))*100* -1;
      //     }else {
      //       proximity=(parseFloat(msg.R)-parseFloat(item1.bid))/(parseFloat(item1.bid))*100;
      //     }
      //     throw proximity;
      //   } catch(e) {
      //     console.log("EXC PROX", e, item1, msg)
      //   }
      // }
      proximity = 2;
      break;
  }
  if (appConstants.ORD_PLACED === msg.BCM || appConstants.ORD_ACTIVATED === msg.BCM) {
    if (msg.DRMK === undefined) {
      msg.DRMK = "";
    }
    if(proximity && Number.isFinite(proximity)) {
      proximity = parseFloat(proximity).toFixed(2);
    }else{
      proximity=null
    }
    var obj = {
      id: msg.ID,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'proximity': proximity,
      'cmdtyPair': cmdtypair,
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL"),
      'quantity': (msg.PQ ? (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0.000"),
      'working': (msg.PQ ? (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0.000"),
      'filled': parseFloat('0').toFixed(config.QuantityRoundOff),
      'cancelQty': parseFloat('0').toFixed(config.QuantityRoundOff),//toFixed(item1.amntMinDec),
      'price' : (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: minDec ,maximumFractionDigits:dec})),
      'accDescription': msg.AD,
      'accCode': msg.AC,
      'validity': (parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'selected': false,
      'dealType': msg?.INLOOP ? LoopDealType : dealType,
      'OT':msg.OT,
      'DOT': msg.DOT,
      'DT': parseInt(msg.DT),
      'valDate': handleValueDate(msg),
      'forwardVal':msg.FWDPER ? parseFloat(msg.FWDPER).toFixed(config.roundOff) :"0.00",
      'linkOrdCLID':msg.OTOLINKID ?msg.OTOLINKID :'',
      'ISOTO': msg?.ISOTO ?? false,
      'ISOCO': msg?.ISOCO ?? false,
      'ISACTIVE': msg?.ISACTIVE ?? true,
      'INLOOP': msg?.INLOOP ?? false,
      'linkclid': !!msg?.OTOLINKID && msg?.OTOLINKID !== "" ? msg?.OTOLINKID : msg.ID,
      'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false
    };

    var obj2 = {
      id: msg.ID,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'status':'Working',
      'deal':(parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
      'pair': cmdtypair,
      'quantity': (msg.PQ ? (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0.000"),
      'working': (msg.PQ ? (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0.000"),
      'rate': (Number(parseFloat(msg.R)).toLocaleString('en',{  minimumFractionDigits: minDec ,maximumFractionDigits:dec})),
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'docNo':'',
      'accDescription':msg.AD,
      'comments': msg.RMK,
      'selected': false,
      'cmdtyId': msg.IID,
      'dealType':msg?.INLOOP ? LoopDealType : dealType,
      'OT':msg.OT,
      'linkOrdCLID':msg.OTOLINKID ? msg.OTOLINKID :'',
      'ISOTO': msg?.ISOTO ?? false,
      'ISOCO': msg?.ISOCO ?? false,
      'ISACTIVE': msg?.ISACTIVE ?? true,
      'INLOOP': msg?.INLOOP ?? false,
      'linkclid': !!msg?.OTOLINKID && msg?.OTOLINKID !== "" ? msg?.OTOLINKID : msg.ID,
      'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false
    };
    var obj1 = {
      'id': msg.ID,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'deal':(parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
      'cmdtyPair': cmdtypair,
      'quantity': parseFloat(msg.PQ.toFixed(config.QuantityRoundOff)),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'accCode': msg.AC,
      'accDescription': msg.AD,
      'comments': msg.RMK,
      'OMT': msg.OMT,
      'PCT': msg.PCT,
      'DRMK': msg.DRMK,
      'HSE':msg.HSE,
      'OR': parseFloat(msg.R).toFixed(dec),
      'OSC': msg.SC,
      'WKQ':msg.PQ,
      'TFQ':0,
      'FQ':0.000,
      'OMC': parseInt(msg.OMC) + 1,
      'VT' :msg.VT,
      'OVT':msg.VT,
      'BID':msg.BID,
      'VD':msg.VD,
      'TIME':msg.TIME,
      'OTIME': msg.TIME,
      'CTID': msg.CTID,
      'cmdtyId': msg.IID,
      'OT':msg.OT,
      'DOT': msg.DOT,
      'DT': parseInt(msg.DT),
      'isVDSelected':msg.isVDSelected,
      'linkOrdCLID':msg.OTOLINKID ?msg.OTOLINKID :'',
      'ISOTO': msg?.ISOTO ?? false,
      'ISOCO': msg?.ISOCO ?? false,
      'ISACTIVE': msg?.ISACTIVE ?? true,
      'INLOOP': msg?.INLOOP ?? false,
      'linkclid': !!msg?.OTOLINKID && msg?.OTOLINKID !== "" ? msg?.OTOLINKID : msg.ID,
      'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false
    };

    // handle suspended orders
    if (msg.hasOwnProperty("ISOTO") && msg.ISOTO) {
      if (msg.hasOwnProperty("ISACTIVE") && msg?.ISACTIVE) {
        // Add in outstanding orders
        templmtArray.unshift(obj);
        lmtOrdArr.unshift(obj2);
      } else {
        // Add in suspended orders
        suspendedArray.unshift(obj);
      }
    } else {
      templmtArray.unshift(obj);
      lmtOrdArr.unshift(obj2);
    }

    lmObj.suspendedOrders = {
      suspendedOrdArr: suspendedArray,
      randomNo: Math.floor((Math.random() * 1000000) + 1)
    }

    temMap.set(msg.NOD, obj1);
    lmObj.outstandingLm.outstandingLmArr = templmtArray;
    lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.limitOrdMap = temMap;
    lmObj.lmtOrdersRows = lmtOrdArr;
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  }else if (appConstants.ORD_MODIFIED === msg.BCM) {
    if (msg.DRMK === undefined) {
      msg.DRMK = "";
    }
    if(msg.RMK=== undefined){
      msg.RMK="";
    }
    if(proximity && Number.isFinite(proximity)) {
      proximity = parseFloat(proximity).toFixed(2);
    }else{
      proximity=null
    }
    var obj = {
      id: msg.ID,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'proximity': proximity,
      'cmdtyPair': cmdtypair,
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL"),
      'quantity': (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })),
      'working': (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })),
      'filled': parseFloat('0').toFixed(config.QuantityRoundOff),
      'cancelQty': parseFloat('0').toFixed(config.QuantityRoundOff),
      'price' : (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: minDec, maximumFractionDigits: dec })),
      'accDescription': msg.AD,
      'accCode': msg.AC,
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'selected': false,
      'dealType': msg?.INLOOP ? LoopDealType : dealType,
      'valDate': handleValueDate(msg),
      'forwardVal':msg.FWDPER ? parseFloat(msg.FWDPER).toFixed(config.roundOff) : "0.00",
      //'markup': SPRPER,
      'isMRKSelected':msg.isMRKSelected,
      'OT':msg.OT,
      'DOT': msg.DOT,
      'DT': parseInt(msg.DT),
      'ISOTO': msg?.ISOTO ?? false,
      'ISOCO': msg?.ISOCO ?? false,
      'ISACTIVE': msg?.ISACTIVE ?? true,
      'INLOOP': msg?.INLOOP ?? false,
      'linkclid': !!msg?.OTOLINKID && msg?.OTOLINKID !== "" ? msg?.OTOLINKID : msg.ID,
      'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false
    };

    var obj2 = {
      id: msg.ID,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'status':'Working',
      'deal':(parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
      'pair': cmdtypair,
      'quantity': (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })),
      'working': (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })),
      'rate': (Number(parseFloat(msg.R)).toLocaleString('en',{  minimumFractionDigits: minDec ,maximumFractionDigits:dec })),
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'docNo':'',
      'accDescription':msg.AD,
      'comments': msg.RMK,
      'selected': false,
      'cmdtyId': msg.IID,
      'dealType': msg?.INLOOP ? LoopDealType : dealType,
      'OT':msg.OT,
      'ISOTO': msg?.ISOTO ?? false,
      'ISOCO': msg?.ISOCO ?? false,
      'ISACTIVE': msg?.ISACTIVE ?? true,
      'INLOOP': msg?.INLOOP ?? false,
      'linkclid': !!msg?.OTOLINKID && msg?.OTOLINKID !== "" ? msg?.OTOLINKID : msg.ID,
      'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false
    };
    var tempobj=temMap.get(msg.NOD);
    var obj1 = {
      'id': msg.ID,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL"),
      'cmdtyPair': cmdtypair,
      'quantity': convertToFloat(msg.PQ),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'accCode': msg.AC,
      'accDescription': msg.AD,
      'comments': msg.RMK,
      'OMT': msg.OMT,
      'PCT': msg.PCT,
      'DRMK': msg.DRMK,
      'OR': parseFloat(msg.R).toFixed(dec),
      'OSC': msg.SC,
      'WKQ':msg.PQ,
      'FQ':msg.PQ,
      'TFQ':0,
      'OMC': parseInt(msg.OMC) + 1,
      'VT' :msg.VT,
      'OVT':tempobj.VT,
      'BID':msg.BID,
      'HSE':msg.HSE,
      'VD':msg.VD,
      'TIME':msg.TIME,
      'OTIME': tempobj.TIME,
      'CTID': msg.CTID,
      'cmdtyId': msg.IID,
      'OT':msg.OT,
      'DOT': msg.DOT,
      'DT': parseInt(msg.DT),
      'isVDSelected':msg.isVDSelected,
      'ISOTO': msg?.ISOTO ?? false,
      'ISOCO': msg?.ISOCO ?? false,
      'ISACTIVE': msg?.ISACTIVE ?? true,
      'INLOOP': msg?.INLOOP ?? false,
      'linkclid': !!msg?.OTOLINKID && msg?.OTOLINKID !== "" ? msg?.OTOLINKID : msg.ID,
      'isSNEXrmk': msg.isSNEXrmk ? msg.isSNEXrmk : false
    };
    temMap.set(msg.NOD, obj1);
    for (let i = 0; i < templmtArray.length; i++) {
      if (templmtArray[i].orderNo === msg.NOD) {
        templmtArray[i] = obj;
        break;
      }
    }
    for (let i = 0; i < lmtOrdArr.length; i++) {
      if(lmtOrdArr[i].orderNo === msg.NOD){
        lmtOrdArr[i] = obj2;
        break;
      }
    }
    lmObj.outstandingLm.outstandingLmArr = templmtArray;
    lmObj.lmtOrdersRows = lmtOrdArr;
    lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.limitOrdMap = temMap;
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);

    workingOrders.length = 0
    workingOrders.push(...templmtArray)
    try {
        if (workingOrders.length) {
            ordersStore.push({
                key: 'orderNo',
                type: 'update',
                data: workingOrders
            })
        }
    } catch (e) {
        /* 
            Note: changes.filter/ changes.forEach is not a function
            this error can be ignored as this
            happens when data is null/undefined 
            which it is at the start
        */
        console.log('os exc: ', e)
    }
  }else if (appConstants.UPDATE_ADJUSTMENT_DEALER === msg.BCM) {
    for (let i = 0; i < templmtArray.length; i++) {
      if (templmtArray[i].orderNo === msg.NOD) {
        if(msg.isVDSelected){
          templmtArray[i].valDate= (moment(msg.VD).format('YYYY/MM/DD') !== item1.VD ? moment(msg.VD).format(appConstants.shortDateFormat) : 'Spot')
        }
        if(msg.isFWDSelected){
          templmtArray[i].forwardVal=msg.FWDPER ? parseFloat(msg.FWDPER).toFixed(config.roundOff) :"0.00"
        }
        break;
      }
    }
    var tempobj=temMap.get(msg.NOD);
    if(msg.isVDSelected){
      tempobj.isVDSelected=msg.isVDSelected;
      tempobj.VD=msg.VD;
      temMap.set(msg.NOD,tempobj);
      lmObj.limitOrdMap = temMap;
    }
    lmObj.outstandingLm.outstandingLmArr = templmtArray;
    lmObj.lmtOrdersRows = lmtOrdArr;
    lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  }else if(appConstants.HEGDGE_SETT_CHNG === msg.BCM){
    var tempobj=temMap.get(msg.NOD);
    tempobj.id=msg.CLID;
    if (templmtArray.findIndex(x => (x.orderNo === msg.NOD)) !== -1) {
      let tempIndex = templmtArray.findIndex(x => (x.orderNo === msg.NOD));
      if (msg.NOD.endsWith("/1")) {
        templmtArray[tempIndex].linkclid = msg.CLID;
        if (tempobj.hasOwnProperty("linkclid")) {
          tempobj.linkclid = msg.CLID;
        }
      }
      templmtArray[tempIndex].id = msg.CLID;
    }
    tempobj.BID=msg.BID;
    temMap.set(msg.NOD,tempobj);
    lmObj.outstandingLm.outstandingLmArr = templmtArray;
    lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.limitOrdMap = temMap;
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  }else if (appConstants.ORD_CANCEL === msg.BCM) { 
    var templmtArrayCancel = [];
    let flag=true;
    let isUpdateFillOrd=false;
// need to check with OTO
    if(msg.OT === appConstants.STOP_ORD_TYPE || msg.OT === appConstants.OTO_ORD_TYPE){
      flag=true;
    } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
       flag=false;
       if(msg.OT === appConstants.OCO_ORD_TYPE && !msg.isUserCancel && msg.NFD){// need to check this condition
        flag= false;
       }else{
        if(msg.OT === appConstants.OCO_ORD_TYPE && !msg.isUserCancel && msg.OMT === appConstants.CANCELORD){//&& !NFD
          flag=true;
        }
       }
       if(msg.OT === appConstants.OCO_ORD_TYPE && msg.isUserCancel){
         flag=true;
       }
     }

    if(flag){
      if (lmObj.lmCancellOrd.lmCancellOrdArr !== undefined) {
        if (lmObj.lmCancellOrd.lmCancellOrdArr !== 0) {
          templmtArrayCancel = lmObj.lmCancellOrd.lmCancellOrdArr;
        }
      }
      for (let i = 0; i < templmtArray.length; i++) {
        if (templmtArray[i].orderNo === msg.NOD) {
          templmtArray.splice(i, 1);
          break;
        }
      }
      for (let i = 0; i < lmtOrdArr.length; i++) {
        if (lmtOrdArr[i].orderNo === msg.NOD) {
          if(lmtOrdArr[i].status === 'Working'){
            lmtOrdArr.splice(i, 1);
          }else{
            lmtOrdArr[i].status='Filled'
          }
      }
      }
      var templmtArrayFill = lmObj.lmFillOrd.lmFillOrdArr;

      if(templmtArrayFill.findIndex(x => (x.orderNo == msg.NOD) ) !== -1){
        let tempIndex=templmtArrayFill.findIndex(x => (x.orderNo == msg.NOD));
        templmtArrayFill[tempIndex].status='Filled';
        isUpdateFillOrd=true;
      }
      temMap.delete(msg.NOD);

      var obj = {
        id: msg.ID,
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
        'cmdtyPair': cmdtypair,
        'quantity': (Number(parseFloat((parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))))).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })),
        'rate': (Number(parseFloat(msg.R)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })),
        'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
        'orderNo': msg.NOD,
        'cmdtyId': msg.IID,
        'dealType': msg.INLOOP ? LoopDealType : dealType,
        'OT':msg.OT
      }

      var obj2 = {
        id: msg.ID,
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'status':'Cancelled',
        'deal':(parseInt(msg.DT) === appConstants.TRADER_BUY
            ? "BUY"
            : "SELL"),
        'pair': cmdtypair,
        'quantity': (Number(parseFloat((parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))))).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })),//parseFloat(msg.PQ.toFixed(config.QuantityRoundOff)),
        'rate': (Number(parseFloat(msg.R)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })),
        'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
        'orderNo': (msg.NOD
          ? msg.NOD
          : ""),
        'docNo':'',
        'accDescription':msg.AD,
        'comments': msg.RMK,
        'cmdtyId': msg.IID,
        'dealType': msg.INLOOP ? LoopDealType : dealType,
        'OT':msg.OT
      };
      // Bug#37000
          templmtArrayCancel.unshift(obj);
          lmtOrdArr.unshift(obj2);
      
    }
    lmObj.lmCancellOrd.lmCancellOrdArr = templmtArrayCancel;
    lmObj.lmCancellOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.outstandingLm.outstandingLmArr = templmtArray;
    lmObj.lmtOrdersRows = lmtOrdArr;
    lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.limitOrdMap = temMap;
    if(isUpdateFillOrd){ lmObj.lmFillOrd.randomNo = Math.floor((Math.random() * 10000000) + 1); }
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  }else if (msg.BCM ===appConstants.ORDER_PARTIALLY_FILL_CANCEL) {// used for stop order
    var templmtArrayFill = []
    if (lmObj.lmFillOrd.lmFillOrdArr !== undefined) {
      if (lmObj.lmFillOrd.lmFillOrdArr.length !== 0) {
         templmtArrayFill = lmObj.lmFillOrd.lmFillOrdArr;
      }
    }
    for (let i = 0; i < templmtArrayFill.length; i++) {
      if (templmtArrayFill[i].orderNo === msg.NOD) {
        templmtArrayFill[i].rate=(Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: amntDec, maximumFractionDigits:amntDec }));
        break;
      }
    }

    for (let i = 0; i < lmtOrdArr.length; i++) {
      if (lmtOrdArr[i].orderNo === msg.NOD && (lmtOrdArr[i].status === 'Filled' || lmtOrdArr[i].status === 'Partially Filled')) {
        lmtOrdArr[i].rate=(Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: amntDec, maximumFractionDigits:amntDec }));
        //lmtOrdArr[i].status="Filled";
        break;
      }
    }
    lmObj.lmFillOrd.lmFillOrdArr = templmtArrayFill;
    lmObj.lmtOrdersRows = lmtOrdArr;
    lmObj.lmFillOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  }else if (msg.BCM ===appConstants.OCO_PARTIALLY_FILL_CANCEL) {
    var lmtOrd=temMap.get(msg.NOD);
    for (let i = 0; i < templmtArray.length; i++) {
      if (templmtArray[i].orderNo === msg.NOD) {
        templmtArray[i].working=parseFloat((""+templmtArray[i].working).replace(/,/g, ''))-parseFloat(msg.CQ);
        lmtOrd.WKQ=templmtArray[i].working;
        let tempFill = numeral(templmtArray[i].cancelQty)._value;
        templmtArray[i].cancelQty=parseFloat(tempFill)+parseFloat(msg.CQ);
      }
    }
    if(lmtOrdArr.findIndex(x => (x.orderNo == msg.NOD) ) !== -1){
      let tempIndex=lmtOrdArr.findIndex(x => (x.orderNo == msg.NOD));
      lmtOrdArr[tempIndex].quantity=parseFloat((""+lmtOrdArr[tempIndex].quantity).replace(/,/g, ''))-parseFloat(msg.CQ);
    }
    lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.outstandingLm.outstandingLmArr = templmtArray;
    lmObj.lmtOrdersRows = lmtOrdArr;
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  }else if((msg.OT !== appConstants.OCO_ORD_TYPE) && (appConstants.ORD_UNHEDGE_FILL === msg.BCM || appConstants.ORD_HEDGE_FILL=== msg.BCM)){
    var templmtArrayFill = []
    if (lmObj.lmFillOrd.lmFillOrdArr !== undefined) {
      if (lmObj.lmFillOrd.lmFillOrdArr.length !== 0) {
        templmtArrayFill = lmObj.lmFillOrd.lmFillOrdArr;
      }
    }
  var lmtOrd=temMap.get(msg.NOD);
  let fillQty=(msg.OMT === 4 ? msg.FQ : msg.TFQ);//parseFloat(msg.FQ);
  if((parseFloat(lmtOrd.WKQ) === fillQty)|| (msg.BCM === appConstants.ORD_UNHEDGE_FILL) ){ 
  for (let i = 0; i < templmtArray.length; i++) {
    if (templmtArray[i].orderNo === msg.NOD) {
      templmtArray.splice(i, 1);
      break;
    }
  }
  for (let i = 0; i < lmtOrdArr.length; i++) {
    if (lmtOrdArr[i].orderNo === msg.NOD) {
      lmtOrdArr.splice(i, 1);
      i--;
    }
  }
  if(templmtArrayFill.findIndex(x => (x.orderNo == msg.NOD) ) !== -1){
    templmtArrayFill.splice(templmtArrayFill.findIndex(x => (x.orderNo == msg.NOD) ),1)
  }
  temMap.delete(msg.NOD);
  let qty= (msg.OMT === 4 ? msg.FQ : msg.TFQ);
  // if(msg.OMT ===5 && msg.isRestated){
  //   qty=msg.TFQ;
  // }
    var obj = {
      id: msg.NFD, // unique ID required for devextreme, NFD is FNC doc no
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'status':'Filled',
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL"),
      'cmdtyPair': cmdtypair,
      'quantity': Number(parseFloat(qty)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }),
      'rate': (Number(parseFloat(msg.DR)).toLocaleString('en', { minimumFractionDigits: minAmtDec, maximumFractionDigits:amntDec })),
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
      'docNo': msg.NFD,
      'orderNo': msg.NOD,
      'valDate': moment(msg.VD).format(appConstants.shortDateFormat),//msg.VD,
      'comments': msg.RMK,
      'wk':msg.FQ,
      'fq':msg.FQ,
      'accDescription': msg.AD,
      'cmdtyId': msg.IID,
      'dealType': msg?.INLOOP ? LoopDealType : dealType,
      'OT':msg.OT
    };
    var obj2 = {
      id: msg.NFD, // unique ID required for devextreme, NFD is FNC doc no
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'status':'Filled',
      'deal':(parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
      'pair': cmdtypair,
      'quantity': (Number(parseFloat(qty)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })),
      'working':(Number(parseFloat(qty)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })),
      'rate': (Number(parseFloat(msg.DR)).toLocaleString('en', { minimumFractionDigits: minAmtDec, maximumFractionDigits:amntDec })),
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'docNo':msg.NFD,
      'accDescription':msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'dealType': msg?.INLOOP ? LoopDealType : dealType,
      'OT':msg.OT
    };
    lmtOrdArr.unshift(obj2);
    templmtArrayFill.unshift(obj);
    lmObj.lmtOrdersRows = lmtOrdArr;
    lmObj.outstandingLm.outstandingLmArr = templmtArray;
    lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.limitOrdMap = temMap;
    lmObj.lmFillOrd.lmFillOrdArr = templmtArrayFill;
    lmObj.lmFillOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  }else{
    let filled=0;
    let working=0;
    let check=0;
    for (let i = 0; i < templmtArray.length; i++) {
      if (templmtArray[i].orderNo === msg.NOD) {
        templmtArray[i].working=parseFloat((""+templmtArray[i].working).replace(/,/g, ''))-parseFloat(msg.FQ);
        working=Number(templmtArray[i].working).toFixed(config.QuantityRoundOff);
        let tempFill = numeral(templmtArray[i].filled)._value;
        templmtArray[i].filled=parseFloat(tempFill)+parseFloat(msg.FQ);
        filled=templmtArray[i].filled
       if(parseFloat(working)===0){
          for (let i = 0; i < templmtArray.length; i++) {
            if (templmtArray[i].orderNo === msg.NOD) {
              templmtArray.splice(i, 1);
              break;
            }
          }
        }
        break;
      }
    }

    for (let j = 0; j < lmtOrdArr.length; j++) {
      if (lmtOrdArr[j].orderNo === msg.NOD) {
         lmtOrdArr[j].quantity=filled;
         lmtOrdArr[j].rate=msg.DR;

        if(lmtOrdArr[j].status ==='Working'){
          lmtOrdArr[j].working=working;
          lmtOrdArr[j].quantity=working;
        }
      if(parseFloat(working)===0 || parseFloat(working)==='0'){
        if(lmtOrdArr[j].docNo === ''){
          lmtOrdArr.splice(j, 1);
        }else{
          lmtOrdArr[j].status='Filled';
        }
        }    
      }
    }

    if(templmtArrayFill.length > 0){ 
      for (let i = 0; i < templmtArrayFill.length; i++) {
        if (templmtArrayFill[i].orderNo === msg.NOD) { 
          templmtArrayFill[i].wk=parseFloat(templmtArrayFill[i].wk)-parseFloat(msg.FQ);
          templmtArrayFill[i].fq=parseFloat(templmtArrayFill[i].fq)+parseFloat(msg.FQ);
          let wk =Number(templmtArrayFill[i].wk).toFixed(config.QuantityRoundOff);
          templmtArrayFill[i].quantity=templmtArrayFill[i].fq;
          templmtArrayFill[i].rate=msg.DR;
          lmtOrd.WKQ=wk;
          lmtOrd.FQ=templmtArrayFill[i].fq;
          lmtOrd.TFQ=templmtArrayFill[i].fq;
          temMap.set(msg.NOD,lmtOrd);

          for (let j = 0; j < lmtOrdArr.length; j++) {
            if (lmtOrdArr[j].orderNo === msg.NOD) {
              lmtOrdArr[j].quantity= parseFloat(templmtArrayFill[i].fq).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }); // partial filled quantity formatter issue fix
              lmtOrdArr[j].rate=(Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: minAmtDec, maximumFractionDigits:amntDec })); // partial filled rate formatter issue fix
              if(lmtOrdArr[j].status ==='Working'){
                lmtOrdArr[j].working=working;
                lmtOrdArr[j].quantity=parseFloat(working).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }); // partial working filled quantity formatter issue fix
              }
              if(parseFloat(wk)===0 || parseFloat(wk)==='0'){
                if(lmtOrdArr[j].docNo === ''){
                  lmtOrdArr.splice(j, 1);
                }else{
                  lmtOrdArr[j].status='Filled';
                  templmtArrayFill[i].status='Filled';
                }
              }
            }
          }
        check=1;
          break;
        }
      }

      if(check!==1)
      {
        var obj = {
          'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
          'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
            ? "BUY"
            : "SELL"),
          'cmdtyPair': cmdtypair,
          'quantity': parseFloat(msg.FQ).toFixed(config.QuantityRoundOff),
          'rate': (Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: minAmtDec, maximumFractionDigits:amntDec })),
          'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
          'docNo': msg.NFD,
          'orderNo': msg.NOD,
          'valDate': moment(msg.VD).format(appConstants.shortDateFormat),
          'wk':working,
          'fq':filled,
          'TFQ':filled,
          'comments': msg.RMK,
          'accDescription': msg.AD,
          'cmdtyId': msg.IID,
          'dealType': msg?.INLOOP ? LoopDealType : dealType,
          'status':msg.OMT === 5 || msg.OMT ===10 ?'Filled':'Partially Filled',
          'OT':msg.OT
        };
        var obj2 = {
          id: msg.ID,
          'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
          'status':msg.OMT === 5 || msg.OMT ===10 ?'Filled':'Partially Filled',
          'deal':(parseInt(msg.DT) === appConstants.TRADER_BUY
              ? "BUY"
              : "SELL"),
          'pair': cmdtypair,
          'quantity': parseFloat(filled).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }), // added for formatter issue in fill order when ALL selected
          'rate': (Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: minAmtDec, maximumFractionDigits:amntDec })),
          'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
          'orderNo': (msg.NOD
            ? msg.NOD
            : ""),
          'docNo':msg.NFD,
          'accDescription':msg.AD,
          'comments': msg.RMK,
          'cmdtyId': msg.IID,
          'dealType': msg?.INLOOP ? LoopDealType : dealType,
          'OT':msg.OT
        };
        templmtArrayFill.unshift(obj);
        lmtOrdArr.unshift(obj2);
      }
    }else{
      var obj = {
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
        'cmdtyPair': cmdtypair,
        'quantity': parseFloat(msg.FQ).toFixed(config.QuantityRoundOff),
        'rate': (Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: minAmtDec, maximumFractionDigits:amntDec })),
        'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
        'docNo': msg.NFD,
        'orderNo': msg.NOD,
        'valDate': moment(msg.VD).format(appConstants.shortDateFormat),
        'wk':working,
        'fq':filled,
        'TFQ':filled,
        'comments': msg.RMK,
        'accDescription': msg.AD,
        'cmdtyId': msg.IID,
        'dealType': msg?.INLOOP ? LoopDealType : dealType,
        'status':msg.OMT === 5 || msg.OMT ===10 ?'Filled':'Partially Filled',
        'OT':msg.OT

      };
      var obj2 = {
        id: msg.ID,
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'status':msg.OMT === 5 || msg.OMT ===10 ? 'Filled' : 'Partially Filled',
        'deal':(parseInt(msg.DT) === appConstants.TRADER_BUY
            ? "BUY"
            : "SELL"),
        'pair': cmdtypair,
        'quantity': parseFloat(filled).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }), // formatter added for BCM 209 hedgefill 
        'rate': (Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: minAmtDec, maximumFractionDigits:amntDec })),
        'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
        'orderNo': (msg.NOD
          ? msg.NOD
          : ""),
        'docNo':msg.NFD,
        'accDescription':msg.AD,
        'comments': msg.RMK,
        'cmdtyId': msg.IID,
        'dealType': msg?.INLOOP ? LoopDealType : dealType,
        'OT':msg.OT
      };
      templmtArrayFill.unshift(obj);
      lmtOrdArr.unshift(obj2);
    }
    lmObj.outstandingLm.outstandingLmArr = templmtArray;
    lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.limitOrdMap = temMap;
    lmObj.lmFillOrd.lmFillOrdArr = templmtArrayFill;
    lmObj.lmFillOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
    lmObj.lmtOrdersRows = lmtOrdArr;
  }
}else if((msg.OT === appConstants.OCO_ORD_TYPE) && (appConstants.ORD_UNHEDGE_FILL === msg.BCM || appConstants.ORD_HEDGE_FILL=== msg.BCM)){
  var templmtArrayFill = []
  if (lmObj.lmFillOrd.lmFillOrdArr !== undefined) {
    if (lmObj.lmFillOrd.lmFillOrdArr.length !== 0) {
      templmtArrayFill = lmObj.lmFillOrd.lmFillOrdArr;
    }
  }
var lmtOrd=temMap.get(msg.NOD);
if(msg.BCM === appConstants.ORD_UNHEDGE_FILL ||(appConstants.ORD_HEDGE_FILL=== msg.BCM && msg.OMT === appConstants.FINAL_FILL)){
  if(templmtArrayFill.findIndex(x => (x.orderNo == msg.NOD) ) !== -1){
    templmtArrayFill.splice(templmtArrayFill.findIndex(x => (x.orderNo == msg.NOD) ),1)
  }
  if(templmtArray.findIndex(x => (x.orderNo == msg.NOD) ) !== -1){
    templmtArray.splice(templmtArray.findIndex(x => (x.orderNo == msg.NOD) ),1)
  }

  for (let i = 0; i < lmtOrdArr.length; i++) {
    if (lmtOrdArr[i].orderNo === msg.NOD) {
      lmtOrdArr.splice(i, 1);       
      i--;
    }
  }
  temMap.delete(msg.NOD);
  let qty= (msg.OMT === 4 ? msg.FQ : msg.TFQ);
  var obj = {
    id: msg.NFD, // unique ID required for devextreme, NFD is FNC doc no
    'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
    'status':'Filled',
    'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
      ? "BUY"
      : "SELL"),
    'cmdtyPair': cmdtypair,
    'quantity': parseFloat(qty).toFixed(config.QuantityRoundOff),
    'rate': (Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: minAmtDec, maximumFractionDigits:amntDec })),
    'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
    'docNo': msg.NFD,
    'orderNo': msg.NOD,
    'valDate': msg.VD,
    'comments': msg.RMK,
    'wk':msg.FQ,
    'fq':msg.FQ,
    'accDescription': msg.AD,
    'cmdtyId': msg.IID,
    'dealType': msg?.INLOOP ? LoopDealType : dealType,
    'OT':msg.OT
  };
  var obj2 = {
    id: msg.NFD, // unique ID required for devextreme, NFD is FNC doc no
    'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
    'status':'Filled',
    'deal':(parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL"),
    'pair': cmdtypair,
    'quantity': parseFloat(qty).toFixed(config.QuantityRoundOff),
    'working': parseFloat(qty).toFixed(config.QuantityRoundOff),
    'rate':(Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: minAmtDec, maximumFractionDigits:amntDec })),
    'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
    'orderNo': (msg.NOD
      ? msg.NOD
      : ""),
    'docNo':msg.NFD,
    'accDescription':msg.AD,
    'comments': msg.RMK,
    'cmdtyId': msg.IID,
    'dealType': msg?.INLOOP ? LoopDealType : dealType,
    'OT':msg.OT
  };
  lmtOrdArr.unshift(obj2);
  templmtArrayFill.unshift(obj);
  lmObj.lmtOrdersRows = lmtOrdArr;
  lmObj.outstandingLm.outstandingLmArr = templmtArray;
  lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.limitOrdMap = temMap;
  lmObj.lmFillOrd.lmFillOrdArr = templmtArrayFill;
  lmObj.lmFillOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
}else{
  let filled=0;
  let working=0;
  let check=0;
  let isPresentInAll=false;
  let isInFill=false;

  for (let i = 0; i < templmtArray.length; i++) {
    if (templmtArray[i].orderNo === msg.NOD) {
      templmtArray[i].working=parseFloat((""+templmtArray[i].working).replace(/,/g, ''))-parseFloat(msg.FQ);
      working=Number(templmtArray[i].working).toFixed(config.QuantityRoundOff);
      let tempFill = numeral(templmtArray[i].filled)._value;
      templmtArray[i].filled=parseFloat(tempFill)+parseFloat(msg.FQ);
      filled=templmtArray[i].filled
     if(parseFloat(working)===0){
        for (let i = 0; i < templmtArray.length; i++) {
          if (templmtArray[i].orderNo === msg.NOD) {
            templmtArray.splice(i, 1);
            break;
          }
        }
      }
      break;
    }
  }
  for (let j = 0; j < lmtOrdArr.length; j++) {
    if (lmtOrdArr[j].orderNo === msg.NOD) {
              lmtOrdArr[j].rate=msg.DR;
              if(lmtOrdArr[j].status ==='Working'){
                lmtOrdArr[j].working=working;
                lmtOrdArr[j].quantity=working;
              }
              lmtOrdArr[j].status=(msg.OMT === 5 || msg.OMT ===10 ?'Filled':'Partially Filled');
              lmtOrdArr[j].docNo=(msg.NFD ? msg.NFD : lmtOrdArr[j].docNo)
            //j--;
      check=1;
      isPresentInAll=true;
    }
  }



  if(templmtArrayFill.length > 0){
    if(templmtArrayFill.findIndex(x => (x.orderNo == msg.NOD) ) === -1){
      check=0;
      isInFill=false
    }
    for (let i = 0; i < templmtArrayFill.length; i++) {
      if (templmtArrayFill[i].orderNo === msg.NOD) {
        templmtArrayFill[i].wk=parseFloat(templmtArrayFill[i].wk)-parseFloat(msg.FQ);
        templmtArrayFill[i].fq=parseFloat(templmtArrayFill[i].fq)+parseFloat(msg.FQ);
        let wk =Number(templmtArrayFill[i].wk).toFixed(config.QuantityRoundOff);
        templmtArrayFill[i].quantity=templmtArrayFill[i].fq;
        templmtArrayFill[i].rate=msg.DR;
        lmtOrd.WKQ=wk;
        lmtOrd.FQ=templmtArrayFill[i].fq;
        lmtOrd.TFQ=templmtArrayFill[i].fq;
        temMap.set(msg.NOD,lmtOrd);
        if(lmtOrdArr.findIndex(x => (x.orderNo == msg.NOD) ) !== -1){
          let tempIndex=lmtOrdArr.findIndex(x => (x.orderNo == msg.NOD));
          lmtOrdArr[tempIndex].quantity=templmtArrayFill[i].fq;
          lmtOrdArr[tempIndex].rate=msg.DR;
        }
        check=1;
        isInFill=true;
        break;
      }
    }

    if(check!==1){
      var obj = {
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
        'cmdtyPair': cmdtypair,
        'quantity': parseFloat(msg.FQ).toFixed(config.QuantityRoundOff),
        'rate': (Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: minAmtDec, maximumFractionDigits:amntDec })),
        'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
        'docNo': msg.NFD,
        'orderNo': msg.NOD,
        'valDate': moment(msg.VD).format(appConstants.shortDateFormat),
        'wk':working,
        'fq':filled,
        'TFQ':filled,
        'comments': msg.RMK,
        'accDescription': msg.AD,
        'cmdtyId': msg.IID,
        'dealType': msg?.INLOOP ? LoopDealType : dealType,
        'status':msg.OMT === 5 || msg.OMT ===10 ?'Filled':'Partially Filled',
        'OT':msg.OT
      };
      var obj2 = {
        id: msg.ID,
        'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        'status':msg.OMT === 5 || msg.OMT ===10 ?'Filled':'Partially Filled',
        'deal':(parseInt(msg.DT) === appConstants.TRADER_BUY
            ? "BUY"
            : "SELL"),
        'pair': cmdtypair,
        'quantity': parseFloat(filled),
        'rate': (Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: minAmtDec, maximumFractionDigits:amntDec })),
        'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
        'orderNo': (msg.NOD
          ? msg.NOD
          : ""),
        'docNo':msg.NFD,
        'accDescription':msg.AD,
        'comments': msg.RMK,
        'cmdtyId': msg.IID,
        'dealType': msg?.INLOOP ? LoopDealType : dealType,
        'OT':msg.OT
      };
      if(!isInFill){
      templmtArrayFill.unshift(obj);}
      if(!isPresentInAll){
      lmtOrdArr.unshift(obj2);
      }
    }
  }else{
    var obj = {
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL"),
      'cmdtyPair': cmdtypair,
      'quantity': parseFloat(msg.FQ).toFixed(config.QuantityRoundOff),
      'rate': (Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: minAmtDec, maximumFractionDigits:amntDec })),
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
      'docNo': msg.NFD,
      'orderNo': msg.NOD,
      'valDate': moment(msg.VD).format(appConstants.shortDateFormat),
      'wk':working,
      'fq':filled,
      'TFQ':filled,
      'comments': msg.RMK,
      'accDescription': msg.AD,
      'cmdtyId': msg.IID,
      'dealType': msg?.INLOOP ? LoopDealType : dealType,
      'status':msg.OMT === 5 || msg.OMT ===10 ?'Filled':'Partially Filled',
      'OT':msg.OT

    };
    var obj2 = {
      id: msg.ID,
      'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      'status':msg.OMT === 5 || msg.OMT ===10 ? 'Filled' : 'Partially Filled',
      'deal':(parseInt(msg.DT) === appConstants.TRADER_BUY
          ? "BUY"
          : "SELL"),
      'pair': cmdtypair,
      'quantity': parseFloat(filled),
      'rate': (Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: minAmtDec, maximumFractionDigits:amntDec })),
      'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
      'orderNo': (msg.NOD
        ? msg.NOD
        : ""),
      'docNo':msg.NFD,
      'accDescription':msg.AD,
      'comments': msg.RMK,
      'cmdtyId': msg.IID,
      'dealType': msg?.INLOOP ? LoopDealType : dealType,
      'OT':msg.OT
    };
    templmtArrayFill.unshift(obj);
    lmtOrdArr.unshift(obj2);
  }
  lmObj.outstandingLm.outstandingLmArr = templmtArray;
  lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.limitOrdMap = temMap;
  lmObj.lmFillOrd.lmFillOrdArr = templmtArrayFill;
  lmObj.lmFillOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.lmtOrdersRows = lmtOrdArr;
}
}else if(appConstants.ORDER_EXPIRED===msg.BCM || appConstants.ORDER_UNHEDGE_EXPIRED===msg.BCM){
  var templmtArrayExpire = [];
  if (lmObj.lmExpOrd.lmExpOrdArr !== undefined) {
    if (lmObj.lmExpOrd.lmExpOrdArr !== 0) {
      templmtArrayExpire = lmObj.lmExpOrd.lmExpOrdArr;
    }
  }
  for (let i = 0; i < templmtArray.length; i++) {
    if (templmtArray[i].orderNo === msg.NOD) {
      templmtArray.splice(i, 1);
      break;
    }
  }
  for (let i = 0; i < lmtOrdArr.length; i++) {

    if (lmtOrdArr[i].orderNo === msg.NOD) {
      // lmtOrdArr.splice(i, 1);
      // break;
      if(lmtOrdArr[i].status === 'Working'){
        lmtOrdArr.splice(i, 1);
       }else{
        lmtOrdArr[i].status='Filled'
       }
    }
  }
  temMap.delete(msg.NOD);
  var obj = {
    id: msg.ID,
    'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
    'deal': (parseInt(msg.DT) === appConstants.TRADER_BUY
      ? "BUY"
      : "SELL"),
    'cmdtyPair': cmdtypair,
    'quantity': (parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff }), // formatter fix added,
    'rate': (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })),
    'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
    'orderNo': msg.NOD,
    'cmdtyId': msg.IID,
    'dealType': msg?.INLOOP ? LoopDealType : dealType,
    'OT':msg.OT
  }
  var obj2 = {
    id: msg.ID,
    'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
    'status':'Expired',
    'deal':(parseInt(msg.DT) === appConstants.TRADER_BUY
        ? "BUY"
        : "SELL"),
    'pair': cmdtypair,
    'quantity': msg.PQ ? (parseFloat(msg.PQ).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) : "0",
    'rate': (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })),
    'validity':(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")),
    'orderNo': (msg.NOD
      ? msg.NOD
      : ""),
    'docNo':'',
    'accDescription':msg.AD,
    'comments': msg.RMK,
    'cmdtyId': msg.IID,
    'dealType': msg?.INLOOP ? LoopDealType : dealType,
    'OT':msg.OT
  };
  // Bug#37000
    templmtArrayExpire.unshift(obj);
    lmtOrdArr.unshift(obj2);
  lmObj.lmExpOrd.lmExpOrdArr = templmtArrayExpire;
  lmObj.lmExpOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.outstandingLm.outstandingLmArr = templmtArray;
  lmObj.outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.limitOrdMap = temMap;
  lmObj.randomNo = Math.floor((Math.random() * 1000000) + 1);
  lmObj.lmtOrdersRows = lmtOrdArr;
}else if(msg.BCM === appConstants.UPDATE_FNC_RMK && msg.OT === 'ORDER' && msg.DT === 'ONG'){//used for updating FNC comments
    var templmtArrayAll = lmObj.lmtOrdersRows;
    if (templmtArrayAll.findIndex(x => (x.orderNo == msg.DN)) !== -1) {
      let tempIndex = templmtArrayAll.findIndex(x => (x.orderNo == msg.DN));
      templmtArrayAll[tempIndex].comments = msg.RMK;
    }
    lmObj.lmtOrdersRows = templmtArrayAll;
    lmObj.randomNo = Math.floor((Math.random() * 10) + 1);

    var templmtArrayFill = lmObj.lmFillOrd.lmFillOrdArr;
    if (templmtArrayFill.findIndex(x => (x.orderNo == msg.DN)) !== -1) {
      let tempIndex = templmtArrayFill.findIndex(x => (x.orderNo == msg.DN));
      templmtArrayFill[tempIndex].comments = msg.RMK;
    }
    lmObj.lmFillOrd.lmFillOrdArr = templmtArrayFill;
    lmObj.lmFillOrd.randomNo = Math.floor((Math.random() * 10) + 1);
}
    // empty array as we are adding everything together
    workingOrders.length = 0
    workingOrders.push(...templmtArray)
    try {
        if (workingOrders.length) {
            ordersStore.push({
                key: 'orderNo',
                type: 'update',
                data: workingOrders
            })
        }
    } catch (e) {
        /* 
            Note: changes.filter/ changes.forEach is not a function
            this error can be ignored as this
            happens when data is null/undefined 
            which it is at the start
        */
        console.log('os exc: ', e)
    }
  let openedWidgets = localStorage.getItem('openedWidgets');
  let flag= 0;
  if (openedWidgets )
  {
    JSON.parse(openedWidgets).map((widget) => {
      if (widget.substring(0, 16) === "OutstandingOrder") {
        flag=1;
      }
    })
  }
  if(flag === 1){
    localStorage.setItem('limitOrdBook', JSON.stringify(lmObj));
  }
  localStorage.setItem('outstandingLm', JSON.stringify(lmObj.outstandingLm));
  return lmObj;
}

export function benchmarkfillObj(msg, bmobj, benchmark) {
  let metal;
  let curr;
  var dec = getBMKDecimal(msg.IID);
  var mindec = getMinBMKDecimal(msg.IID);
  const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  metal = item.D1;
  curr = item.D2;
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  if (msg.BCM === appConstants.BENCHMARK_MANUAL_FILL) {
    let remark = "";
    let qty = (msg.OT === 5 ? msg.PQ : msg.QPF);
    if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
      remark = "BOUGHT" +
        " " + (Number(parseFloat(qty)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
          ? msg.SC
          : "") + " " + metal + "/" + curr + " @" + " " + (msg.FP
            ? ((parseFloat(msg.FP)).toLocaleString('en', { minimumFractionDigits: mindec, maximumFractionDigits: dec }))
            : "0") + " ";
    } else {
      remark = "SOLD" +
        " " + (Number(parseFloat(qty)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
          ? msg.SC
          : "") + " " + metal + "/" + curr + " @" + " " + (msg.FP
            ? ((parseFloat(msg.FP)).toLocaleString('en', { minimumFractionDigits: mindec, maximumFractionDigits: dec }))
            : "0") + " ";
    }
    var obj = [{
      flag: true,
      title: (msg.OT !== 5 ? 'Avg ' : '') + "Benchmark[ " + msg.BMN + " ]",
      eventType: "FILLED",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      benchmark: msg.BMN,
      docNo: msg.OT === 5 ? msg.ONB : msg.AVG,
      fixingDate: msg.DD ? moment(msg.DD).format(appConstants.shortDateFormat) : "",
      trader: msg.AD,
      remark: remark,
      comments: msg.RMK,
      remark2: ""
    }];
    localStorage.setItem('benmFillObj', JSON.stringify(obj));
    localStorage.setItem('benmFillObjflag', true);
    return obj;
  } else if (msg.BCM === appConstants.BM_MODIFIED) {
    //let tempMap= benchMrkBook.benchMrkMap.get()
    // msg.BMSET.map((bmDet)=>{
    let remark = "";
    let remark2 = "";
    if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
      remark = "BUY" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
          ? msg.SC
          : "") + " " + metal + "/" + curr + " " + msg.BMN + " ";
      remark2 = "Old: " + "BUY" +
        " " + (Number(parseFloat(msg.OPQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.OSC
          ? msg.OSC
          : "") + " " + metal + "/" + curr + " " + msg.BMN + " ";
    } else {
      remark = "SELL" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
          ? msg.SC
          : "") + " " + metal + "/" + curr + " " + msg.BMN + " ";
      remark2 = "Old: " + "SELL" +
        " " + (Number(parseFloat(msg.OPQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.OSC
          ? msg.OSC
          : "") + " " + metal + "/" + curr + " " + msg.BMN + " ";
    }
    let docNo = msg.ISAPPLY ? msg.ONB : msg.BMSET[0].DN;

    let bmData = benchmark.benchMrkMap.get(docNo);
    try {
      let fixingData = msg.ISAPPLY ? moment(msg.FD).format(appConstants.shortDateFormat) + " to " + moment(msg.TD).format(appConstants.shortDateFormat)
        : moment(bmData.DD).format(appConstants.shortDateFormat);
      var obj = [{
        flag: true,
        title: "Benchmark[ " + msg.BMN + " ]",
        eventType: "MODIFIED",
        ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        benchmark: msg.BMN,
        docNo: docNo,
        fixingDate: fixingData,
        trader: msg.AD,
        comments: msg.RMK,
        remark: remark,
        remark2: remark2
      }];
    } catch (e) {
      console.log("except" + e);
    }
    // tempArray.push(obj)
    // });
    localStorage.setItem('benmFillObj', JSON.stringify(obj));
    localStorage.setItem('benmFillObjflag', true);
    return obj;
  } else if (msg.BCM === appConstants.BM_CANCELLED) {
    let remark = "";
    if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
      remark = "BUY" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
          ? msg.SC
          : "") + " " + metal + "/" + curr + " " + msg.BMN + " ";
    } else {
      remark = "SELL" +
        " " + (Number(parseFloat(msg.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
          ? msg.SC
          : "") + " " + metal + "/" + curr + " " + msg.BMN + " ";
    }

    var obj = [{
      flag: true,
      title: "Benchmark[ " + msg.BMN + " ]",
      eventType: "CANCELLED",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      benchmark: msg.BMN,
      docNo: msg.ONB,
      fixingDate: msg.DD ? moment(msg.DD).format(appConstants.shortDateFormat) : '',
      trader: msg.AD,
      comments: msg.RMK,
      remark: remark
    }];
    localStorage.setItem('benmFillObj', JSON.stringify(obj));
    localStorage.setItem('benmFillObjflag', true);
    return obj;
  } else {
    return bmobj;
  }

}

export function limitFileeObj(msg, lmobj, limitOrdBook) {
  let metal;
  let curr;
  let comm;
  var dec = getMinAmntDecimal(msg.IID);
  var amntDec = getAmntDecimal(msg.IID);
  const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
  metal = item.D1;
  curr = item.D2;
  comm = item.B;
  if (msg.RMK === undefined) {
    msg.RMK = "";
  }
  let dealType = "";
  if (msg.OT === appConstants.STOP_ORD_TYPE) {
    dealType = "Stop ";
  } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
    if (msg.DOT === appConstants.STOP_ORD_TYPE) {
      dealType = 'OCO Stop ';
    } else {
      dealType = 'OCO Limit ';
    }
  }
  if (msg.BCM === appConstants.ORD_HEDGE_FILL || msg.BCM === appConstants.ORD_UNHEDGE_FILL) {
    let remark = "";
    let remark2 ="";
    let sc;
    if(parseInt(comm)===1){
      sc="";
    }else {
      sc="OZ";
    }
    let COTCQ=(msg.COTCQ ? msg.COTCQ: '0')
    let qty= (msg.OMT === 4 ? msg.FQ : msg.TFQ);
    remark = (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BOUGHT" : "SOLD") +
      " " + (Number(parseFloat(qty)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits:config.QuantityRoundOff})) + " " + sc + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.DR)).toLocaleString('en',{ minimumFractionDigits: item.amntMinDec, maximumFractionDigits: amntDec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    if(msg.OMT === 4){
      remark2 ="Working Balance: " + (parseInt(msg.DT) === appConstants.TRADER_BUY ? " BUY" : " SELL") +
        " " + (Number(parseFloat(msg.PQ)-parseFloat(msg.TFQ)-parseFloat(COTCQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff, maximumFractionDigits:config.QuantityRoundOff})) + " " + sc + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits:  item.amntMinDec, maximumFractionDigits:dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
          }

    let msgTitle;
    if (msg.OT === appConstants.STOP_ORD_TYPE) {
      msgTitle = 'Stop';
    } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
      if (msg.ISOTO) { 
        msgTitle = `OTO (OCO ${getOrderType(msg.DOT)})`;
      } else {
        msgTitle = `OCO (${getOrderType(msg.DOT)})`;
      }
    } else if (msg.OT === appConstants.OTO_ORD_TYPE || msg.ISOTO) {
      if (msg.ISOCO) {
        msgTitle = `OTO (OCO ${getOrderType(msg.LINKORD_DOT)} / ${getOrderType(msg.OCO_LINKORD_DOT)})`;
      } else {
        msgTitle = `OTO (${getOrderType(msg.LINKORD_DOT)})`;
      }
    } else {
      msgTitle = 'Limit'
    } 

    let orderStatus = (msg.OMT === 10 || msg.OMT === 5 ? "FILLED" : "PARTIALLY FILLED");
     var obj = [{
      flag: true,
      title: msgTitle,
      eventType: orderStatus,
      benchmark:"",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      docNo: msg.NOD,
      trader: msg.AD,
      comments:msg.RMK,
      remark: remark,
      remark2: remark2
    }];
    return obj;
  } else if (msg.ISOTO && msg.ISACTIVE && msg.BCM === appConstants.ORD_MODIFIED && (msg.OT !== appConstants.OCO_ORD_TYPE && msg.OT !== appConstants.OTO_ORD_TYPE) && msg.hasOwnProperty("NOD") && !msg?.NOD?.endsWith("/1")) {
    // 2nd OTO order modification notification
    let orderData=limitOrdBook.limitOrdMap.get(msg.NOD);
    let dealText = getDealType(msg.OT, msg.DOT, msg.DT);
    let remark =dealText+" " + (Number(parseFloat(msg.PQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));

    let remark2 = "Old: "+dealText +" " + (Number(parseFloat(msg.OPQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.OR)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.OVT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.OTIME)).format(appConstants.validityDateFormat) : (parseInt(msg.OVT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    let msgTitle;
    if (msg.OT === appConstants.STOP_ORD_TYPE) {
      msgTitle = 'Stop';
    } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
      msgTitle = `OCO (${getOrderType(msg.DOT)})`;
    } else if (msg.OT === appConstants.OTO_ORD_TYPE || msg.ISOTO) {
      if (msg.ISOCO) {
        msgTitle = `OTO (OCO ${getOrderType(msg.LINKORD_DOT)} / ${getOrderType(msg.OCO_LINKORD_DOT)})`;
      } else {
        msgTitle = `OTO (${getOrderType(msg.LINKORD_DOT)})`;
      }
    } else {
      msgTitle = 'Limit'
    } 
    const obj = [{
      flag: true,
      title: msgTitle,
      eventType: "MODIFIED",
      benchmark:"",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      docNo: msg.NOD,
      trader: msg.AD,
      comments:msg.RMK,
      remark: remark,
      remark2: remark2,
      LINKORD_ONG:""
    }];
    return obj;
  } else if (!msg.ISOTO && msg.BCM === appConstants.ORD_MODIFIED && (msg.OT !== appConstants.OCO_ORD_TYPE)) {
    //if(msg.modifyLinkOrd !== true ){
      let orderData=limitOrdBook.limitOrdMap.get(msg.NOD);
      let dealText = getDealType(msg.OT, msg.DOT, msg.DT);
      let remark =dealText+" " + (Number(parseFloat(msg.PQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
          ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));

      let remark2 = "Old: "+dealText +" " + (Number(parseFloat(msg.OPQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
          ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.OR)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.OVT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.OTIME)).format(appConstants.validityDateFormat) : (parseInt(msg.OVT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
      var obj = [{
        flag: true,
        title:msg.OT === appConstants.STOP_ORD_TYPE ? 'Stop': msg.OT === appConstants.OCO_ORD_TYPE ? 'OCO':'Limit',
        eventType: "MODIFIED",
        benchmark:"",
        ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        docNo: msg.NOD,
        trader: msg.AD,
        comments:msg.RMK,
        remark: remark,
        remark2: remark2,
        LINKORD_ONG:""
      }];
      return obj;
  } else if(!msg.ISOTO && msg.BCM === appConstants.OCO_ORD_BCM && msg.OMT === appConstants.MODORD) {
    let orderData=limitOrdBook.limitOrdMap.get(msg.NOD + "/1");
    const order1DT = (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    const order2DT = (parseInt(msg.LINKORD_DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    let remark = `Order 1: ${order1DT}` + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
      ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    let remark2 = `Old: ${order1DT}` +" " + (Number(parseFloat(msg.OPQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
      ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.OR)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(orderData.OVT) === appConstants.GTD ? "GTD: "+moment(parseFloat(orderData.OTIME)).format(appConstants.validityDateFormat) : (parseInt(orderData.OVT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    let linkOrdRmk = `Order 2: ${order2DT}` + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
      ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.LINKORD_R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    let linkOrdRmk2 = `Old: ${order2DT}` +" " + (Number(parseFloat(msg.OPQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.LINKORD_OR)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(orderData.OVT) === appConstants.GTD ? "GTD: "+moment(parseFloat(orderData.OTIME)).format(appConstants.validityDateFormat) : (parseInt(orderData.OVT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    
    let msgTitle;
    if (msg.OT === appConstants.STOP_ORD_TYPE) {
      msgTitle = 'Stop';
    } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
      msgTitle = `OCO (${getOrderType(msg.DOT)} / ${getOrderType(msg.LINKORD_DOT)})`;
    } else if (msg.OT === appConstants.OTO_ORD_TYPE || msg.ISOTO) {
      if (msg.ISOCO) {
        msgTitle = `OTO (${getOrderType(msg.DOT)} | OCO ${getOrderType(msg.LINKORD_DOT)} / ${getOrderType(msg.OCO_LINKORD_DOT)})`;
      } else {
        msgTitle = `OTO (${getOrderType(msg.DOT)} / ${getOrderType(msg.LINKORD_DOT)})`;
      }
    } else {
      msgTitle = 'Limit'
    } 
    var obj = [{
      flag: true,
      title: msgTitle,
      eventType: "MODIFIED",
      benchmark:"",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      docNo: msg.NOD,
      trader: msg.AD,
      comments:msg.RMK,
      remark: remark,
      remark2: remark2,
      linkOrdRmk:linkOrdRmk,
      linkOrdRmk2:linkOrdRmk2,
      LINKORD_ONG:msg.LINKORD_ONG,
      linkOrder:true
    }];
    return obj;
  } else if (msg.ISOTO && msg.BCM === appConstants.OCO_ORD_BCM && msg.OMT === appConstants.MODORD) {
    let orderData = limitOrdBook.limitOrdMap.get(msg.NOD + "/2");
    const order1DT = (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    const order2DT = (parseInt(msg.LINKORD_DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    let order3DT;
    const ord1OldValidity = msg.hasOwnProperty("OVT") ? msg.OVT : orderData.OVT;
    const ord1OldValidityDateTime = msg.hasOwnProperty("OTIME") ? msg.OTIME : msg.OTIME;
    const ord2Validity = msg.hasOwnProperty("LINKORD_VT") ? msg.LINKORD_VT : orderData.VT;
    const ord2ValidityDateTime = msg.hasOwnProperty("LINKORD_TIME") ? msg.LINKORD_TIME : msg.TIME;
    const ord2OldValidity = msg.hasOwnProperty("LINKORD_OVT") ? msg.LINKORD_OVT : orderData.OVT;
    const ord2OldValidityDateTime = msg.hasOwnProperty("LINKORD_OTIME") ? msg.LINKORD_OTIME : msg.OTIME;
    let remark = `Order 1: ${order1DT}` + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
      ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    let remark2 = `Old: ${order1DT}` +" " + (Number(parseFloat(msg.OPQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
      ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.OR)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(ord1OldValidity) === appConstants.GTD ? "GTD: "+moment(parseFloat(ord1OldValidityDateTime)).format(appConstants.validityDateFormat) : (parseInt(ord1OldValidity) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    
    // const ord3Validity = msg.hasOwnProperty("LINKORD_VT") ? msg.LINKORD_VT : msg.VT;
    // const ord3ValidityDateTime = msg.hasOwnProperty("LINKORD_TIME") ? msg.LINKORD_TIME : msg.TIME;
    // const ord3OldValidity = msg.hasOwnProperty("LINKORD_OVT") ? msg.LINKORD_OVT : msg.OVT;
    // const ord3OldValidityDateTime = msg.hasOwnProperty("LINKORD_OTIME") ? msg.LINKORD_OTIME : msg.OTIME;
    let linkOrdRmk = `Order 2: ${msg.hasOwnProperty("OCO_LINKORD_CTID") ? "(" + order2DT : order2DT}`+" " + (Number(parseFloat(msg.PQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
      ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.LINKORD_R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(ord2Validity) === appConstants.GTD ? "GTD: "+moment(parseFloat(ord2ValidityDateTime)).format(appConstants.validityDateFormat) : (parseInt(ord2Validity) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    let linkOrdRmk2 = `Old: ${msg.hasOwnProperty("OCO_LINKORD_CTID") ? "(" : ""}${order2DT}` +" " + (Number(parseFloat(msg.OPQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.LINKORD_OR)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(ord2OldValidity) === appConstants.GTD ? "GTD: "+moment(parseFloat(ord2OldValidityDateTime)).format(appConstants.validityDateFormat) : (parseInt(ord2OldValidity) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    
    // OTO-OCO orders
    if (msg.hasOwnProperty("OCO_LINKORD_CTID")) {
      // get order type
      order3DT = (parseInt(msg.LINKORD_DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
      
      // generate remark
      linkOrdRmk += `) / (${order3DT} ` + (Number(parseFloat(msg.GQ)-parseFloat((msg.LINKORD_TFQ !== undefined?parseFloat(msg.LINKORD_TFQ):0))).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.OCO_LINKORD_R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(ord2Validity) === appConstants.GTD ? "GTD: "+moment(parseFloat(ord2ValidityDateTime)).format(appConstants.validityDateFormat) : (parseInt(ord2Validity) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")) + ")";
      linkOrdRmk2 += `) / (${order3DT} ` + (Number(parseFloat(msg.OPQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.OCO_LINKORD_OR)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.OCO_LINKORD_OVT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.OCO_LINKORD_OTIME)).format(appConstants.validityDateFormat) : (parseInt(msg.OCO_LINKORD_OVT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")) + ")"
    }

    let msgTitle;
    if (msg.OT === appConstants.STOP_ORD_TYPE) {
      msgTitle = 'Stop';
    } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
      if (msg.ISOTO) {
        msgTitle = `OTO (OCO ${getOrderType(msg.DOT)} / ${getOrderType(msg.LINKORD_DOT)})`;
      } else {
        msgTitle = `OCO (${getOrderType(msg.DOT)} / ${getOrderType(msg.LINKORD_DOT)})`;
      }
    } else if (msg.OT === appConstants.OTO_ORD_TYPE || msg.ISOTO) {
      if (msg.ISOCO) {
        msgTitle = `OTO (${getOrderType(msg.DOT)} | OCO ${getOrderType(msg.LINKORD_DOT)} / ${getOrderType(msg.OCO_LINKORD_DOT)})`;
      } else {
        msgTitle = `OTO (${getOrderType(msg.DOT)} / ${getOrderType(msg.LINKORD_DOT)})`;
      }
    } else {
      msgTitle = 'Limit'
    } 
    var obj = [{
      flag: true,
      title: msgTitle,
      eventType: "MODIFIED",
      benchmark:"",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      docNo: msg.NOD,
      trader: msg.AD,
      comments:msg.RMK,
      remark: remark,
      remark2: remark2,
      linkOrdRmk:linkOrdRmk,
      linkOrdRmk2:linkOrdRmk2,
      LINKORD_ONG:msg.LINKORD_ONG,
      linkOrder:true
    }];
    return obj;
  } else if (!!msg?.loopOrderPlace && !!msg?.ISOTO && !!msg?.INLOOP && msg.BCM === appConstants.OCO_ORD_BCM && msg.OMT === appConstants.NEWORD) {
    const order1DT = (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    const order2DT = (parseInt(msg.LINKORD_DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    let order3DT;
    let remark = `Order 1: ${order1DT}` + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
      ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    let linkOrdRmk = `Order 2: ${msg.hasOwnProperty("OCO_LINKORD_CTID") ? "(" + order2DT : order2DT}`+" " + (Number(parseFloat(msg.PQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
      ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.LINKORD_R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.LINKORD_VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.LINKORD_TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.LINKORD_VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    
    // OTO-OCO orders
    if (msg.hasOwnProperty("OCO_LINKORD_CTID")) {
      // get order type
      order3DT = (parseInt(msg.LINKORD_DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
      
      // generate remark
      linkOrdRmk += `) / (${order3DT} ` + (Number(parseFloat(msg.GQ)-parseFloat((msg.LINKORD_TFQ !== undefined?parseFloat(msg.LINKORD_TFQ):0))).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.OCO_LINKORD_R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.LINKORD_VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.LINKORD_TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.LINKORD_VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")) + ")";
    }

    let msgTitle;
    if (msg.OT === appConstants.STOP_ORD_TYPE) {
      msgTitle = 'Stop';
    } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
      msgTitle = `OCO (${getOrderType(msg.DOT)} / ${getOrderType(msg.LINKORD_DOT)})`;
    } else if (msg.OT === appConstants.OTO_ORD_TYPE || msg.ISOTO) {
      if (msg.ISOCO) {
        msgTitle = `OTO (${getOrderType(msg.DOT)} | OCO ${getOrderType(msg.LINKORD_DOT)} / ${getOrderType(msg.OCO_LINKORD_DOT)})`;
      } else {
        msgTitle = `OTO (${getOrderType(msg.DOT)} / ${getOrderType(msg.LINKORD_DOT)})`;
      }
    } else {
      msgTitle = 'Limit'
    } 
    var obj = [{
      flag: true,
      title: msgTitle,
      eventType: "PLACED",
      benchmark:"",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      docNo: msg.NOD,
      trader: msg.AD,
      comments:msg.RMK,
      remark: remark,
      linkOrdRmk:linkOrdRmk,
      LINKORD_ONG:msg.LINKORD_ONG,
      linkOrder:true
    }];
    return obj;
  } else if (!!msg?.ISOTO && msg.BCM === appConstants.ORD_ACTIVATED) {
    const order1DT = (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    let remark = `${order1DT}` + " " + (Number(parseFloat(msg.PQ)).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
      ? msg.SC : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));

    let msgTitle;
    if (msg.OT === appConstants.STOP_ORD_TYPE) {
      msgTitle = 'Stop';
    } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
      if (msg.ISOTO) { 
        msgTitle = `OTO (OCO ${getOrderType(msg.DOT)})`;
      } else {
        msgTitle = `OCO (${getOrderType(msg.DOT)})`;
      }
    } else if (msg.OT === appConstants.OTO_ORD_TYPE || msg.ISOTO) {
      if (msg.ISOCO) {
        msgTitle = `OTO (${getOrderType(msg.DOT)} | OCO ${getOrderType(msg.LINKORD_DOT)} / ${getOrderType(msg.OCO_LINKORD_DOT)})`;
      } else {
        msgTitle = `OTO (${getOrderType(msg.DOT)})`;
      }
    } else {
      msgTitle = 'Limit'
    } 
    var obj = [{
      flag: true,
      title: msgTitle,
      eventType: "ACTIVATED",
      benchmark:"",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      docNo: msg.NOD,
      trader: msg.AD,
      comments:msg.RMK,
      remark: remark,
      LINKORD_ONG:msg.LINKORD_ONG
    }];
    return obj;
  } else if (!msg.ISOTO && (msg.BCM === appConstants.ORDER_UNHEDGE_EXPIRED || msg.BCM === appConstants.ORDER_EXPIRED)) { 
    let remark = ""
    // dealType = msg.DOT === appConstants.STOP_ORD_TYPE ? 'OTO STOP ' : 'OTO Limit ';
    dealType += `${msg.ISOTO ? 'OTO ' : ''}`
    if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
      remark = "BUY" +
        " " + (Number(parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    } else {
      remark = "SELL" +
        " " + (Number(parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD:"+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    }
    let msgTitle;
    if (msg.OT === appConstants.STOP_ORD_TYPE) {
      msgTitle = 'Stop';
    } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
      msgTitle = `OCO (${getOrderType(msg.DOT)})`;
    } else if (msg.OT === appConstants.OTO_ORD_TYPE || msg.ISOTO) {
      if (msg.ISOCO) {
        msgTitle = `OTO (${getOrderType(msg.DOT)} | OCO ${getOrderType(msg.LINKORD_DOT)} / ${getOrderType(msg.OCO_LINKORD_DOT)})`;
      } else {
        msgTitle = `OTO (${getOrderType(msg.DOT)} / ${getOrderType(msg.LINKORD_DOT)})`;
      }
    } else {
      msgTitle = 'Limit'
    } 
    var obj = [{
      flag: true,
      title: msgTitle,
      eventType: "EXPIRED",
      benchmark:"",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      docNo: msg.NOD,
      trader: msg.AD,
      comments:msg.RMK,
      remark: remark,
      remark2: ""
    }];
    return obj;
  } else if ((msg.ISOTO && msg.ISACTIVE && !msg?.NOD?.endsWith("/1")) && (msg.BCM === appConstants.ORDER_UNHEDGE_EXPIRED || msg.BCM === appConstants.ORDER_EXPIRED)) { 
    let remark = ""
    // dealType = msg.DOT === appConstants.STOP_ORD_TYPE ? 'OTO STOP ' : 'OTO Limit ';
    dealType += `${msg.ISOTO ? 'OTO ' : ''}`
    if (parseInt(msg.DT) === appConstants.TRADER_BUY) {
      remark = "BUY" +
        " " + (Number(parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    } else {
      remark = "SELL" +
        " " + (Number(parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD:"+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    }
    let msgTitle;
    if (msg.OT === appConstants.STOP_ORD_TYPE) {
      msgTitle = 'Stop';
    } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
      msgTitle = `OCO (${getOrderType(msg.DOT)})`;
    } else if (msg.OT === appConstants.OTO_ORD_TYPE || msg.ISOTO) {
      if (msg.ISOCO) {
        msgTitle = `OTO (${getOrderType(msg.DOT)} | OCO ${getOrderType(msg.LINKORD_DOT)} / ${getOrderType(msg.OCO_LINKORD_DOT)})`;
      } else {
        msgTitle = `OTO (${getOrderType(msg.DOT)})`;
      }
    } else {
      msgTitle = 'Limit'
    } 
    var obj = [{
      flag: true,
      title: msgTitle,
      eventType: "EXPIRED",
      benchmark:"",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      docNo: msg.NOD,
      trader: msg.AD,
      comments:msg.RMK,
      remark: remark,
      remark2: ""
    }];
    return obj;
  } else if (msg.BCM === appConstants.ORD_CANCEL) {
    if(!msg?.ISOTO && (msg.OT === appConstants.STOP_ORD_TYPE || msg.OT === appConstants.LMT_ORD_TYPE || (msg.OT === appConstants.OCO_ORD_TYPE && !msg.isUserCancel && !msg.NFD))){
      let remark = "";
      let remark2 = "";
      // dealType = msg.DOT === appConstants.STOP_ORD_TYPE ? 'OTO STOP ' : 'OTO Limit ';
      remark = (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL") +
        " " + (Number(parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    
      let msgTitle;
      if (msg.OT === appConstants.STOP_ORD_TYPE) {
        msgTitle = 'Stop';
      } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
        msgTitle = `OCO (${getOrderType(msg.DOT)})`;
      } else if (msg.OT === appConstants.OTO_ORD_TYPE || msg.ISOTO) {
        if (msg.ISOCO) {
          msgTitle = `OTO (${getOrderType(msg.DOT)} | OCO ${getOrderType(msg.LINKORD_DOT)} / ${getOrderType(msg.OCO_LINKORD_DOT)})`;
        } else {
          msgTitle = `OTO (${getOrderType(msg.DOT)} / ${getOrderType(msg.LINKORD_DOT)})`;
        }
      } else {
        msgTitle = 'Limit'
      }
      var obj = [{
        flag: true,
        title: msgTitle,
        eventType: "CANCELLED",
        benchmark:"",
        ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        docNo: msg.NOD,
        trader: msg.AD,
        comments:msg.RMK,
        remark: remark,
        remark2: remark2
      }];
      return obj;
    } else if ((msg.ISOTO && msg.ISACTIVE && !msg.ISOCO && msg.hasOwnProperty("NOD") && !msg?.NOD?.endsWith("/1")) || (msg.ISOTO && msg.ISACTIVE && msg.ISOCO && !msg.isUserCancel)) {
      // 2nd order cancellation after activating
      let remark = "";
      let remark2 = "";
      // dealType = msg.DOT === appConstants.STOP_ORD_TYPE ? 'OTO STOP ' : 'OTO Limit ';
      remark = (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL") +
        " " + (Number(parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    
      let msgTitle;
      if (msg.OT === appConstants.STOP_ORD_TYPE) {
        msgTitle = 'Stop';
      } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
        if (msg.ISOTO) { 
          msgTitle = `OTO (OCO ${getOrderType(msg.DOT)})`;
        } else {
          msgTitle = `OCO (${getOrderType(msg.DOT)})`;
        }
      } else if (msg.OT === appConstants.OTO_ORD_TYPE || msg.ISOTO) {
        if (msg.ISOCO) {
          msgTitle = `OTO (${getOrderType(msg.DOT)} | OCO ${getOrderType(msg.LINKORD_DOT)} / ${getOrderType(msg.OCO_LINKORD_DOT)})`;
        } else {
          msgTitle = `OTO (${getOrderType(msg.DOT)} / ${getOrderType(msg.LINKORD_DOT)})`;
        }
      } else {
        msgTitle = 'Limit'
      }
      var obj = [{
        flag: true,
        title: msgTitle,
        eventType: "CANCELLED",
        benchmark:"",
        ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
        docNo: msg.NOD,
        trader: msg.AD,
        comments:msg.RMK,
        remark: remark,
        remark2: remark2
      }];
      return obj;
    }
  } else if (msg.BCM === appConstants.OCO_ORD_BCM && (msg.OMT === appConstants.CANCELORD || msg.OMT === appConstants.EXPIREDORD) && msg.LINKORD_FILLED !== true) {
    const order1DT = (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    const order2DT = (parseInt(msg.LINKORD_DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
    let order3DT, ocoOrd3Rmk = "";
    let remark = `Order 1: ${order1DT}`+" " + (Number(parseFloat(msg.GQ)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
      ? msg.SC
      : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    
    let VT = msg.LINKORD_VT ? msg.LINKORD_VT : msg.VT; //bug30411 changes
    let TIME = msg.LINKORD_TIME ? msg.LINKORD_TIME : msg.TIME //bug30411 changes
    let linkOrdRmk = `Order 2: ${msg.hasOwnProperty("OCO_LINKORD_CTID") ? "(" + order2DT : order2DT}`+" " + (Number(parseFloat(msg.GQ)-parseFloat((msg.LINKORD_TFQ !== undefined?parseFloat(msg.LINKORD_TFQ):0))).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
      ? msg.SC
      : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.LINKORD_R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(TIME)).format(appConstants.validityDateFormat) : (parseInt(VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC"));
    
    // OTO-OCO orders
    if (msg.hasOwnProperty("OCO_LINKORD_CTID")) {
      // get order type
      order3DT = (parseInt(msg.LINKORD_DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
      
      // generate remark
      linkOrdRmk += `) / (${order3DT} ` + (Number(parseFloat(msg.GQ)-parseFloat((msg.LINKORD_TFQ !== undefined?parseFloat(msg.LINKORD_TFQ):0))).toLocaleString('en',{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC
        ? msg.SC
        : "") + " " + metal + "/" + curr + " @ " + (Number(parseFloat(msg.OCO_LINKORD_R)).toLocaleString('en',{ minimumFractionDigits: dec })) + ", "+(parseInt(msg.LINKORD_VT) === appConstants.GTD ? "GTD: "+moment(parseFloat(msg.LINKORD_TIME)).format(appConstants.validityDateFormat) : (parseInt(msg.LINKORD_VT) === appConstants.DAY ? "DAY: 1700 NYC" : "GTC")) + ")";
    }

    let msgTitle;
    if (msg.OT === appConstants.STOP_ORD_TYPE) {
      msgTitle = 'Stop';
    } else if (msg.OT === appConstants.OCO_ORD_TYPE) {
      if (msg.ISOTO) { 
        msgTitle = `OTO (OCO ${getOrderType(msg.DOT)} / ${getOrderType(msg.LINKORD_DOT)})`;
      } else {
        msgTitle = `OCO (${getOrderType(msg.DOT)} / ${getOrderType(msg.LINKORD_DOT)})`;
      }
    } else if (!!msg.ISOTO || msg.OT === appConstants.OTO_ORD_TYPE) {
      if (msg.ISOCO || msg.OT === appConstants.OCO_ORD_TYPE) {
        msgTitle = `OTO (${getOrderType(msg.DOT)} | OCO ${getOrderType(msg.LINKORD_DOT)} / ${getOrderType(msg.OCO_LINKORD_DOT)})`;
      } else {
        msgTitle = `OTO (${getOrderType(msg.DOT)} / ${getOrderType(msg.LINKORD_DOT)})`;
      }
    } else {
      msgTitle = 'Limit'
    }
    let eventName;
    if (msg.OMT === appConstants.EXPIREDORD) {
      eventName = "EXPIRED";
    } else if (msg.OMT === appConstants.CANCELORD) {
      eventName = "CANCELLED";
    }
    return [{
      flag: true,
      title: msgTitle,
      eventType: eventName,
      benchmark:"",
      ts: moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
      docNo: msg.NOD,
      trader: msg.AD,
      comments:msg.RMK,
      remark: remark,
      linkOrdRmk:linkOrdRmk,
      LINKORD_ONG:msg.LINKORD_ONG,
      ocoLinkOrdRmk: ocoOrd3Rmk,
      OCO_LINKORD_ONG:msg.OCO_LINKORD_ONG,
      linkOrder: true,
      ocoLinkOrder: msg.hasOwnProperty("OCO_LINKORD_CTID")
    }];
  } else {
    return lmobj;
  }
}

const setOrdCTID = (ctid, ordersCTID) => {
  ordersCTID.push(ctid);
  return ordersCTID;
}
const updateCtid = (msg, trdCTID) => {
  if (msg.BCM === appConstants.TRADE_REQUEST_CONFIRMED || msg.BCM === appConstants.TRADE_REQUEST_REJCTED ||
    msg.BCM === appConstants.MARGIN_CHECKS_FAILED || msg.BCM === appConstants.INITIAL_CHECKS_FAILED) {
    trdCTID = null;
  }
  localStorage.setItem('trdCTID', trdCTID);
  return trdCTID;
}
const setRefreshFlag = () => {
  localStorage.setItem('LoadFlag', false);
  return false;
}

export function setPayRequestRejectModal(msg, payReqRejectModal) {
  var obj = {};
  let defaultAC = JSON.parse(localStorage.getItem('DefaultAC'));
  if (msg.AC === defaultAC.AC) {
    if (msg.BCM === appConstants.PAYMENT_REQUEST_FAIL) {
      if (parseInt(msg.OMT) === 2) {
        obj.title = "Modify Payment Request -" + msg.DN;
      } else if (parseInt(msg.OMT) === 6) {
        obj.title = "Cancel Payment Request -" + msg.DN;
      } else {
        obj.title = "Place Payment Request";
      }
      obj.mdflag = true;
      obj.msg = "Your payment request was unsuccessful. Please see the Activity Log for details.";//msg.MSG;
      obj.docNo = msg.DN;
      payReqRejectModal = obj;
    }
  }
  return payReqRejectModal
}

const closePayReqRejectModal = (payReqRejectModal) => {
  var obj1 = {
    mdflag: false,
    title: "",
    msg: "",
    docNo: ""
  };
  payReqRejectModal = obj1;
  return obj1;
}

const updateBMKMarkup = (msg, benchMrkBook) => {
  var item = JSON.parse(localStorage.getItem(msg.IID));
  var tempbenchArray = [];
  if (benchMrkBook.outStanBencMrkOrd) {
    if (benchMrkBook.outStanBencMrkOrd.outStanBencMrkArray !== undefined) {
      if (benchMrkBook.outStanBencMrkOrd.outStanBencMrkArray.length !== 0) {
        tempbenchArray = benchMrkBook.outStanBencMrkOrd.outStanBencMrkArray;
      }
    }
  }
  for (let i = 0; i < tempbenchArray.length; i++) {
    if (tempbenchArray[i].cmdtyId === msg.IID && tempbenchArray[i].accCode === msg.AC && !tempbenchArray[i].isSPRSelected) {
      var SPRPER = '';
      if (tempbenchArray[i].SPRPER && (parseFloat(tempbenchArray[i].SPRPER) !== 0)) {
        SPRPER = (Number(parseFloat(tempbenchArray[i].SPRPER)).toLocaleString('en', { minimumFractionDigits: config.roundOff, maximumFractionDigits: config.roundOff })) + " % | "
      }
      if (tempbenchArray[i].deal === 'BUY') {
        var SPR = " $ " + (Number(parseFloat(msg.BA) * -1).toLocaleString('en', { minimumFractionDigits: item.pMinDec, maximumFractionDigits: item.pDec }));
        tempbenchArray[i].spreadVal = SPRPER + '' + SPR

      } else {
        var SPR = " $ " + (Number(parseFloat(msg.BB) * -1).toLocaleString('en', { minimumFractionDigits: item.pMinDec, maximumFractionDigits: item.pDec }));
        tempbenchArray[i].spreadVal = SPRPER + '' + SPR
      }
    }
  }
  benchMrkBook.outStanBencMrkOrd.outStanBencMrkArray = tempbenchArray;
  benchMrkBook.outStanBencMrkOrd.randomNo = Math.floor((Math.random() * 1000000) + 1);
  return benchMrkBook
}

const updateAvgBMKMarkup = (msg, avgBMKData) => {
  var item = JSON.parse(localStorage.getItem(msg.IID));
  let avgBMKDetails = avgBMKData;
  if(item){
  avgBMKDetails = avgBMKDetails.map((data) => {
    if (data.cmdtyId === msg.IID && data.accCode === msg.AC && !data.isSPRSelected) {
      var SPRPER = '';
      if (data.SPRPER && (parseFloat(data.SPRPER) !== 0)) {
        SPRPER = (Number(parseFloat(data.SPRPER)).toLocaleString('en', { minimumFractionDigits: config.roundOff, maximumFractionDigits: config.roundOff })) + " % | "
        data.SPRPER = parseFloat(data.SPRPER)
      }
      if (data.Deal === 'BUY') {
        var SPR = " $ " + (Number(parseFloat(msg.BA) * -1).toLocaleString('en', { minimumFractionDigits: item.pMinDec, maximumFractionDigits: item.pDec }));
        data.Spread = SPRPER + '' + SPR
        data.SPR = (parseFloat(msg.BA) * -1);

        } else {
          var SPR = " $ " + (Number(parseFloat(msg.BB) * -1).toLocaleString('en', { minimumFractionDigits: item.pMinDec, maximumFractionDigits: item.pDec }));
          data.Spread = SPRPER + '' + SPR;
          data.SPR = (parseFloat(msg.BB) * -1);

        }
      }
      return data;
    })
  }
  return avgBMKDetails;
}
const getSpreadValueForPCS = (preType, preRate) => {
  let sprVal = 'Prm - ';
  if (preType === 'PERC') {
    sprVal = sprVal + parseFloat(preRate).toFixed(2) + ' % '
  } else if (preType === 'PEROZ') {
    sprVal = sprVal + parseFloat(preRate).toFixed(2) + ' /OZ '
  } else if (preType === 'PERPCS') {
    sprVal = sprVal + parseFloat(preRate).toFixed(2) + ' /PCS '
  } else if (preType === 'NA') {
    sprVal = sprVal + ' NA '
  } else {
    sprVal = sprVal + preRate
  }
  return sprVal;
}

const updateMktOrd = (msg, tradeBook) => {
  if (msg.BCM === appConstants.AVGBMK_REVERSE_REBOOK) {
    //var cmdtyDet = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
    var cmdtyDet = JSON.parse(localStorage.getItem(msg.IID));
    var orderDetails = [];
    if (tradeBook) {
      if (tradeBook.tradeBookArray !== undefined) {
        orderDetails = tradeBook.tradeBookArray;
      }
    }
    var minDec = getMinDecimal(msg.IID)
    var amntDec = getAmntDecimal(msg.IID);

    if(cmdtyDet){
        msg.D.map((item) => {
            var obj = {
                'eventTime': moment(msg.TS).format(appConstants.actTimeDateTimeFormatter),
                'deal': (parseInt(item.DT) === appConstants.TRADER_BUY
                ? "BUY"
                : "SELL"),
                'cmdtyPair': cmdtyDet.cmdty,
                'quantity': (Number(parseFloat(item.PQ)).toLocaleString('en', { minimumFractionDigits: config.QuantityRoundOff })),
                'qtyType': (item.SC ? item.SC : ""),
                'rate': (item.DR
                    ? Number(parseFloat(item.DR)).toLocaleString('en', { minimumFractionDigits: minDec, maximumFractionDigits: amntDec }) : "0"),
                'docNo': (item.DN ? item.DN : ""),
                'valDate': moment(msg.VD).format('YYYY/MM/DD') !== cmdtyDet.VD ? moment(msg.VD).format(appConstants.shortDateFormat) : 'Spot',
                'trader': msg.UCD,
                'accDescription': msg.AD,
                'comments': item.RMK,
                'cmdtyId': msg.IID
            };
            orderDetails.push(obj);
        })
    }
    tradeBook.tradeBookArray = orderDetails
    tradeBook.randomNo = Math.floor((Math.random() * 10) + 1);
    return tradeBook;
  } else {
    return tradeBook;
  }

}
// update value date whe VD is updated fron NEO
const updateVDForMktOrd = (tradeBook) =>{
  var orderDetails = [];
  if (tradeBook) {
    if (tradeBook.tradeBookArray !== undefined) {
      orderDetails = tradeBook.tradeBookArray;
    }
  }
  orderDetails = orderDetails.map((data) => {
    var item = JSON.parse(localStorage.getItem(data.cmdtyId));
     data.valDate= (data.VD !== item.VD ? moment(data.VD).format(appConstants.shortDateFormat): 'Spot')
     data.VD=moment(data.VD).format('YYYY/MM/DD')
    return data;
  })
  tradeBook.tradeBookArray=orderDetails
  tradeBook.randomNo = Math.floor((Math.random() * 100) + 1);
  return tradeBook
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.SUCCESS_DEFAULT:
      return {
        ...state
      };
    case types.FAILURE_DEFAULT:
      return {
        ...state
      };
    case types.LOAD_ACTIVITYCOMPONENT:
      return {
        ...state
      };
    case types.UPDATE_ACTIVITYCOMPONENT:
      var actLogRandomNo = Math.floor((Math.random() * 100) + 1);
      return {
        ...state,
        activityLog: actLogGenerator(action.msg, state.activityLog, state.benchMrkBook, state.invalidBmFlag, action.isFwdFlag),//// check lmt order as lmt,ord,stop order-
        actLogRandomNo: actLogRandomNo,
        ordcnfrmsg: ordcnfrmsgGenerator(action.msg, state.ordcnfrmsg),// check lmt order as lmt,ord,stop order
        dealcnfrmsg: dealCnfrmsgGenerator(action.msg, state.dealcnfrmsg),
        bmOrdcnfrmsg: bmOrdcnfrmsgGenerator(action.msg, state.bmOrdcnfrmsg),
        tradeBook: trdeBookSet(action.msg, state.tradeBook),
        swapBook: swapBookSet(action.msg, state.swapBook),
        benchMrkBook: updateBenchmarkOrder(action.msg, state.benchMrkBook, state.outstandingBm),
        benmFillObj: benchmarkfillObj(action.msg, state.benmFillObj, state.benchMrkBook),
        lmtFillModExpObj: limitFileeObj(action.msg, state.lmtFillModExpObj, state.limitOrdBook),
        limitOrdBook: setLimitOrdBook(action.msg, state.limitOrdBook),
        requestRejectModal: setRequestRejectModal(action.msg, state.requestRejectModal),
        trdCTID: updateCtid(action.msg, state.trdCTID),
      }
    case types.ADD_ACTIVITYCOMPONENT:
      return {
        ...state,
        activityLog: activityuserLoggedIn(action.msg, state.activityLog)
      }
    //update spread val
    case types.UPDATE_ORD_BMK_MRK:
      return {
        ...state,
        benchMrkBook: updateBMKMarkup(action.msg, state.benchMrkBook),
        avgBMKData: updateAvgBMKMarkup(action.msg, state.avgBMKData),
        isavgBMKDataUpdated: true
        //limitOrdBook:updateORDMarkup(action.msg, state.limitOrdBook,'markupUpdated')
      }

    case types.UPDATE_ORD_MRK:
      return {
        ...state,
        //limitOrdBook:updateORDMarkup(action.msg, state.limitOrdBook,'efpUpdated')//cmdty
      }
    //When payemnt request send/modify/cancel
    case types.UPDATE_ACTIVITYDATA:
      var actLogRandomNo = Math.floor((Math.random() * 100) + 1);
      return {
        ...state,
        activityLog: actLogGenerator(action.msg, state.activityLog, state.benchMrkBook, state.invalidBmFlag),
        payReqRejectModal: setPayRequestRejectModal(action.msg, state.payReqRejectModal),
        actLogRandomNo: actLogRandomNo,
      }
    //When Avg BMK order placed/modify/cancel
    //FD9279-AVGBMK orders. If rnr perform then do not hit api call
    case types.UPDATE_AVG_BMK:
      var actLogRandomNo = Math.floor((Math.random() * 100) + 1)
      return {
        ...state,
        // activityLog:updateRevAndRebLog(action.msg, state.activityLog),
        actLogRandomNo: actLogRandomNo,
        avgBMKData: updateAvgBMKData(action.msg, state.avgBMKData),
        tradeBook: updateMktOrd(action.msg, state.tradeBook),    //FD9279-AVGBMK orders. If rnr perform then do not hit api call
        isavgBMKDataUpdated: true
      }
    case types.RESET_IS_AVG_BMK_UPDATED:
      return {
        ...state,
        isavgBMKDataUpdated: action.flag
      }
    case types.UPDATE_ORDCNFMSG:
      localStorage.setItem('ordcnfrmsg', JSON.stringify({}));
      return {
        ...state,
        ordcnfrmsg: {}
      }
    case types.ClOSE_DEALCNFMSG:
      localStorage.setItem('dealcnfrmsg', JSON.stringify({}));
      return {
        ...state,
        dealcnfrmsg: {}
      }
    case types.ClOSE_BMKCNFMSG:
      localStorage.setItem('bmOrdcnfrmsg', JSON.stringify({}));
      return {
        ...state,
        bmOrdcnfrmsg: {}
      }
    // displaying modal popup
    case types.DISPLAY_MODAL:
      return {
        ...state,
        showModal: action.value
      }
    case types.SELECT_ORDERS_ALL:
      const newOrders = [...action.orders];
      return {
        ...state,
        selectedAllOrders: newOrders
      }
    case types.RESET_STATE:
      localStorage.setItem('ordcnfrmsg', JSON.stringify({}));
      localStorage.setItem('dealcnfrmsg', JSON.stringify({}));
      localStorage.setItem('bmOrdcnfrmsg', JSON.stringify({}));
      localStorage.setItem('activityLog', []);
      localStorage.setItem('tradeBook', JSON.stringify({}));
      localStorage.setItem('swapBook', JSON.stringify({}));
      localStorage.setItem('benchMrkBook', JSON.stringify({}));
      localStorage.setItem('limitOrdBook', JSON.stringify({}));
      localStorage.setItem('bmDate', moment());
      localStorage.setItem('bmFlag', false);
      localStorage.setItem('ocoOrdMsg', JSON.stringify({}))
      localStorage.setItem('ocoOrderPopout', false)
      return {
        ...state,
        activityLog: [],
        dealcnfrmsg: {},
        ordcnfrmsg: {},
        bmOrdcnfrmsg: {},
        tradeBook: { tradeBookArray: [], randomNo: 0 },
        swapBook: { swapBookArray: [], randomNo: 0 },
        benchMrkBook: {
          outStanBencMrkOrd: { outStanBencMrkArray: [], randomNo: 0 },
          benchMrkMap: null,
          bmCancelledOrdersRows: { bmCancelledOrdArray: [], randomNo: 0 },
          bmFillOrdersRows: { bmFillOrderArray: [], randomNo: 0 },
          bmOrderRows: [],
          randomNo: 0,
          outstandingBm: []
        },
        limitOrdBook: {
          outstandingLm: { outstandingLmArr: [], randomNo: 0 },
          limitOrdMap: null,
          lmCancellOrd: { lmCancellOrdArr: [], randomNo: 0 },
          lmFillOrd: { lmFillOrdArr: [], randomNo: 0 },
          lmExpOrd: { lmExpOrdArr: [], randomNo: 0 },
          lmtOrdersRows: [],
          randomNo: 0,
          randomNopro: 0
        },
        benmFillObj: [],
        lmtFillModExpObj: [],
        payReqRejectModal: {
          mdflag: false,
          title: "",
          msg: "",
          docNo: ""
        },
        clearNotifyFlag: false,
        notificationCount: 0
      }
    case types.CLOSE_BM_MODAL:
      return {
        ...state,
        benmFillObj: [],
        lmtFillModExpObj: []
      }

    // case types.REFRESH_PROXIMITY:
    // return {
    //   ...state,
    //   limitOrdBook:refreshProxi(state.limitOrdBook),
    // }
    case types.CLOSE_REQ_REJECTED_MODAL:
      return {
        ...state,
        requestRejectModal: closeReqRejectModal(action.requestRejectModal),
      }
    case types.GET_ALL_ORDER_DATA:
      return {
        ...state
      };
    case types.GET_ALL_ORDER_DATA_SUCCESS:
      try {
        var refreshRandomNo = Math.floor((Math.random() * 100) + 1);
        localStorage.setItem('randomNoDB', refreshRandomNo);
        var requestRejectModal = [{ mdflag: false, title: "", msg: "", CTID: "" }];
        localStorage.setItem('requestRejectModal', JSON.stringify(requestRejectModal));
        return {
          ...state,
          randomNoDB: refreshRandomNo,
          allspotTrades: getallspot(action.result.data.spotTrades, state.tradeBook),
          allSwapTrades: getallSwap(action.result.data.swapTrade, state.swapBook),
          outstandingBm: getOutstandingorderBM(action.result.data.outstandingBenchmark, state.benchMrkBook),
          outstandingLm: getOutstandingorderLMT(action.result.data.outstandingLimitOrd, state.limitOrdBook),
          suspendedOrders: getSuspendedOrders(action.result.data.outstandingLimitOrd, state.limitOrdBook),
          cancelledBm: getCancelledBM(action.result.data.cancelledBenchmarkOrd, state.benchMrkBook),
          filledLm: getFilledLMT(action.result.data.filledLimitOrd, state.limitOrdBook),
          cancelledLm: getCancelledLMT(action.result.data.cancelledLimitOrd, state.limitOrdBook),
          expiredLm: getExpiredLMT(action.result.data.expiredLimitOrd, state.limitOrdBook),
          filledBm: getFilledBM(action.result.data.filledBenchmarkOrd, state.benchMrkBook),
          LoadFlag: setRefreshFlag(),
          avgBMKData: getAvgBMKData(action.result.data.AVG)
        };
      } catch (e) {
        console.log("Exception in get all orders: ", e)
      }
      
    case types.GET_ALL_ORDER_DATA_FAILURE:
      return {
        ...state
      };
    case types.GET_BENCHMARK_ORDER_DATA_SUCCESS:
      var refreshRandomNo = Math.floor((Math.random() * 100) + 1);
      localStorage.setItem('randomNoDB', refreshRandomNo);
      var requestRejectModal = [{ mdflag: false, title: "", msg: "", CTID: "" }];
      localStorage.setItem('requestRejectModal', JSON.stringify(requestRejectModal));
      return {
        ...state,
        randomNoDB: refreshRandomNo,
        outstandingBm: getOutstandingorderBM(action.result.data.outstandingBenchmark, state.benchMrkBook),
        cancelledBm: getCancelledBM(action.result.data.cancelledBenchmarkOrd, state.benchMrkBook),
        filledBm: getFilledBM(action.result.data.filledBenchmarkOrd, state.benchMrkBook),
        //  allspotTrades: getallspot(action.result.data.spotTrades, state.tradeBook),
        LoadFlag: setRefreshFlag()
      };
    case types.GET_BENCHMARK_ORDER_DATA_FAILURE:
      return {
        ...state
      };
    case types.GET_AVG_BMK_DRILLDOWN_DATA_SUCCESS:
      return {
        ...state,
        avgBMKDrilldownData: getAvgBMKDrilldownData(action.result.data, state.avgBMKDrilldownData)
      };
    case types.GET_AVG_BMK_DRILLDOWN_DATA_FAILURE:
      return {
        ...state
      };
    case types.GET_ORDERS_CTID:
      return {
        ...state,
        ordersCTID: setOrdCTID(action.ctid, state.ordersCTID)
      };
    case types.GET_TRADE_CTID:
      if (action.order === 'undefined' || action.order === undefined) {
        action.order = false;
      } else {
        if (!action.order) {
          action.ctid = null;
          action.order = true;
          localStorage.setItem('trdCTID', null);
        } else {
          localStorage.setItem('trdCTID', action.ctid);
          action.order = false;
        }
      }
      return {
        ...state,
        trdCTID: action.ctid,
        dealFlag: action.order
      };
    case types.DEAL_FAILED_FLAG:
      if (action.order === 'undefined' || action.order === undefined) {
        action.order = action.flag;
      } else {
        if (!action.order) {
          action.order = true;
        } else {
          action.order = false;
        }
      }
      return {
        ...state,
        dealFlag: action.order
      };
    case types.BM_FAILED_FLAG:
      return {
        ...state,
        invalidBmFlag: action.flag
      };
    case types.CLEAR_NOTIFICATION_FLAG:
      return {
        ...state,
        clearNotifyFlag: action.flag
      };
    case types.SET_NOTIFICATION_COUNTER:
      return {
        ...state,
        notificationCount: action.cnt
      }
    case types.SET_LMT_ORD_FLAG:
      return {
        ...state,
        limitOrdFlag: action.flag
      }
    case types.SET_STOP_ORD_FLAG:
      return {
        ...state,
        stopOrdFlag: action.flag
      }
    case types.SET_BMK_ORD_FLAG:
      return {
        ...state,
        bmkOrdFlag: action.flag
      }
    case types.CLOSE_PAY_REQ_REJECTED_MODAL:
      return {
        ...state,
        payReqRejectModal: closePayReqRejectModal(action.reqData),
      }
    case types.UPDATE_VD:
      var randomNoVD = Math.floor((Math.random() * 100) + 1);
      return {
        ...state,
        tradeBook:updateVDForMktOrd(state.tradeBook),
        randomNoVD:randomNoVD
      }
      
    case types.LS_NOTIFICATION_CONN:
      return {
         ...state,
        subscribedObj : action.payload
    }; 

   case types.CLOSE_LS_NOTIFICATION_CONN:
      return {
       ...state,
       subscribedObj : null
    };

    default:
      return state;
  }
}

// array-store for orders with proximity update
export const ordersStore = new ArrayStore({
    key: "orderNo",
    data: workingOrders
});